{
  "general": {
    "acceptsJpgPng": "يقبل JPG و PNG - الحد الأقصى (10MB)",
    "retry": "إعادة المحاولة",
    "chooseFile": "اختر ملف",
    "orDragDrop": "أو اسحب وأفلت",
    "remove": "إزالة",
    "unsupportedFileType": "نوع الملف غير مدعوم: {{name}}",
    "change": "تغيير",
    "optional": "اختياري",
    "Save": "حفظ",
    "SaveAndAddMore": "حفظ و اضافة جديد",
    "Done": "انتهت",
    "inValid": "غير صحيح",
    "Valid": "صحيح",
    "actions": "اجراءات",
    "status": "الحالة",
    "view": "مشاهدة",
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "Comment": "تعليق",
    "select": "أختر",
    "write": "اكتب...",
    "print": "طباعة",
    "refresh": "تحديث",
    "No_Chats": "لا يوجد محادثات",
    "No_Participant": "لا يوجد اعضاء",
    "Mark_As_Open": "علامة مفتوح",
    "Move_To_Done": "تحويل الى انتهت",
    "Filter": "تصفيه",
    "Password": "كلمة السالمرورر",
    "Password_is_required": "كلمة المرور اجباري",
    "Email": "البريد الإلكتروني",
    "Email_is_required": "البريد الإلكتروني مطلوب!",
    "User_Name_is_required": "الاسم اجباري",
    "Wrong_User_Or_Password": "اسم المستخدم أو كلمة المرور غير صحيحة",
    "Company_Disabled": "انتهى اشتراككم. يرجى التواصل مع الدعم لإعادة تفعيل الحساب.",
    "Company_Disabled_Title": "الحساب معطل",
    "Company_Disabled_Back": "تسجيل الدخول بحساب آخر",
    "Contact_Support": "تواصل مع الدعم",
    "login": "تسجيل دخول",
    "Sign_In": "تسجيل دخول",
    "Send": "ارسال",
    "Cancel": "الغاء",
    "Update": "تحديث",
    "Star_Messages": "رسالة مميزة",
    "Username": "اسم مستخدة",
    "Agents": "موظف",
    "Id": "id",
    "Subject_Name": "اسم ",
    "Creation": "تاريخ الإنشاء",
    "Owner": "مدير النظام",
    "Participant": "الاعضاء",
    "close": "اغلاق",
    "Delete": "حذف",
    "confirmDeleteItem": "هل أنت متأكد من حذف هذا العنصر؟",
    "Add": "إضافة",
    "Edit": "تعديل",
    "create": "إنشاء",
    "RequiredField": "هذا الحقل مطلوب",
    "submit": "إرسال",
    "InActive": "غير نشط",
    "save-changes": "حفظ التغييرات",
    "No": "لا",
    "Yes": "نعم",
    "Active": "نشط",
    "Disable": "تعطيل",
    "Enable": "تفعيل",
    "addNew": "+ إضافة جديد",
    "Retry_Send": "اعادة الارسال",
    "statusUpdatedSuccess": "تم تحديث الحالة بنجاح",
    "statusUpdateFailed": "فشل تحديث الحالة.",
    "invalidFileType": "نوع ملف غير صحيح. يرجى اختيار ملف إكسل أو CSV.",
    "fileTooLarge": "الملف كبير جداً. الحد الأقصى للحجم هو 10 ميجابايت.",
    "fileSelected": "تم اختيار الملف بنجاح. جاري المعالجة...",
    "exportStarted": "تم بدء التصدير. ستحصل على الملف قريباً.",
    "Import": "استيراد",
    "all": "جميع",
    "selectFile": "يرجى اختيار ملف للتحميل",
    "importing": "جاري استيراد المنتجات...",
    "importingUnits": "جاري استيراد الوحدات...",
    "importSuccess": "تم رفع الملف بنجاح",
    "importUnitsSuccess": "تم استيراد الوحدات بنجاح!",
    "importError": "فشل في استيراد المنتجات. يرجى المحاولة مرة أخرى.",
    "importUnitsError": "فشل في استيراد الوحدات. يرجى المحاولة مرة أخرى.",
    "importValidationError": "تنسيق ملف غير صحيح أو بيانات غير صحيحة. يرجى التحقق من ملفك والمحاولة مرة أخرى.",
    "serverError": "حدث خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً.",
    "importingBrands": "جاري استيراد العلامات التجارية...",
    "importBrandsSuccess": "تم استيراد العلامات التجارية بنجاح!",
    "importBrandsError": "فشل في استيراد العلامات التجارية. يرجى المحاولة مرة أخرى.",
    "importingCategories": "جاري استيراد الفئات...",
    "importCategoriesSuccess": "تم استيراد الفئات بنجاح!",
    "importCategoriesError": "فشل في استيراد الفئات. يرجى المحاولة مرة أخرى.",
    "downloadingSample": "جاري تحميل ملف النموذج...",
    "sampleDownloaded": "تم تحميل ملف النموذج بنجاح!",
    "downloadError": "فشل في تحميل ملف النموذج. يرجى المحاولة مرة أخرى.",
    "enabled": "مفعل",
    "disabled": "معطل",
    "By": "بواسطة",
    "download": "تحميل",
    "latitude": "خط العرض",
    "longitude": "خط الطول",
    "selectAll": "تحديد الكل",
    "deselectAll": "إلغاء تحديد الكل",
    "updating": "جاري التحديث...",
    "back": "رجوع",
    "loading": "جاري التحميل...",
    "NoData": "لا توجد بيانات متاحة",
    "file": "ملف",
    "preview": "معاينة",
    "thankYou": "شكراً لطلبك!",
    "poweredByAwfar": "مدعوم من أوفر",
    "to": "إلى"
  },
  "loading": {
    "permissions": "جاري تحميل الصلاحيات..."
  },
  "permissions": {
    "refreshPermissions": "تحديث الصلاحيات  ",
    "refreshing": "جاري التحديث...",
    "refreshSuccess": "تم تحديث الصلاحيات بنجاح",
    "refreshError": "فشل في تحديث الصلاحيات",
    "Permissions": "الصلاحيات"
  },
  "error": {
    "noPermissions": "تعذر تحميل الصلاحيات"
  },
  "common": {
    "noPermission": "ليس لديك صلاحية للوصول إلى هذا القسم"
  },
  "header": {
    "chatbot": "الشات بوت",
    "awfar": "Awfar",
    "Bot_Chat": "المحادثات",
    "CRM": "CRM",
    "Dashboard": "Dashboard",
    "Log_out": "تسجيل الخروج",
    "searchCustomer": "ابحث عن عميل...",
    "noCustomersFound": "لم يتم العثور على عملاء",
    "darkMode": "الوضع الداكن",
    "lightMode": "الوضع الفاتح"
  },
  "sideBar": {
    "home": "الرئيسية",
    "reports": "التقارير",
    "reportsDashboard": "لوحة التحكم",
    "reportsExportLogs": "سجلات التصدير",
    "reportsCompanies": "الشركات",
    "welcome": "مرحبا بك في لوحة التحكم",
    "catalog": "الفهرس",
    "product": "المنتجات",
    "categories": "الفئات",
    "brands": "العلامات التجارية",
    "manufacturers": "الشركات المصنّعة",
    "extra": "الإضافات",
    "productAttributes": "خصائص المنتج",
    "keywords": "الكلمات المفتاحية",
    "productReviews": "تقييمات المنتجات",
    "reviewBannedWords": "كلمات التقييم المحظورة",
    "sections": "الأقسام",
    "fileManager": "إدارة الملفات",
    "failedProductImports": "فشل استيراد المنتجات",
    "orders": "الطلبات",
    "addOrder": "إضافة طلب",
    "orderList": "قائمة الطلبات",
    "activeOrders": "الطلبات النشطة",
    "orderTracking": "تتبع الطلبات",
    "activities": "الأنشطة",
    "allTickets": "جميع التذاكر",
    "activity-types": "أنواع الأنشطة",
    "activity-sections": "أقسام الأنشطة",
    "activity-reasons": "أسباب الأنشطة",
    "activity-status": "حالة الأنشطة",
    "activityPriorities": "أولويات الأنشطة ومدة الإغلاق",
    "eCommerce": "التجارة الإلكترونية",
    "slider": "الشرائح",
    "flashDeal": "عرض فوري",
    "promocode": "أكواد الخصم",
    "cancelReasons": "أسباب الإلغاء",
    "uncompletedOrderReasons": "أسباب الطلبات غير المكتملة",
    "homeStaticContent": "محتوى الصفحة الرئيسية الثابت",
    "homeLayout": "تخطيط الصفحة الرئيسية",
    "blogs": "المقالات الصحية",
    "videos": "الفيديوهات",
    "symptoms": "تسوق حسب الأعراض",
    "Setting": "الإعدادات",
    "setting": {
      "company-setting": "إعدادات الشركة",
      "all-companies": "جميع الشركات",
      "company-customizations": "تخصيصات الشركات",
      "notification-sounds": "أصوات التنبيهات",
      "payment-settings": "إعدادات الدفع",
      "customer-segmentation": "تقسيم العملاء",
      "export-reports": "تصدير التقارير",
      "email-settings": "إعدادات البريد الإلكتروني",
      "push-notifications": "إشعارات الدفع",
      "organization": "المؤسسة",
      "sms-templates": "قوالب الرسائل النصية"
    },
    "users": "المستخدمون",
    "manageCustomers": "إدارة العملاء",
    "alwaysOpen": "تثبيت القائمة",
    "configuration": "التكوين",
    "locations": "المواقع",
    "countries": "البلدان",
    "cities": "المدن",
    "areas": "المناطق",
    "regions": "الأقاليم",
    "offers": "العروض",
    "allOffers": "جميع العروض",
    "offersGroup": "مجموعات العروض",
    "logs": "السجلات",
    "failedOfferImports": "فشل استيراد العروض",
    "failedCategoryImports": "فشل استيراد الأقسام",
    "integrationMonitoring": "مراقبة التكاملات",
    "integrations": "التكاملات",
    "sms": "الرسائل النصية",
    "paymentGateway": "بوابة الدفع",
    "dmsSettings": "إعدادات DMS",
    "aiDistribution": "توزيع الذكاء الاصطناعي",
    "skills": "المهارات",
    "serviceTypes": "أنواع الخدمات",
    "tripTypes": "أنواع الرحلات",
    "shoppers": "المتسوقون",
    "shopperOrderStatus": "حالة طلب المتسوق",
    "custody": "الحراسة",
    "purchasing": "المشتريات",
    "predictProducts": "توقع المنتجات",
    "purchasingRequests": "طلبات الشراء",
    "allPurchasingRequests": "كل طلبات الشراء",
    "dmsReports": "تقارير DMS",
    "dmsDashboard": "لوحة التحكم",
    "top10Shoppers": "أفضل 10 متسوقين",
    "driverTracker": "تعقب السائق",
    "agentKpi": "مؤشرات أداء المندوب",
    "prediction": "توقع",
    "pages": "الصفحات",
    "aboutPage": "صفحة حول",
    "privacyPage": "صفحة الخصوصية",
    "termsPage": "صفحة الشروط",
    "faqPage": "صفحة الأسئلة الشائعة",
    "insurance": "التأمين",
    "insuranceCompanies": "شركات التأمين",
    "insuranceOrder": "طلب تأميني",
    "sallaOrders": "طلبات سلة",
    "sallaAllOrders": "كل الطلبات",
    "sallaPurchasedOrders": "الطلبات المشتراة",
    "shortLinks": "الروابط المختصرة",
    "suppliers": "الموردون",
    "permissions": "الصلاحيات",
    "permissionsModels": "النماذج",
    "permissionsPermissions": "الصلاحيات",
    "permissionsRoles": "الأدوار",
    "reportsRevenue": "الإيرادات",
    "reportsOrderAnalytics": "تحليلات الطلبات",
    "reportsCustomers": "العملاء",
    "reportsStoreCompare": "مقارنة الفروع",
    "reportsGrowth": "النمو",
    "reportsProducts": "المنتجات",
    "pharmacistWorkspace": "مساحة الصيدلي",
    "prescriptionStatuses": "حالات الروشتة",
    "prescriptionRejectReasons": "أسباب رفض الروشتة",
    "refunds": "المرتجعات المالية",
    "refundApprovalRules": "قواعد موافقة الاسترداد"
  },
  "permissionsPanel": {
    "title": "الصلاحيات",
    "tabs": {
      "models": "النماذج",
      "permissions": "الصلاحيات",
      "roles": "الأدوار"
    },
    "placeholder": {
      "models": "ستتوفر إدارة النماذج هنا.",
      "permissions": "ستتوفر إدارة الصلاحيات هنا.",
      "roles": "ستتوفر إدارة الأدوار هنا."
    }
  },
  "models": {
    "tableTitle": "النماذج",
    "columns": {
      "title": "العنوان"
    },
    "placeholders": {
      "title": "أدخل العنوان"
    },
    "addTitle": "إضافة نموذج",
    "editTitle": "تعديل نموذج",
    "createdSuccessfully": "تم الإنشاء بنجاح",
    "updatedSuccessfully": "تم التحديث بنجاح",
    "failedSave": "فشل الحفظ",
    "awfarOnlyTitle": "الوصول مقيد",
    "awfarOnlySubtitle": "يمكن لمستخدمي مدير أوفار فقط عرض وإدارة النماذج."
  },
  "permission": {
    "tableTitle": "الصلاحيات",
    "columns": {
      "title": "العنوان",
      "model": "النموذج",
      "status": "الحالة"
    },
    "placeholders": {
      "title": "أدخل العنوان",
      "model": "أدخل النموذج"
    },
    "addTitle": "إضافة صلاحية",
    "editTitle": "تعديل صلاحية",
    "createdSuccessfully": "تم الإنشاء بنجاح",
    "updatedSuccessfully": "تم التحديث بنجاح",
    "failedSave": "فشل الحفظ",
    "awfarOnlyTitle": "الوصول مقيد",
    "awfarOnlySubtitle": "يمكن لمستخدمي مدير أوفار فقط عرض وإدارة الصلاحيات."
  },
  "role": {
    "tableTitle": "الأدوار",
    "columns": {
      "title": "العنوان",
      "permission": "الصلاحيات"
    },
    "placeholders": {
      "title": "أدخل العنوان"
    },
    "addTitle": "إضافة دور",
    "editTitle": "تعديل دور",
    "createdSuccessfully": "تم الإنشاء بنجاح",
    "updatedSuccessfully": "تم التحديث بنجاح",
    "failedSave": "فشل الحفظ",
    "showMore": "عرض الكل",
    "active": "مفعل",
    "accessRestrictedTitle": "الوصول مقيد",
    "accessRestrictedSubtitle": "يمكن لمستخدمي مدير أوفار ومدير الشركة فقط عرض وإدارة الأدوار.",
    "permissionsModal": {
      "title": "صلاحيات الدور",
      "total": "إجمالي الصلاحيات",
      "general": "صلاحيات عامة",
      "noPermissions": "لا توجد صلاحيات مسندة لهذا الدور."
    },
    "permissionsPicker": {
      "search": "ابحث في الصلاحيات",
      "selectAll": "تحديد الكل",
      "clearAll": "إلغاء التحديد",
      "selected": "المحدد",
      "models": "النماذج",
      "noResults": "لا توجد صلاحيات",
      "general": "عام"
    },
    "permissionGroups": {
      "odoo": "أودو",
      "dms": "DMS",
      "refund": "الاسترداد"
    },
    "permissionLabels": {
      "odoo_show": "عرض بيانات أودو",
      "odoo_not_delivered_refund": "استرجاع الطلب غير المُسلَّم",
      "odoo_return_history": "سجل المرتجعات",
      "order_details_show_dms": "عرض بيانات DMS في تفاصيل الطلب",
      "manage_refund_view": "عرض عمليات الاسترداد",
      "manage_refund_show": "عرض تفاصيل الاسترداد",
      "manage_refund_create": "طلب استرداد",
      "manage_refund_approve": "الموافقة على / رفض الاسترداد",
      "manage_refund_process": "تسوية الاسترداد",
      "manage_refund_approval_rule_view": "عرض قواعد موافقة الاسترداد",
      "manage_refund_approval_rule_show": "عرض قاعدة موافقة الاسترداد",
      "manage_refund_approval_rule_create": "إضافة قواعد موافقة الاسترداد",
      "manage_refund_approval_rule_edit": "تعديل قواعد موافقة الاسترداد",
      "manage_refund_approval_rule_delete": "حذف قواعد موافقة الاسترداد"
    }
  },
  "pages": {
    "about": {
      "title": "صفحة حول",
      "contentAr": "المحتوى بالعربية",
      "contentEn": "المحتوى بالإنجليزية",
      "saveSuccess": "تم حفظ صفحة حول"
    },
    "privacy": {
      "title": "صفحة الخصوصية",
      "contentAr": "المحتوى بالعربية",
      "contentEn": "المحتوى بالإنجليزية",
      "saveSuccess": "تم حفظ صفحة الخصوصية"
    },
    "terms": {
      "title": "صفحة الشروط",
      "contentAr": "المحتوى بالعربية",
      "contentEn": "المحتوى بالإنجليزية",
      "saveSuccess": "تم حفظ صفحة الشروط"
    },
    "faq": {
      "title": "صفحة الأسئلة الشائعة",
      "contentAr": "المحتوى بالعربية",
      "contentEn": "المحتوى بالإنجليزية",
      "saveSuccess": "تم حفظ صفحة الأسئلة الشائعة"
    },
    "insurance": {
      "title": "شركات التأمين"
    }
  },
  "insuranceCoverage": {
    "title": "التغطية",
    "addCoverage": "إضافة تغطية",
    "editCoverage": "تعديل التغطية",
    "targetType": "تطبق التغطية على",
    "product": "منتج",
    "category": "تصنيف",
    "name": "الاسم",
    "barcode": "الباركود",
    "coveragePercent": "نسبة التغطية %",
    "startsAt": "تبدأ في",
    "endsAt": "تنتهي في",
    "window": "فترة التفعيل",
    "always": "دائماً",
    "activeNow": "مفعلة الآن",
    "outOfWindow": "خارج الفترة",
    "endBeforeStart": "يجب أن يكون تاريخ الانتهاء في يوم البداية أو بعده",
    "saveError": "فشل حفظ التغطية",
    "searchPlaceholder": "ابحث بالمنتج أو الباركود أو التصنيف",
    "importTitle": "استيراد التغطية",
    "uploadFile": "رفع ملف",
    "downloadSample": "تحميل نموذج الملف",
    "fileTooLarge": "الملف كبير جداً. الحد الأقصى 10 ميجابايت.",
    "importSuccess": "تم استيراد التغطية بنجاح",
    "importError": "فشل استيراد التغطية. حاول مرة أخرى.",
    "importCounts": "تمت الإضافة: {{created}}، تم التحديث: {{updated}}، تم التخطي: {{skipped}}",
    "unmatchedBarcodes": "باركود غير موجود: {{barcodes}}",
    "unmatchedCategories": "تصنيفات غير موجودة: {{categories}}",
    "importInstructions": {
      "title": "تعليمات الاستيراد",
      "target": "اكتب الباركود لمنتج أو category_id لتصنيف كامل — واحد فقط لكل صف",
      "percent": "coverage_percent مطلوب (0 – 100)",
      "dates": "starts_at / ends_at اختيارية (YYYY-MM-DD)",
      "status": "status اختياري (1 / 0، الافتراضي 1)",
      "upsert": "يتم تحديث التغطية الموجودة لنفس المنتج أو التصنيف",
      "supportedFormats": "الصيغ المدعومة"
    }
  },
  "insurance": {
    "nameEn": "الاسم بالإنجليزية",
    "nameAr": "الاسم بالعربية",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "sort": "الترتيب",
    "detailsEn": "تفاصيل (إنجليزي)",
    "detailsAr": "تفاصيل (عربي)",
    "logo": "الشعار",
    "files": "الملفات",
    "filesFor": "ملفات لـ",
    "filesNameEn": "اسم الملف (إنجليزي)",
    "filesNameAr": "اسم الملف (عربي)",
    "filesType": "النوع",
    "minFiles": "أقل عدد ملفات",
    "maxFiles": "أقصى عدد ملفات",
    "instructionAr": "تعليمات (عربي)",
    "instructionEn": "تعليمات (إنجليزي)",
    "uploadPrescription": "رفع ملف الوصفة",
    "showInstruction": "إظهار التعليمات",
    "image": "الصورة",
    "addCompany": "إضافة شركة تأمين",
    "editCompany": "تعديل شركة تأمين",
    "addFile": "إضافة ملف",
    "editFile": "تعديل ملف"
  },
  "insuranceDetails": {
    "title": "التأمين",
    "cards": "بطاقات التأمين",
    "companyFiles": "ملفات الشركة",
    "nationalId": "الرقم القومي",
    "prescriptions": "الروشتات",
    "companyProfile": "ملف الشركة",
    "approval": "الموافقة",
    "company": "شركة التأمين",
    "selectCompany": "اختر شركة التأمين",
    "attachmentType": "نوع المرفق",
    "prescription": "روشتة",
    "nationalIdOption": "الرقم القومي",
    "uploadPrescriptionHint": "اضغط لرفع صور الروشتة (يمكن رفع أكثر من صورة).",
    "uploadNationalIdHint": "اضغط لرفع صور الرقم القومي (يمكن رفع أكثر من صورة).",
    "saveAttachments": "حفظ المرفقات",
    "saveSuccess": "تم تحديث بيانات التأمين بنجاح",
    "saveFailed": "فشل تحديث بيانات التأمين",
    "companyRequired": "يرجى اختيار شركة التأمين",
    "editLocked": "لم يعد بإمكانك تعديل هذا الطلب",
    "metaError": "تعذر تحميل شركات التأمين"
  },
  "insuranceOrder": {
    "title": "طلب تأميني",
    "metaErrorTitle": "تعذر تحميل نموذج الطلب",
    "metaError": "تعذر تحميل المتاجر وشركات التأمين. برجاء المحاولة مرة أخرى.",
    "allOrders": "كل الطلبات",
    "selectStore": "اختر المتجر",
    "selectCustomer": "اختر العميل",
    "searchCustomer": "ابحث عن عميل...",
    "insuranceCompany": "شركة التأمين",
    "selectCompany": "اختر شركة التأمين",
    "insuranceProfile": "بوليصة التأمين",
    "noProfile": "بدون بوليصة",
    "profileAutoCreate": "سيتم إنشاء بوليصة تلقائياً عند رفع الروشتة",
    "prescription": "الروشتة / الوصفة الطبية",
    "optional": "(اختياري)",
    "upload": "رفع",
    "uploadFailed": "فشل رفع صور الروشتة",
    "comment": "ملاحظات",
    "commentPlaceholder": "أي ملاحظات إضافية...",
    "addProducts": "إضافة منتجات",
    "searchProduct": "ابحث عن منتج...",
    "cart": "المنتجات المختارة",
    "clear": "مسح",
    "confirmClear": "هل تريد مسح كل المنتجات؟",
    "emptyCart": "لا يوجد منتجات بعد",
    "total": "الإجمالي",
    "submit": "تأكيد الطلب",
    "orderCreated": "تم إنشاء الطلب بنجاح!",
    "orderNumber": "رقم الطلب ",
    "viewOrder": "عرض الطلب",
    "newOrder": "طلب جديد",
    "error": "حدث خطأ ما",
    "uploadPartial": "فشل رفع {{failed}} ملف/ملفات؛ سيتم المتابعة بالباقي."
  },
  "shortLinks": {
    "title": "الروابط المختصرة",
    "name": "الاسم",
    "web": "رابط الويب",
    "android": "رابط أندرويد",
    "ios": "رابط iOS",
    "hash": "التجزئة",
    "visitCounts": "عدد الزيارات",
    "uniqueVisitCounts": "عدد الزيارات الفريدة",
    "showResult": "عرض النتيجة",
    "visitors": "الزوار",
    "ipAddress": "عنوان IP",
    "userAgent": "وكيل المستخدم",
    "country": "الدولة",
    "region": "المنطقة",
    "city": "المدينة",
    "method": "الطريقة",
    "parameter": "المعامل",
    "countryName": "اسم الدولة",
    "countryCode": "رمز الدولة",
    "regionCode": "رمز المنطقة",
    "regionName": "اسم المنطقة",
    "cityName": "اسم المدينة",
    "latitude": "خط العرض",
    "longitude": "خط الطول",
    "timezone": "المنطقة الزمنية",
    "referer": "المرجع",
    "deviceType": "نوع الجهاز",
    "platform": "المنصة",
    "browser": "المتصفح",
    "visitedAt": "تاريخ الزيارة",
    "addShortLink": "إضافة رابط مختصر",
    "editShortLink": "تعديل رابط مختصر"
  },
  "sms": {
    "smsTypeManagement": "إدارة أنواع الرسائل النصية",
    "smsTypeManagementDescription": "إنشاء وإدارة أنواع مختلفة من خدمات الرسائل النصية مع شعاراتها وإعداداتها.",
    "createNewSmsType": "إنشاء نوع رسالة نصية جديد",
    "editSmsType": "تعديل نوع الرسالة النصية",
    "smsTypeName": "اسم نوع الرسالة النصية",
    "smsTypeNameRequired": "اسم نوع الرسالة النصية مطلوب",
    "smsTypeNameMinLength": "يجب أن يكون الاسم حرفين على الأقل",
    "smsTypeNameMaxLength": "يجب ألا يتجاوز الاسم 50 حرف",
    "smsServiceLogo": "شعار خدمة الرسائل النصية",
    "uploadLogo": "رفع الشعار",
    "dataOfIntegration": "بيانات تكامل {{name}}",
    "editCredentials": "تعديل بيانات الاعتماد",
    "setCredentials": "تعيين بيانات الاعتماد",
    "credentialsFeature": "ميزة إعداد بيانات الاعتماد قريباً",
    "smsTypeCreated": "تم إنشاء نوع الرسالة النصية بنجاح",
    "smsTypeCreateError": "فشل في إنشاء نوع الرسالة النصية",
    "smsTypeUpdated": "تم تحديث نوع الرسالة النصية بنجاح",
    "smsTypeUpdateError": "فشل في تحديث نوع الرسالة النصية",
    "smsTypeDeleted": "تم حذف نوع الرسالة النصية بنجاح",
    "smsTypeDeleteError": "فشل في حذف نوع الرسالة النصية",
    "deleteConfirm": "هل أنت متأكد من أنك تريد حذف نوع الرسالة النصية هذا؟",
    "noSmsTypes": "لم يتم العثور على أنواع رسائل نصية",
    "createFirstSmsType": "أنشئ نوع الرسالة النصية الأول",
    "status": "الحالة",
    "active": "فعال",
    "inactive": "غير فعال",
    "overview": "نظرة عامة",
    "smsTypes": "أنواع الرسائل النصية",
    "overviewDescription": "إدارة إعدادات تكامل الرسائل النصية وإرسال الرسائل للعملاء.",
    "smsConfiguration": "إعداد الرسائل النصية",
    "configure": "إعداد",
    "smsConfigurationDescription": "إعداد بيانات اعتماد مزود الرسائل النصية وإعدادات API.",
    "sendSms": "إرسال رسالة نصية",
    "sendMessage": "إرسال رسالة",
    "sendSmsDescription": "إرسال رسائل نصية للعملاء الأفراد أو المجموعات.",
    "smsTemplates": "قوالب الرسائل النصية",
    "manageTemplates": "إدارة القوالب",
    "smsTemplatesDescription": "إنشاء وإدارة قوالب الرسائل النصية.",
    "recentActivity": "نشاط الرسائل النصية الأخير",
    "noRecentActivity": "لا يوجد نشاط رسائل نصية حديث للعرض.",
    "updateSmsIntegration": "تحديث تكامل الرسائل النصية",
    "smsType": "نوع الرسالة النصية",
    "selectSmsType": "اختر نوع الرسالة النصية",
    "sender": "المرسل",
    "senderRequired": "المرسل مطلوب",
    "language": "اللغة",
    "languageRequired": "اللغة مطلوبة",
    "activation": "التفعيل",
    "credentialsUpdated": "تم تحديث بيانات الاعتماد بنجاح",
    "credentialsUpdateError": "فشل في تحديث بيانات الاعتماد"
  },
  "fileManager": {
    "title": "مدير الملفات",
    "cloudStorage": "جوجل كلاود ستوريج",
    "dragDropText": "اسحب وأفلت الملفات هنا، أو انقر لاختيار الملفات",
    "dropFiles": "أفلت الملفات هنا...",
    "supportedFormats": "يدعم: الصور، المستندات، ملفات PDF، الأرشيف (الحد الأقصى: 100 ميجابايت لكل ملف)",
    "uploading": "جاري الرفع...",
    "uploadingFiles": "جاري رفع الملفات",
    "uploadedFiles": "ملفات التخزين السحابي",
    "noFiles": "لا توجد ملفات في التخزين السحابي بعد",
    "noSearchResults": "لم يتم العثور على ملفات تطابق البحث",
    "cloudStored": "سحابي",
    "loading": "جاري تحميل الملفات من التخزين السحابي...",
    "loadError": "فشل تحميل الملفات من التخزين السحابي",
    "uploadSuccess": "تم الرفع بنجاح",
    "uploadError": "فشل في رفع الملف",
    "firebasePermissionError": "فشل الرفع: أذونات Firebase Storage غير مُعدة. يرجى الاتصال بالمسؤول لإعداد أذونات Firebase Storage.",
    "permissionDenied": "فشل الرفع: تم رفض الإذن. يرجى التحقق من أذونات التخزين الخاصة بك.",
    "downloadSuccess": "بدأ تحميل الملف",
    "downloadError": "فشل في تحميل الملف",
    "selectMode": "تحديد الملفات",
    "exitSelection": "إنهاء التحديد",
    "selectAll": "تحديد الكل",
    "selectedCount": "{{count}} محدد",
    "clearSelection": "إلغاء التحديد",
    "downloadSelected": "تحميل المحدد ({{count}})",
    "downloadFolder": "تحميل المجلد كملف مضغوط",
    "archiveDownloadStarted": "بدأ تحميل الملف المضغوط",
    "archiveDownloadError": "فشل في تحميل الملفات المحددة",
    "folderDownloadError": "فشل في تحميل هذا المجلد",
    "deleteConfirm": "هل أنت متأكد من حذف هذا الملف؟",
    "deleteWarning": "لا يمكن التراجع عن هذا الإجراء. سيتم حذف الملف نهائياً من التخزين السحابي.",
    "deleteSuccess": "تم حذف الملف بنجاح",
    "deleteError": "فشل في حذف الملف",
    "textPreview": "معاينة الملف النصي غير متاحة. يرجى التحميل لعرض المحتوى.",
    "previewNotSupported": "المعاينة غير مدعومة لهذا النوع من الملفات",
    "searchPlaceholder": "البحث عن الملفات بالاسم أو النوع أو المسار...",
    "tipsTitle": "نصائح مدير الملفات",
    "folderSelectionTitle": "📁 اختيار المجلد:",
    "folderSelectionTip1": "اضغط مع Ctrl/Cmd + انقر على أي مجلد لاختياره كوجهة للرفع",
    "folderSelectionTip2": "النقر العادي يوسع/يطوي المجلدات",
    "folderSelectionTip3": "سيتم تمييز المجلد المحدد باللون الأزرق",
    "folderSelectionTip4": "سيتم رفع الملفات إلى المجلد المحدد",
    "folderUploadTitle": "🗂️ رفع المجلد:",
    "folderUploadTip1": "انقر على زر \"رفع مجلد\" لرفع مجلدات كاملة",
    "folderUploadTip2": "يحافظ على هيكل المجلد الأصلي",
    "folderUploadTip3": "سيتم الاحتفاظ بجميع المجلدات الفرعية والملفات",
    "smartUploadTitle": "🎯 الرفع الذكي:",
    "smartUploadTip1": "بدون اختيار مجلد: الملفات تصنف تلقائياً حسب النوع",
    "smartUploadTip2": "مع اختيار مجلد: الملفات تذهب إلى المجلد المحدد",
    "smartUploadTip3": "اسحب مباشرة على المجلدات في عرض الشجرة",
    "catalogFoldersTitle": "🖼️ مجلدات صور الكتالوج:",
    "catalogFoldersNote": "لاستخدام الصور في الكتالوج، يجب أن يطابق اسم المجلد أحد الأسماء التالية تمامًا:",
    "catalogFoldersDetail": "استخدم هذه الأسماء بحروف صغيرة تمامًا. صيغ الجمع أو أي اختلافات أخرى (مثل \"products\") لن يتم ربطها، وستظهر الصور معطلة في الكتالوج.",
    "tips": "نصائح",
    "treeView": "عرض الشجرة",
    "listView": "عرض القائمة",
    "clearSearch": "مسح البحث",
    "uploadFilesTitle": "📁 رفع الملفات والمجلدات",
    "selectFiles": "اختيار الملفات",
    "uploadFolder": "رفع مجلد",
    "uploadTo": "رفع إلى:",
    "clear": "مسح",
    "clickToExpand": "انقر للتوسيع/الطي، Ctrl+انقر لاختيار كوجهة للرفع",
    "selectedFolder": "📁 تم اختيار المجلد: \"{folderPath}\" للرفع",
    "selectedVirtualFolder": "✨ تم اختيار المجلد الافتراضي: \"{folderPath}\" للرفع. سيصبح هذا المجلد دائمًا عند رفع الملفات إليه.",
    "imageTag": "📷 صورة",
    "company": "الشركة:",
    "user": "المستخدم",
    "uploadTargetReset": "تم إعادة تعيين وجهة الرفع للتصنيف التلقائي",
    "switchedToCompany": "تم التبديل إلى الشركة {companyId} (تغيير يدوي)",
    "switchBackToUser": "↻ استخدم {companyId}",
    "switchedBackToUser": "تم التبديل إلى شركة المستخدم {companyId}",
    "filesText": "ملفات",
    "of": "من",
    "connectionActive": "اتصال مباشر مع جوجل كلاود ستوريج نشط!",
    "bucketAccessRestricted": "الوصول إلى مجموعة التخزين السحابي مقيد. استخدام الوضع التجريبي.",
    "gcsNotAccessible": "التخزين السحابي غير متاح ({{status}}). استخدام الوضع التجريبي.",
    "gcsNotAvailable": "التخزين السحابي غير متاح. استخدام الوضع التجريبي مع التخزين المحلي.",
    "noCompanyId": "لم يتم العثور على معرف الشركة. يرجى تعيين معرف الشركة لاستخدام مدير الملفات.",
    "createFolder": "إنشاء مجلد",
    "folderNameRequired": "اسم المجلد مطلوب",
    "folderCreated": "تم إنشاء المجلد بنجاح",
    "folderCreateError": "فشل في إنشاء المجلد",
    "parentFolder": "المجلد الأب",
    "rootFolder": "الجذر",
    "folderNamePlaceholder": "أدخل اسم المجلد...",
    "rename": "إعادة تسمية",
    "file": "ملف",
    "folder": "مجلد",
    "nameRequired": "الاسم مطلوب",
    "renameSuccess": "تمت إعادة التسمية بنجاح",
    "renameError": "فشل في إعادة التسمية",
    "currentName": "الاسم الحالي",
    "newNamePlaceholder": "أدخل الاسم الجديد...",
    "deleteFolderConfirm": "هل أنت متأكد من حذف هذا المجلد؟",
    "deleteFolderWarning": "لا يمكن التراجع عن هذا الإجراء. سيتم حذف المجلد وجميع محتوياته نهائياً من التخزين السحابي.",
    "uploadBatchSummary": "تم رفع {{uploaded}} ملف بنجاح. فشل {{failed}} ملف.",
    "uploadBatchFailure": "فشل رفع {{failed}} ملف. أول خطأ: {{message}}",
    "uploadSessionFailed": "فشلت جلسة الرفع قبل الاكتمال. يرجى المحاولة مرة أخرى.",
    "uploadQueueSummary": "{{active}} نشط، {{failed}} فشل، {{total}} إجمالي",
    "uploadQueueMore": "+{{count}} ملفات إضافية في قائمة الانتظار"
  },
  "attribute": {
    "title": "الخصائص",
    "id": "المعرف",
    "englishName": "الاسم بالإنجليزية",
    "arabicName": "الاسم بالعربية",
    "status": "الحالة",
    "type": "النوع",
    "write": "اكتب...",
    "active": "فعال",
    "inactive": "غير فعال",
    "edit": "تعديل الخاصية",
    "add": "خاصية جديدة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء خصائص المنتج",
    "searchPlaceholder": "ابحث بالاسم أو المعرف",
    "createOptions": {
      "title": "إضافة خاصية منتج جديدة",
      "subtitle": "أضف خصائص المنتج بسهولة في خطوات بسيطة",
      "description": "يمكنك إضافة الخصائص واحدة تلو الأخرى أو رفع عدة خصائص باستخدام ملف Excel",
      "typeHint": "عمود النوع: {{mapping}}",
      "uploadGroup": {
        "title": "رفع مجموعة من الخصائص",
        "description": "رفع جميع الخصائص بسهولة باستخدام ملف Excel"
      },
      "addSingle": {
        "title": "إضافة خاصية واحدة",
        "description": "أضف خاصية واحدة بسهولة واحدة تلو الأخرى"
      },
      "downloadSample": "تحميل ملف نموذجي"
    },
    "importSuccess": "تم استيراد الخصائص بنجاح!",
    "importError": "فشل في استيراد الخصائص. يرجى المحاولة مرة أخرى.",
    "savedSuccessfully": "تم حفظ الخصائص بنجاح",
    "failedSave": "فشل حفظ الخصائص",
    "updatedSuccessfully": "تم تحديث الخصائص بنجاح",
    "failedUpdate": "فشل تحديث الخصائص",
    "required": "هذا الحقل مطلوب"
  },
  "sectionList": {
    "tableTitle": "جميع الأقسام",
    "modalTitle": "نافذة القسم",
    "addSection": "إضافة قسم",
    "editSection": "تعديل قسم",
    "columns": {
      "nameEn": "الاسم (إنجليزي)",
      "nameAr": "الاسم (عربي)"
    },
    "save": "حفظ",
    "cancel": "إلغاء",
    "sort": "ترتيب الفرز",
    "products": "المنتجات",
    "writeNameEn": "اكتب الاسم بالإنجليزية...",
    "writeNameAr": "اكتب الاسم بالعربية...",
    "selectProducts": "اختر المنتجات...",
    "enterSortNumber": "أدخل رقم الترتيب...",
    "imageEn": "الصورة الإنجليزية",
    "imageAr": "الصورة العربية",
    "hideFromStores": "إخفاء من المتاجر",
    "selectStores": "اختر المتاجر للإخفاء منها...",
    "required": "هذا الحقل مطلوب",
    "status": "الحالة",
    "enable": "تفعيل",
    "disable": "إلغاء التفعيل",
    "createdSuccessfully": "تم إنشاء القسم بنجاح",
    "updatedSuccessfully": "تم تحديث القسم بنجاح",
    "failedSave": "فشل في حفظ القسم",
    "write": "اكتب..."
  },
  "attributeTypeOptions": {
    "colorSelect": "اختيار اللون",
    "select": "اختيار",
    "text": "نص",
    "number": "رقم",
    "date": "تاريخ"
  },
  "extrasList": {
    "tableTitle": "جميع الإضافات",
    "addExtra": "إضافة إضافة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء إضافات",
    "createOptions": {
      "title": "إضافة إضافة جديدة",
      "subtitle": "أضف إضافاتك بسهولة في خطوات بسيطة",
      "description": "يمكنك إضافة الإضافات واحدة تلو الأخرى أو رفع عدة إضافات باستخدام ملف Excel",
      "uploadGroup": {
        "title": "رفع مجموعة من الإضافات",
        "description": "رفع جميع الإضافات بسهولة باستخدام ملف Excel"
      },
      "addSingle": {
        "title": "إضافة إضافة واحدة",
        "description": "أضف إضافة واحدة بسهولة واحدة تلو الأخرى"
      },
      "downloadSample": "تحميل ملف نموذجي"
    },
    "importSuccess": "تم استيراد الإضافات بنجاح!",
    "importError": "فشل في استيراد الإضافات. يرجى المحاولة مرة أخرى.",
    "columns": {
      "nameEn": "الاسم (إنجليزي)",
      "nameAr": "الاسم (عربي)",
      "enterNameEn": "أدخل الاسم بالإنجليزية",
      "enterNameAr": "أدخل الاسم بالعربية",
      "price": "السعر",
      "enterPrice": "أدخل السعر",
      "actions": "الإجراءات",
      "savedSuccessfully": "تم حفظ الإضافة بنجاح",
      "updatedSuccessfully": "تم تحديث الإضافة بنجاح",
      "failedSave": "فشل في حفظ الإضافة",
      "failedUpdate": "فشل في تحديث الإضافة"
    },
    "editExtra": "تعديل الإضافة"
  },
  "setting": {
    "Restart": "اعادة الاتصال",
    "sync_chats": "مزامنة",
    "Unlink_Device": "إلغاء ربط الجهاز",
    "Status": "حالة الاتصال"
  },
  "callChannel": {
    "tableTitle": "اتصال القنوات",
    "id": "المعرف",
    "arabicName": "الاسم العربي",
    "englishName": "الاسم الإنجليزي",
    "actions": "الإجراءات",
    "activation": "التفعيل",
    "callChannel": "اتصال القناة",
    "savedSuccessfully": "تم حفظ قناة الاتصال بنجاح",
    "failedSave": "فشل في حفظ القناة",
    "editCallChannel": "تعديل قناة الاتصال",
    "addCallChannel": "إضافة قناة اتصال",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء قنوات الاتصال",
    "noEditPermission": "ليس لديك صلاحية لتعديل قنوات الاتصال",
    "noDeletePermission": "ليس لديك صلاحية لحذف قنوات الاتصال"
  },
  "apiKeys": {
    "tableTitle": "مفاتيح API",
    "addApiKey": "إضافة مفتاح API",
    "editApiKey": "تعديل مفتاح API",
    "id": "المعرف",
    "name": "الاسم",
    "selectName": "اختر نوع المفتاح",
    "value": "القيمة",
    "actions": "الإجراءات",
    "activation": "التفعيل",
    "confirmDelete": "حذف مفتاح API هذا؟",
    "savedSuccessfully": "تم حفظ مفتاح API بنجاح",
    "deletedSuccessfully": "تم حذف مفتاح API بنجاح",
    "failedSave": "فشل في حفظ مفتاح API",
    "failedDelete": "فشل في حذف مفتاح API"
  },
  "orderStatus": {
    "tableTitle": "حالات الطلب",
    "id": "المعرف",
    "arabicName": "الاسم العربي",
    "englishName": "الاسم الإنجليزي",
    "actions": "الإجراءات",
    "activation": "التفعيل",
    "orderStatus": "حالة الطلب",
    "savedSuccessfully": "تم حفظ حالة الطلب بنجاح",
    "failedSave": "فشل حفظ حالة الطلب",
    "OrderStarted": "تم بدء الطلب",
    "SendToCollector": "إرسال إلى المجمّع",
    "SendToDriver": "إرسال إلى السائق",
    "OrderFinished": "تم إنهاء الطلب",
    "OrderCanceled": "تم إلغاء الطلب",
    "CanCancel": "يمكن الإلغاء",
    "CanEdit": "يمكن التعديل",
    "CanReorder": "يمكن إعادة الطلب",
    "CanReturn": "يمكن الإرجاع",
    "CanRefund": "يمكن استرداد المبلغ",
    "WithDriver": "مع السائق",
    "WithCollector": "مع المجمّع",
    "OrderModified": "تم تعديل الطلب",
    "Status": "الحالة",
    "Background": "الخلفية",
    "OrderType": "نوع الطلب",
    "StatusGroup": "مجموعة الحالة",
    "Sort": "ترتيب",
    "Delivery": "التوصيل",
    "Pickup": "الاستلام",
    "Both": "كلاهما",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء حالة الطلب",
    "noEditPermission": "ليس لديك صلاحية لتعديل حالة الطلب",
    "noDeletePermission": "ليس لديك صلاحية لحذف حالة الطلب"
  },
  "loyaltySettings": {
    "hasLoyalty": "تفعيل الولاء",
    "loyaltyFrom": "المصدر للنقاط",
    "cashToPoint": "النقد إلى نقاط",
    "pointToCash": "النقاط إلى نقد",
    "expiredAfter": "تنتهي الصلاحية بعد (أيام)",
    "expireNotificationTime": "وقت إشعار انتهاء الصلاحية",
    "expireNotificationTimeInfo": "إرسال إشعار للعميل قبل انتهاء صلاحية النقاط (الوقت بالأيام).",
    "expireNotificationTimePlaceholder": "مثال: 3",
    "days": "أيام",
    "usePercentage": "نسبة الاستخدام",
    "savedSuccessfully": "تم حفظ إعدادات الولاء بنجاح",
    "failedSave": "فشل في حفظ إعدادات الولاء",
    "notificationApiPending": "سيتم إضافة ربط واجهة برمجة التطبيق للإشعارات لاحقًا.",
    "notificationTitle": "عنوان الإشعار (إنجليزي / عربي)",
    "notificationsTitle": "إشعارات الولاء",
    "notificationsSubTitle": "إدارة وجدولة تنبيهات العملاء ثنائية اللغة.",
    "createNotification": "إنشاء إشعار",
    "generalDetails": "التفاصيل العامة",
    "titleEnglish": "العنوان (بالإنجليزية)",
    "titleEnglishPlaceholder": "أدخل العنوان بالإنجليزية",
    "titleArabic": "العنوان (بالعربية)",
    "titleArabicPlaceholder": "أدخل العنوان بالعربية",
    "bodyEnglish": "محتوى الرسالة (بالإنجليزية)",
    "bodyEnglishPlaceholder": "اكتب رسالتك...",
    "bodyArabic": "محتوى الرسالة (بالعربية)",
    "bodyArabicPlaceholder": "اكتب رسالتك هنا...",
    "notificationBanner": "بانر الإشعار",
    "bannerHint": "انقر أو اسحب الصورة للرفع (الموصى به 1200x600)",
    "saveNotification": "حفظ الإشعار",
    "activeNotifications": "الإشعارات النشطة",
    "sendVia": "الإرسال عبر",
    "sendViaNotification": "إشعار",
    "sendViaSms": "رسالة نصية",
    "sendViaBoth": "إشعار ورسالة نصية",
    "orderTotal": "إجمالي الطلب",
    "productPoints": "نقاط المنتج"
  },
  "store": {
    "fixedPriceOption": "خيار السعر الثابت",
    "Fixed fees after X kilo": "رسوم ثابتة بعد X كيلو",
    "AddStore": "إضافة متجر",
    "EditStore": "تعديل المتجر",
    "DeleteStore": "حذف المتجر",
    "StoreList": "قائمة المتاجر",
    "StoreDetails": "تفاصيل المتجر",
    "StoreName": "اسم المتجر",
    "StoreDescription": "وصف المتجر",
    "StoreImage": "صورة المتجر",
    "status": "الحالة",
    "createdAt": "تاريخ الإنشاء",
    "updatedAt": "تاريخ التحديث",
    "savedSuccessfully": "تم حفظ المتجر بنجاح",
    "updatedSuccessfully": "تم تحديث المتجر بنجاح",
    "deletedSuccessfully": "تم حذف المتجر بنجاح",
    "failedSave": "فشل في حفظ المتجر",
    "failedUpdate": "فشل في تحديث المتجر",
    "failedDelete": "فشل في حذف المتجر",
    "confirmDelete": "هل أنت متأكد أنك تريد حذف هذا المتجر؟",
    "noStoresFound": "لم يتم العثور على متاجر",
    "StoreContent": "محتوى المتجر",
    "phone": "الهاتف",
    "phone2": "هاتف بديل",
    "storePhoneForShopper": "هاتف المتجر للمشتري",
    "emails": "البريد الإلكتروني",
    "sendEmail": "إرسال البريد الإلكتروني",
    "reportMail": "بريد التقارير",
    "activityEmails": "رسائل النشاط",
    "activity_cc_emails": "رسائل النشاط CC",
    "inquiry_emails": "رسائل الاستفسارات",
    "inquiry_cc_emails": "رسائل الاستفسارات CC",
    "compliant_emails": "رسائل الشكاوى",
    "compliant_cc_emails": "رسائل الشكاوى CC",
    "MainData": "البيانات الأساسية",
    "nameEn": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "IsMainStore": "هل هذا هو المتجر الرئيسي؟",
    "storeType": "نوع المتجر",
    "Branch": "الفرع",
    "slugEn": "الاسم القصير (بالإنجليزية)",
    "slugAr": "الاسم القصير (بالعربية)",
    "internalId": "المعرف الداخلي",
    "odooDeliveryFeesId": "معرف رسوم التوصيل في أودو",
    "url": "الرابط",
    "enLogo": "شعار (إنجليزي)",
    "arLogo": "شعار (عربي)",
    "enImage": "صورة (إنجليزي)",
    "arImage": "صورة (عربي)",
    "DeliveryLocation": "موقع التسليم",
    "areaStock": "المخزون في المنطقة",
    "mapColor": "لون الخريطة",
    "latitude": "خط العرض",
    "longitude": "خط الطول",
    "kilometer": "كيلومتر",
    "feesByKilo": "الرسوم لكل كيلو",
    "shippingFees": "رسوم الشحن",
    "fixedPrice": "السعر الثابت",
    "deliveryFeesPricingOption": "خيارات تسعير رسوم التوصيل",
    "fixedFeesAfterXKilo": "رسوم ثابتة بعد X كيلو",
    "Pharmacy": "صيدلية",
    "Grocery": "بقالة",
    "select_working_days": "اختر أيام وساعات العمل للاستلام",
    "select_all_days": "اختر كل الأيام",
    "select_all_times": "اختر كل الأوقات",
    "deliveryType": "نوع التوصيل",
    "PickUp": "الاستلام",
    "Delivery": "التوصيل",
    "Both": "كلاهمامه",
    "sat": "السبت",
    "sun": "الأحد",
    "mon": "الاثنين",
    "tue": "الثلاثاء",
    "wed": "الأربعاء",
    "thu": "الخميس",
    "fri": "الجمعة",
    "From": "من",
    "To": "إلى",
    "AM": "ص",
    "PM": "م",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المتاجر",
    "noEditPermission": "ليس لديك صلاحية لتعديل المتاجر",
    "noDeletePermission": "ليس لديك صلاحية لحذف المتاجر"
  },
  "TableEditDelete": {
    "msgDeleteSuccess": "تم الحذف بنجاح",
    "msgDeleteFailed": "فشل في الحذف",
    "msgRestoreSuccess": "تمت الاستعادة بنجاح",
    "msgRestoreFailed": "فشلت الاستعادة",
    "edit": "تعديل",
    "delete": "حذف",
    "restore": "إستعادة",
    "deleteConfirm": "هل أنت متأكد أنك تريد الحذف؟",
    "resotreConfirm": "هل أنت متأكد أنك تريد الإستعادة؟",
    "ok": "نعم",
    "no": "لا",
    "noPermission": "ليس لديك صلاحية لتنفيذ هذا الإجراء",
    "noEditPermission": "ليس لديك صلاحية للتعديل",
    "noDeletePermission": "ليس لديك صلاحية للحذف"
  },
  "bulkActions": {
    "selectedCount": "{{count}} محدد",
    "clearSelection": "إلغاء التحديد",
    "deleteSelected": "حذف المحدد",
    "deleteConfirm": "هل أنت متأكد أنك تريد حذف {{count}} من العناصر المحددة؟",
    "deleteSuccess": "تم حذف العناصر المحددة بنجاح",
    "deletePartial": "تم حذف {{deleted}} عنصر، وتعذر حذف {{failed}}",
    "deleteFailed": "فشل حذف العناصر المحددة",
    "categoryLinkedWarning": "{{count}} من الفئات المحددة لا تزال تحتوي على فئات فرعية أو منتجات مرتبطة بها."
  },
  "activityTypes": {
    "tableTitle": "جميع الأنواع",
    "addActivityTypes": "إنشاء نوع جديد",
    "editActivityTypes": "تعديل النوع",
    "failedSave": "فشل في حفظ نوع النشاط",
    "savedSuccessfully": "تم حفظ أنواع الأنشطة بنجاح",
    "fields": {
      "forProduct": "للمنتج",
      "main_type": "النوع الرئيسي",
      "cc": "نسخة كربونية"
    },
    "noCreatePermission": "ليس لديك صلاحية لإنشاء أنواع الأنشطة"
  },
  "activityPriority": {
    "tab": "الأولويات ومدة الإغلاق",
    "tableTitle": "أولويات التذاكر",
    "add": "إضافة أولوية جديدة",
    "edit": "تعديل الأولوية",
    "savedSuccessfully": "تم حفظ الأولوية بنجاح",
    "failedSave": "فشل حفظ الأولوية",
    "noCreatePermission": "ليس لديك صلاحية لإضافة أولويات",
    "fields": {
      "name": "الأولوية",
      "arabicName": "الاسم بالعربية",
      "englishName": "الاسم بالإنجليزية",
      "slaHours": "مدة الإغلاق (بالساعات)",
      "slaDays": "≈ {{days}} يوم",
      "warningPercent": "التنبيه عند (% من مدة الإغلاق)",
      "warningPercentHint": "يتم تنبيه الفريق بعد مرور هذه النسبة من مدة الإغلاق إذا كانت التذكرة لا تزال مفتوحة.",
      "isDefault": "افتراضية للتذاكر الجديدة",
      "isDefaultHint": "التذاكر التي تُنشأ بدون أولوية تأخذ هذه الأولوية، ويبدأ احتساب مدة الإغلاق فورًا.",
      "notifyUsers": "المستخدمون المطلوب تنبيههم",
      "notifyUsersHint": "يتم تنبيههم بالإضافة إلى موظف التذكرة عند اقتراب أو تجاوز مدة الإغلاق.",
      "color": "لون الأولوية",
      "sort": "الترتيب",
      "ticketHint": "اختياري. اختيار الأولوية يملأ مدة الإغلاق الخاصة بها.",
      "changeHint": "تغيير الأولوية يحتفظ بوقت البداية الأصلي، ويُعاد حساب موعد الإغلاق فقط.",
      "noClosingTimeHint": "0 = لا تُغلق التذاكر: لا يوجد تنبيه ولا إغلاق تلقائي.",
      "ticketSlaHours": "مدة الإغلاق (ساعات)",
      "ticketSlaHoursHint": "اختياري، مع أولوية أو بدونها. اختيار الأولوية يملؤها ويمكنك تغييرها. 0 = لا تُغلق التذكرة.",
      "ticketSlaHoursEditHint": "تغييرها يعيد حساب موعد الإغلاق والتنبيه من وقت البدء الأصلي. 0 = لا تُغلق التذكرة."
    },
    "sla": {
      "title": "مدة الإغلاق",
      "on_track": "في الموعد",
      "at_risk": "قارب على الانتهاء",
      "breached": "متأخرة",
      "met": "أُغلقت في الموعد",
      "missed": "أُغلقت متأخرة",
      "none": "بدون أولوية",
      "left": "متبقي {{time}}",
      "overdueBy": "متأخرة {{time}}",
      "dueAt": "موعد الإغلاق",
      "closedAt": "تاريخ الإغلاق",
      "no_limit": "بدون مدة إغلاق",
      "auto_closed": "أُغلقت تلقائياً"
    }
  },
  "activityStatus": {
    "noColor": "بدون لون",
    "Types": "الأنواع",
    "Sections": "الأقسام",
    "Reasons": "الأسباب",
    "Status": "الحالة",
    "editActivityStatus": "تعديل حالة النشاط",
    "addActivityStatus": "إضافة حالة النشاط",
    "savedSuccessfully": "تم حفظ حالة النشاط بنجاح",
    "failedSave": "فشل في حفظ حالة النشاط",
    "status": {
      "tableTitle": "جميع حالات الأنشطة"
    },
    "fields": {
      "arabicName": "الاسم العربي",
      "englishName": "الاسم الإنجليزي",
      "sendMail": "إرسال بريد",
      "email": "البريد الإلكتروني",
      "type": "النوع",
      "status": "الحالة",
      "actions": "الإجراءات",
      "isOpening": "للافتتاح",
      "isClosed": "للإغلاق",
      "color": "لون الحالة"
    },
    "types": {
      "activity": "نشاط",
      "inquiry": "استفسار",
      "complaint": "شكوى"
    },
    "noCreatePermission": "ليس لديك صلاحية لإنشاء حالة النشاط"
  },
  "companies": {
    "status": {
      "tableTitle": "جميع الشركات"
    },
    "fields": {
      "englishName": "الاسم بالإنجليزية",
      "arabicName": "الاسم بالعربية",
      "loginAs": "تسجيل الدخول",
      "logOut": "تسجيل الخروج",
      "url": "الرابط",
      "phone": "الهاتف",
      "status": "الحالة",
      "actions": "الإجراءات"
    },
    "LoggedinSuccessfully": "تم الدخول كشركة بنجاح!",
    "LoggedOutSuccessfully": "تم تسجيل الخروج بنجاح",
    "LoginAsError": "فشل تسجيل الدخول كشركة. يرجى المحاولة مرة أخرى."
  },
  "companyCustomizations": {
    "title": "تخصيصات الشركات",
    "listHint": "القوالب معرّفة في الكود. يمكنك فقط ربط الشركات أو إلغاء ربطها — دون إنشاء أو تعديل القوالب.",
    "emptyPresets": "لا توجد قوالب تخصيص.",
    "emptyAssignments": "لا توجد شركات مرتبطة بهذا القالب.",
    "active": "نشط",
    "inactive": "غير نشط",
    "inactiveLinkDisabled": "لا يمكن ربط القوالب غير النشطة بالشركات.",
    "settingsOverrides": "تجاوزات الإعدادات",
    "settingsOverridesHint": "تجاوزات جزئية تُطبَّق فوق الإعدادات الافتراضية للوحدة. للعرض فقط.",
    "settingsPreview": "معاينة مدمجة (افتراضيات + تجاوزات)",
    "settingsPreviewHint": "الإعدادات الكاملة المحلولة لهذا القالب. للعرض فقط.",
    "linkedCompaniesTitle": "الشركات المرتبطة",
    "linkedCompaniesHint": "قالب واحد لكل وحدة لكل شركة.",
    "linkCompany": "ربط شركة",
    "link": "ربط",
    "unlink": "إلغاء الربط",
    "unlinkConfirm": "إلغاء ربط هذه الشركة؟",
    "unlinkConfirmHint": "ستعود الشركة إلى الإعدادات الافتراضية للوحدة.",
    "linkReplaceWarning": "ربط \"{{preset}}\" سيستبدل أي قالب {{module}} موجود للشركة المحددة.",
    "selectCompany": "اختر شركة",
    "companyRequired": "يرجى اختيار شركة",
    "linkSuccess": "تم ربط الشركة بالقالب",
    "linkError": "فشل ربط الشركة",
    "unlinkSuccess": "تم إلغاء ربط الشركة بالقالب",
    "unlinkError": "فشل إلغاء ربط الشركة",
    "presetNotFound": "القالب غير موجود",
    "fields": {
      "name": "الاسم",
      "slug": "المعرّف",
      "module": "الوحدة",
      "linkedCompanies": "الشركات المرتبطة",
      "legacyCompanyId": "معرّف الشركة القديم",
      "status": "الحالة",
      "description": "الوصف",
      "company": "الشركة",
      "updatedAt": "آخر تحديث"
    },
    "modules": {
      "all": "كل الوحدات",
      "activities": "الأنشطة",
      "orders": "الطلبات",
      "pos": "نقاط البيع"
    }
  },
  "activitySections": {
    "tableTitle": "جميع الأقسام",
    "savedSuccessfully": "تم حفظ أقسام الأنشطة بنجاح",
    "failedSave": "فشل في حفظ أقسام الأنشطة",
    "editActivitySections": "تعديل أقسام الأنشطة",
    "addActivitySections": "إضافة أقسام الأنشطة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء أقسام الأنشطة"
  },
  "activityReasons": {
    "tableTitle": "جميع الأسباب",
    "sections": "الأقسام",
    "savedSuccessfully": "تم حفظ أسباب الأنشطة بنجاح",
    "failedSave": "فشل في حفظ أسباب الأنشطة",
    "editActivityReasons": "تعديل أسباب الأنشطة",
    "addActivityReasons": "إضافة أسباب الأنشطة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء أسباب الأنشطة"
  },
  "paymentSettings": {
    "savedSuccessfully": "تم حفظ إعدادات الدفع بنجاح",
    "failedSave": "فشل في حفظ إعدادات الدفع"
  },
  "notificationSounds": {
    "labels": {
      "new_order": "صوت طلب جديد",
      "new_activity": "صوت نشاط جديد",
      "new_inquiry": "صوت استفسار جديد",
      "new_complaint": "صوت شكوى جديدة",
      "activity_reply": "صوت الرد على النشاط",
      "status_changed": "صوت تغيير الحالة"
    },
    "title": "أصوات الإشعارات",
    "uploadFile": "رفع",
    "changeFile": "تغيير",
    "play": "تشغيل",
    "playCurrent": "تشغيل الصوت الحالي",
    "noChanges": "لا توجد تغييرات للحفظ",
    "savedSuccessfully": "تم حفظ أصوات الإشعارات بنجاح",
    "saveFailed": "فشل في حفظ أصوات الإشعارات",
    "fetchFailed": "فشل في تحميل أصوات الإشعارات",
    "maxFileSizeHint": "الحجم الأقصى المسموح به للملف: 800 كيلوبايت.",
    "fileTooLarge": "يتجاوز حجم الملف الحد الأقصى المسموح به وهو 800 كيلوبايت."
  },
  "deliveryManagement": {
    "title": "إدارة التوصيل",
    "useShopper": "استخدام المتسوق",
    "hasCustody": "لديه عهدة",
    "save": "حفظ",
    "savedSuccessfully": "تم حفظ إدارة التوصيل بنجاح",
    "failedSave": "فشل حفظ إدارة التوصيل"
  },
  "tickets": {
    "createActivity": "إنشاء نشاط",
    "createComplaint": "إنشاء شكوى",
    "createInquiry": "إنشاء استفسار",
    "fields": {
      "customerPhone": "هاتف العميل",
      "customerName": "اسم العميل",
      "orderId": "معرف الطلب",
      "last_date": "التاريخ الأخير",
      "agentName": "اسم الوكيل"
    },
    "channels": "القنوات",
    "reasons": "الأسباب",
    "branches": "الفروع",
    "validity": "الصلاحية",
    "details": "التفاصيل",
    "savedSuccessfully": "تم حفظ التذكرة بنجاح",
    "failedSave": "فشل في حفظ التذكرة",
    "saveNotConfirmed": "استغرق تأكيد الطلب وقتًا طويلاً. راجع قائمة الأنشطة قبل الإرسال مرة أخرى."
  },
  "productReviews": {
    "tableTitle": "تقييمات المنتجات",
    "searchPlaceholder": "ابحث في التعليق أو العميل أو المنتج",
    "approve": "قبول",
    "reject": "رفض",
    "approveSelected": "قبول المحدد",
    "rejectSelected": "رفض المحدد",
    "selected": "تم تحديد {{count}}",
    "approveSuccess": "تم قبول التقييم",
    "rejectSuccess": "تم رفض التقييم",
    "actionError": "حدث خطأ ما",
    "bulkPartial": "تم قبول {{done}}، وتم تخطي {{skipped}} تقييمات مُعلَّمة",
    "approveAnyway": "قبول على أي حال",
    "flaggedTitle": "محتوى مُعلَّم",
    "flaggedBody": "يحتوي هذا التقييم على كلمات مُعلَّمة. سياسة محتوى الصيدلية لا تسمح بالادعاءات الطبية. هل تريد القبول على أي حال؟",
    "flaggedManyBody": "{{count}} من التقييمات المحددة تحتوي على كلمات مُعلَّمة. هل تريد قبولها على أي حال؟",
    "rejectTitle": "رفض التقييم",
    "rejectManyTitle": "رفض {{count}} تقييمات",
    "reason": "السبب",
    "reasonRequired": "من فضلك اختر السبب",
    "note": "ملاحظة",
    "noteRequired": "من فضلك أضف ملاحظة",
    "noComment": "تقييم بدون تعليق",
    "dateFrom": "من",
    "dateTo": "إلى",
    "columns": {
      "product": "المنتج",
      "productId": "رقم المنتج",
      "customer": "العميل",
      "rating": "التقييم",
      "comment": "التعليق",
      "order": "الطلب",
      "status": "الحالة",
      "createdAt": "تاريخ الإرسال"
    },
    "status": {
      "pending": "قيد المراجعة",
      "approved": "مقبول",
      "rejected": "مرفوض"
    },
    "flags": {
      "profanity": "ألفاظ مسيئة",
      "medical_claim": "ادعاء طبي"
    },
    "reasons": {
      "profanity": "ألفاظ مسيئة",
      "medical_claim": "ادعاء طبي (سياسة الصيدلية)",
      "irrelevant": "لا يخص المنتج",
      "spam": "رسائل مزعجة / إعلان",
      "personal_info": "يحتوي على بيانات شخصية",
      "other": "أخرى"
    }
  },
  "reviewBannedWords": {
    "tableTitle": "الكلمات المحظورة في التقييمات",
    "noCreatePermission": "ليس لديك صلاحية إضافة كلمات",
    "word": "الكلمة / العبارة",
    "type": "النوع",
    "createdAt": "تاريخ الإنشاء",
    "add": "إضافة كلمة",
    "edit": "تعديل كلمة",
    "created": "تمت إضافة الكلمة بنجاح",
    "updated": "تم تعديل الكلمة بنجاح",
    "saveFailed": "فشل حفظ الكلمة",
    "wordRequired": "من فضلك أدخل الكلمة"
  },
  "keywordsList": {
    "tableTitle": "كل الكلمات المفتاحية",
    "addKeyword": "إضافة كلمة مفتاحية",
    "editKeyword": "تعديل الكلمة المفتاحية",
    "exportKeywords": "تصدير الكلمات المفتاحية",
    "exportSuccess": "تم التصدير بنجاح",
    "exportError": "فشل تصدير الكلمات المفتاحية. برجاء المحاولة مرة أخرى.",
    "importing": "جاري استيراد الكلمات المفتاحية...",
    "importSuccess": "تم استيراد الكلمات المفتاحية بنجاح!",
    "importError": "فشل استيراد الكلمات المفتاحية. برجاء المحاولة مرة أخرى.",
    "fileTooLarge": "حجم الملف كبير جدًا. الحد الأقصى 2 ميجابايت.",
    "noCreatePermission": "ليس لديك صلاحية لإضافة كلمات مفتاحية",
    "noImportPermission": "ليس لديك صلاحية لاستيراد كلمات مفتاحية",
    "createOptions": {
      "title": "إضافة كلمة مفتاحية جديدة",
      "uploadGroup": {
        "title": "رفع مجموعة من الكلمات المفتاحية",
        "description": "ارفع جميع الكلمات المفتاحية بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة كلمة مفتاحية واحدة",
        "description": "أضف كلمة مفتاحية واحدة بسهولة"
      },
      "downloadSample": "تحميل قالب عينة"
    },
    "importInstructions": {
      "title": "تعليمات الاستيراد",
      "nameRequired": "اسم الكلمة المفتاحية مطلوب",
      "statusOptional": "الحالة اختيارية (نشط/غير نشط)",
      "barcodesOptional": "باركودات المنتجات اختيارية",
      "barcodesCommaSeparated": "يجب أن تكون باركودات المنتجات مفصولة بفواصل",
      "supportedFormats": "الصيغ المدعومة"
    },
    "columns": {
      "name": "اسم الكلمة المفتاحية / العنوان",
      "status": "الحالة",
      "productsCount": "عدد المنتجات",
      "createdAt": "تاريخ الإنشاء"
    },
    "fields": {
      "title": "عنوان الكلمة المفتاحية (اختياري)",
      "titlePlaceholder": "أدخل عنوان المجموعة للكلمات المفتاحية",
      "titleHint": "عنوان لتجميع عدة كلمات مفتاحية معًا",
      "name": "اسم الكلمة المفتاحية",
      "namePlaceholder": "أدخل الكلمات المفتاحية مفصولة بفواصل",
      "nameHint": "أدخل الكلمات المفتاحية مفصولة بفواصل",
      "products": "ربط بالمنتجات (اختياري)",
      "productsHint": "ابحث واختر المنتجات المراد ربطها بهذه الكلمة المفتاحية",
      "barcodes": "باركودات المنتجات (اختياري)",
      "barcodesPlaceholder": "أدخل باركودات المنتجات مفصولة بفواصل (مثال: 123,321,456,645)",
      "barcodesHint": "يتم مطابقة الباركودات مع منتجات هذه الشركة"
    },
    "importCounts": {
      "created": "تم الإنشاء",
      "updated": "تم التحديث",
      "deleted": "تم الحذف"
    },
    "messages": {
      "created": "تم إنشاء الكلمة المفتاحية بنجاح",
      "updated": "تم تحديث الكلمة المفتاحية بنجاح",
      "createFailed": "فشل حفظ الكلمة المفتاحية",
      "updateFailed": "فشل تحديث الكلمة المفتاحية",
      "unmatchedBarcodes": "بعض الباركودات لم تطابق أي منتج: {{barcodes}}",
      "loadFailed": "فشل تحميل الكلمة المفتاحية"
    }
  },
  "manufacturersList": {
    "importing": "جارٍ استيراد الشركات المصنّعة...",
    "importSuccess": "تم استيراد الشركات المصنّعة بنجاح!",
    "importError": "فشل استيراد الشركات المصنّعة. حاول مرة أخرى.",
    "noImportPermission": "ليس لديك صلاحية لاستيراد الشركات المصنّعة",
    "createOptions": {
      "title": "إضافة شركة مصنّعة جديدة",
      "uploadGroup": {
        "title": "رفع مجموعة من الشركات المصنّعة",
        "description": "ارفع جميع الشركات المصنّعة بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة شركة مصنّعة واحدة",
        "description": "أضف الشركات المصنّعة بسهولة واحدة تلو الأخرى"
      },
      "downloadSample": "تحميل ملف النموذج"
    },
    "tableTitle": "جميع الشركات المصنّعة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء الشركات المصنّعة",
    "details": "تفاصيل الشركة المصنّعة",
    "savedSuccessfully": "تم حفظ الشركة المصنّعة بنجاح",
    "failedSave": "فشل في حفظ الشركة المصنّعة",
    "nameRequired": "الاسم مطلوب",
    "deleteConfirmDescription": "ستصبح منتجات الشركات المصنّعة المحذوفة بدون شركة مصنّعة.",
    "columns": {
      "logo": "الشعار",
      "nameEn": "الاسم (الإنجليزية)",
      "nameAr": "الاسم (العربية)",
      "productsCount": "المنتجات",
      "sort": "الترتيب",
      "status": "الحالة"
    }
  },
  "brandsList": {
    "createOptions": {
      "title": "إضافة علامة تجارية جديدة",
      "subtitle": "أضف علاماتك التجارية بسهولة في خطوات بسيطة",
      "description": "أنشئ كتالوج العلامات التجارية وأدر علامات منتجاتك بكفاءة.",
      "uploadGroup": {
        "title": "رفع مجموعة من العلامات التجارية",
        "description": "ارفع جميع العلامات التجارية بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة علامة تجارية واحدة",
        "description": "أضف علامة تجارية واحدة بسهولة واحدة تلو الأخرى"
      },
      "downloadSample": "تحميل ملف النموذج"
    },
    "noCreatePermission": "ليس لديك صلاحية لإنشاء العلامات التجارية",
    "noImportPermission": "ليس لديك صلاحية لاستيراد العلامات التجارية",
    "importSuccess": "تم استيراد العلامات التجارية بنجاح!",
    "importError": "فشل استيراد العلامات التجارية. يرجى المحاولة مرة أخرى.",
    "tableTitle": "جميع العلامات التجارية",
    "columns": {
      "id": "الرقم",
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "sort": "الترتيب",
      "actions": "الإجراءات",
      "BrandDetails": "تفاصيل العلامة التجارية",
      "nameEN": "الاسم (الإنجليزية)",
      "content_en": "المحتوى (الإنجليزية)",
      "content_ar": "المحتوى (العربية)",
      "logo": "الشعار",
      "Hide From Stores": "إخفاء من المتاجر",
      "savedSuccessfully": "تم حفظ العلامة التجارية بنجاح",
      "failedSave": "فشل في حفظ العلامة التجارية",
      "show in home?": "تظهر في الصفحة الرئيسية؟"
    }
  },
  "products": {
    "products": "المنتجات",
    "categories": "الفئات",
    "loadingMoreProducts": "جاري تحميل المزيد من المنتجات...",
    "noMoreProductsToLoad": "لا توجد منتجات أخرى للتحميل",
    "filterBy": "تصفية حسب",
    "searchProducts": "البحث في المنتجات",
    "mostCustomerProducts": "أكثر المنتجات طلباً من العملاء",
    "storeMostSales": "أكثر المنتجات مبيعاً في المتجر",
    "offers": "العروض",
    "customers": "العملاء",
    "unavailableProducts": "المنتجات غير المتوفرة",
    "withBrand": "منتجات مع علامة تجارية",
    "withCategory": "منتجات مع فئة",
    "withPhoto": "منتجات مع صورة",
    "withoutBrand": "منتجات بدون علامة تجارية",
    "withoutCategory": "منتجات بدون فئة",
    "withoutPhoto": "منتجات بدون صورة",
    "applyFilter": "تطبيق التصفية",
    "cancel": "إلغاء",
    "id": "الرقم التعريفي",
    "nameEn": "الاسم - بالإنجليزية",
    "nameAr": "الاسم - بالعربية",
    "barcode": "الباركود",
    "category": "الفئة",
    "price": "السعر",
    "productLink": "رابط المنتج",
    "status": "الحالة",
    "actions": "الإجراءات",
    "deleteSelected": "حذف المحدد",
    "bulkDeleteConfirm": "هل أنت متأكد أنك تريد حذف {{count}} من المنتجات المحددة؟",
    "bulkDeleteSuccess": "تم حذف المنتجات المحددة بنجاح",
    "bulkDeleteFailed": "فشل حذف المنتجات المحددة",
    "noBulkDeletePermission": "ليس لديك صلاحية حذف المنتجات",
    "changeStatusSelected": "تغيير الحالة",
    "activateSelected": "تفعيل",
    "deactivateSelected": "إلغاء التفعيل",
    "bulkStatusSuccess": "تم تحديث حالة المنتجات المحددة",
    "bulkStatusFailed": "فشل تحديث حالة المنتجات المحددة",
    "noBulkStatusPermission": "ليس لديك صلاحية تغيير حالة المنتجات",
    "assignManufacturer": "تعيين الشركة المصنّعة",
    "assignManufacturerTitle": "تعيين الشركة المصنّعة لـ {{count}} منتج محدد",
    "selectManufacturer": "اختر الشركة المصنّعة",
    "removeManufacturer": "إزالة الشركة المصنّعة من المنتجات المحددة",
    "bulkManufacturerSuccess": "تم تحديث الشركة المصنّعة للمنتجات المحددة",
    "bulkManufacturerPartial": "تم تحديث {{updated}} منتج، وتعذر تحديث {{failed}}",
    "bulkManufacturerFailed": "فشل تحديث الشركة المصنّعة للمنتجات المحددة",
    "filterByManufacturer": "الشركة المصنّعة",
    "selectedCount": "تم تحديد {{count}}",
    "clearSelection": "إلغاء التحديد"
  },
  "productList": {
    "mainDetails": "تفاصيل المنتج الرئيسية",
    "createOptions": {
      "title": "إضافة منتج جديد",
      "subtitle": "أضف منتجاتك بسهولة في خطوات بسيطة",
      "description": "أنشئ كتالوج منتجاتك الخاص، وتتبع مخزونك، وبيع منتجك بسهولة برابط مباشر.",
      "uploadGroup": {
        "title": "رفع مجموعة من المنتجات",
        "description": "ارفع جميع المنتجات بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة منتج واحد",
        "description": "أضف منتج واحد بتفاصيل كاملة"
      },
      "exportProducts": "تصدير المنتجات",
      "downloadSample": "تحميل ملف النموذج"
    },
    "noImportPermission": "ليس لديك صلاحية لاستيراد المنتجات",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المنتجات",
    "noExportPermission": "ليس لديك صلاحية لتصدير المنتجات",
    "ProductDetails": "تفاصيل المنتج",
    "SeoSearch": "تحسين محركات البحث ",
    "importOptions": {
      "title": "استيراد المنتجات",
      "selectSection": "اختر قسم الاستيراد",
      "selectSectionRequired": "يرجى اختيار قسم الاستيراد",
      "selectSectionPlaceholder": "اختر ما تريد استيراده",
      "selectSectionFirst": "يرجى اختيار قسم الاستيراد أولاً",
      "selectFile": "اختر الملف",
      "dragFileText": "انقر أو اسحب الملف إلى هذه المنطقة للتحميل",
      "fileHint": "يدعم ملفات Excel (.xlsx, .xls) أو ملفات CSV. الحد الأقصى لحجم الملف: 10 ميجابايت",
      "info": "اختر القسم الذي تريد استيراده وقم برفع ملفك. يجب أن يطابق الملف نوع الاستيراد المحدد.",
      "downloadSample": "تحميل ملف النموذج"
    }
  },
  "productAlternatives": {
    "title": "البدائل",
    "activeIngredient": "المادة الفعالة",
    "activeIngredientHint": "المنتجات التي لها نفس المادة الفعالة تُقترح كبدائل مثيلة",
    "types": {
      "brand": "بديل تجاري",
      "generic": "بديل مثيل"
    },
    "columns": {
      "product": "المنتج",
      "barcode": "الباركود",
      "price": "السعر",
      "type": "النوع"
    },
    "searchProducts": "ابحث عن منتجات لإضافتها",
    "add": "إضافة",
    "save": "حفظ البدائل",
    "confirmSave": "هل تريد حفظ البدائل؟",
    "saved": "تم حفظ البدائل",
    "saveFailed": "فشل حفظ البدائل",
    "loadFailed": "فشل تحميل البدائل",
    "confirmDelete": "هل تريد إزالة هذا البديل؟",
    "deleted": "تمت إزالة البديل",
    "deleteFailed": "فشلت إزالة البديل",
    "empty": "لا توجد بدائل بعد",
    "suggest": "اقتراح حسب المادة الفعالة",
    "suggestionsTitle": "نفس المادة الفعالة",
    "suggestionsFailed": "فشل تحميل الاقتراحات",
    "noSuggestions": "لا توجد منتجات أخرى بنفس المادة الفعالة. حدد المادة الفعالة للمنتج أولاً.",
    "addAllGeneric": "إضافة الكل كبدائل مثيلة",
    "importSuccess": "تم استيراد البدائل. تمت إضافة {{created}}، وتحديث {{updated}}، وتخطي {{skipped}}.",
    "unmatchedBarcodes": "باركود غير موجود: {{barcodes}}"
  },
  "productsList": {
    "videos": "الفيديوهات",
    "leaflets": "النشرات (PDF)",
    "uploadVideo": "رفع فيديو",
    "videoUploadRestrictions": "MP4 أو WebM أو MOV، بحد أقصى 100 ميجابايت",
    "addVideoUrl": "إضافة رابط يوتيوب/فيميو",
    "videoUrlPlaceholder": "https://www.youtube.com/watch?v=...",
    "invalidVideoUrl": "أدخل رابط يوتيوب أو فيميو صحيح",
    "videoAdded": "تمت إضافة الفيديو بنجاح",
    "videoTypeError": "يجب أن يكون الفيديو بصيغة MP4 أو WebM أو MOV",
    "videoMaxSizeError": "يجب ألا يتجاوز حجم الفيديو 100 ميجابايت",
    "noVideos": "لا توجد فيديوهات بعد",
    "leafletUploadRestrictions": "PDF فقط، بحد أقصى 10 ميجابايت، نشرة واحدة لكل لغة",
    "leafletPdfOnly": "يجب أن تكون النشرة ملف PDF",
    "leafletMaxSizeError": "يجب ألا يتجاوز حجم النشرة 10 ميجابايت",
    "uploadLeaflet": "رفع PDF",
    "replaceLeaflet": "استبدال",
    "viewLeaflet": "عرض النشرة",
    "noLeaflet": "لا توجد نشرة",
    "allLanguages": "كل اللغات",
    "arabic": "العربية",
    "english": "الإنجليزية",
    "mediaUploaded": "تم رفع الملف بنجاح",
    "mediaUploadFailed": "فشل رفع الملف",
    "mediaDeleted": "تم الحذف بنجاح",
    "mediaDeleteFailed": "فشل الحذف",
    "mediaSortFailed": "فشل إعادة ترتيب الفيديوهات",
    "deleteMediaConfirm": "هل أنت متأكد من حذف هذا الملف؟",
    "rating": "التقييم",
    "Extra": "الإضافة",
    "selectExtra": "اختر الإضافة",
    "nameEN": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "description_en": "الوصف (بالإنجليزية)",
    "description_ar": "الوصف (بالعربية)",
    "mainImage": "الصورة الرئيسية",
    "moreImages": "المزيد من الصور",
    "tagKeyWords": "الكلمات الدلالية",
    "internal_parcode": "الباركود الداخلي",
    "optional": "(اختياري)",
    "salla_id": "معرف سلة",
    "metaEn": "الوصف التعريفي (بالإنجليزية)",
    "metaAr": "الوصف التعريفي (بالعربية)",
    "metaDescEn": "الوصف التعريفي (بالإنجليزية)",
    "metaDescAr": "الوصف التعريفي (بالعربية)",
    "keywordsHelpText": "ستساعد الكلمات الدلالية في العثور على هذا المنتج بشكل أسرع.",
    "savedSuccessfully": "تم حفظ المنتج بنجاح",
    "failedSave": "فشل في حفظ المنتج",
    "imageUploadBillingError": "فشل في رفع الصورة: حساب الفوترة لـ Google Cloud Storage معطل. يرجى الاتصال بالمسؤول.",
    "nameENPlaceholder": "أدخل اسم المنتج بالإنجليزية",
    "nameArPlaceholder": "أدخل اسم المنتج بالعربية",
    "descriptionEnPlaceholder": "أدخل وصف المنتج بالإنجليزية",
    "descriptionArPlaceholder": "أدخل وصف المنتج بالعربية",
    "tagKeyWordsPlaceholder": "أدخل الكلمات الدلالية للمنتج",
    "internalParcodePlaceholder": "أدخل الباركود الداخلي",
    "sallaIdPlaceholder": "أدخل معرف سلة",
    "SeoEN": "عنوان SEO (بالإنجليزية)",
    "SeoAr": "عنوان SEO (بالعربية)",
    "metaEnPlaceholder": "أدخل عنوان SEO بالإنجليزية",
    "metaArPlaceholder": "أدخل عنوان SEO بالعربية",
    "metaDescriptionEn": "وصف الميتا (بالإنجليزية)",
    "metaDescriptionAr": "وصف الميتا (بالعربية)",
    "metaDescEnPlaceholder": "أدخل وصف الميتا بالإنجليزية",
    "metaDescArPlaceholder": "أدخل وصف الميتا بالعربية",
    "price": "السعر",
    "barcode1": "الباركود 1",
    "barcode2": "الباركود 2 (اختياري)",
    "quantityAvailable": "الكمية المتاحة",
    "minQty": "الحد الأدنى للكمية",
    "maxQty": "الحد الأقصى للكمية (اختياري)",
    "steps": "الخطوات",
    "showInApi": "عرض في API (اختياري)",
    "HideFromStores": "إخفاء من المتاجر",
    "meta_desc_en": "وصف التعريف (الإنجليزية)",
    "meta_desc_ar": "وصف التعريف (العربية)",
    "meta_en": "عنوان التعريف (الإنجليزية)",
    "meta_ar": "عنوان التعريف (العربية)",
    "ProductDetails": "تفاصيل المنتج",
    "suppliers": "الموردون",
    "sort": "ترتيب الفرز (اختياري)",
    "SeoSearch": "تحسين محركات البحث",
    "unitTypes": "أنواع الوحدات",
    "Brand": "العلامة التجارية",
    "Manufacturer": "الشركة المصنّعة",
    "Steps": "الخطوات",
    "StockDetails": "تفاصيل المخزون",
    "Pricing": "التسعير",
    "storeVisibilityHelpText": "اعرض هذا المنتج في متجرك الخاص، وقم بتنشيط الرابط السحري لهذا الطلب.",
    "imageUploadRestrictions": "يقبل JPG و JPEG و PNG و GIF و SVG — بحد أقصى 800 كيلوبايت لكل صورة",
    "imageMaxSizeError": "يجب ألا يتجاوز حجم الصورة 800 كيلوبايت",
    "imageTypeError": "يجب أن تكون الصورة بصيغة JPG أو JPEG أو PNG أو GIF أو SVG",
    "UnitEN": "الوحدة (إنجليزي)",
    "UnitAR": "الوحدة (عربي)",
    "UnitType": "نوع الوحدة",
    "PriceEffect": "تأثير السعر",
    "StockEffect": "تأثير المخزون",
    "Quantity": "الكمية",
    "None": "لا شيء",
    "Increase": "زيادة",
    "Decrease": "نقصان",
    "productUnits": "وحدات المنتج",
    "ProductUnits": "وحدات المنتج",
    "AddUnit": "إضافة وحدة",
    "SaveUnits": "حفظ الوحدات",
    "confirmSaveUnits": "هل أنت متأكد من حفظ هذه الوحدات؟",
    "confirmDeleteUnit": "هل أنت متأكد من حذف هذه الوحدة؟",
    "unitDeletedSuccessfully": "تم حذف الوحدة بنجاح",
    "unitDeleteFailed": "فشل في حذف الوحدة",
    "saveProductFirst": "يرجى حفظ المنتج أولاً قبل إضافة الوحدات",
    "noValidUnits": "لا توجد وحدات صحيحة للحفظ. يرجى ملء جميع الحقول المطلوبة.",
    "unitsSavedSuccessfully": "تم حفظ الوحدات بنجاح",
    "unitsFailedSave": "فشل في حفظ الوحدات",
    "UnitENPlaceholder": "أدخل اسم الوحدة بالإنجليزية...",
    "UnitARPlaceholder": "أدخل اسم الوحدة بالعربية...",
    "productExtra": "إضافات المنتج",
    "AddExtra": "إضافة إضافة",
    "SaveExtras": "حفظ الإضافات",
    "confirmSaveExtras": "هل أنت متأكد من حفظ الإضافات؟",
    "confirmDeleteExtra": "هل أنت متأكد من حذف هذه الإضافة؟",
    "extraDeletedSuccessfully": "تم حذف الإضافة بنجاح",
    "extraDeleteFailed": "فشل في حذف الإضافة",
    "extrasSavedSuccessfully": "تم حفظ الإضافات بنجاح",
    "extrasFailedSave": "فشل في حفظ الإضافات",
    "noValidExtras": "لا توجد إضافات صحيحة للحفظ. يرجى ملء جميع الحقول المطلوبة.",
    "AddAttribute": "إضافة خاصية",
    "AddValue": "إضافة قيمة",
    "selectAttribute": "اختر الخاصية",
    "SaveAttributes": "حفظ الخصائص",
    "confirmSaveAttributes": "هل أنت متأكد من حفظ الخصائص؟",
    "attributeValueDeletedSuccessfully": "تم حذف قيمة الخاصية بنجاح",
    "attributeValueDeleteFailed": "فشل في حذف قيمة الخاصية",
    "attributesSavedSuccessfully": "تم حفظ الخصائص بنجاح",
    "attributesFailedSave": "فشل في حفظ الخصائص",
    "noValidAttributes": "لا توجد خصائص صحيحة للحفظ. يرجى ملء جميع الحقول المطلوبة.",
    "confirmDeleteAttributeValue": "هل أنت متأكد من حذف هذه القيمة؟",
    "attribute": "الخاصية",
    "valueAr": "القيمة (عربي)",
    "valueEn": "القيمة (إنجليزي)",
    "priceEffect": "تأثير السعر",
    "changeType": "نوع التغيير",
    "sku": "رمز SKU",
    "value": "القيمة",
    "addValue": "إضافة قيمة"
  },
  "categoryList": {
    "createOptions": {
      "title": "إضافة فئة جديدة",
      "subtitle": "أضف فئاتك بسهولة في خطوات بسيطة",
      "description": "يجب عليك إضافة الفئة الرئيسية أولاً، ثم يمكنك إضافة فئة فرعية من المستوى الأول أو الثاني",
      "uploadGroup": {
        "title": "رفع مجموعة من الفئات",
        "description": "ارفع جميع الفئات بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة فئة واحدة",
        "description": "أضف فئة واحدة بسهولة واحدة تلو الأخرى"
      },
      "downloadSample": "تحميل ملف النموذج"
    },
    "noCreatePermission": "ليس لديك صلاحية لإنشاء الفئات",
    "noImportPermission": "ليس لديك صلاحية لاستيراد الفئات",
    "tableTitle": "جميع الفئات الرئيسية",
    "subCategoriesTitle": "الفئات الفرعية",
    "CategoryDetails": "تفاصيل الفئة",
    "SubCategoryDetails": "تفاصيل الفئة الفرعية",
    "columns": {
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "subCategories": "الفئات الفرعية",
      "subSubCategories": "الفئات الفرعية الفرعية"
    },
    "addSubSubCategoryButton": "+ إضافة فئة فرعية جديدة",
    "addSubCategoryButton": "+ إضافة فئة فرعية جديدة "
  },
  "categoriesList": {
    "savedSuccessfully": "تم حفظ الفئة بنجاح",
    "Category": "الفئة",
    "failedSave": "فشل في حفظ الفئة",
    "CategoryDetails": "تفاصيل الفئة",
    "MainCategory": "الفئة الرئيسية",
    "nameEN": "الاسم (الإنجليزية)",
    "nameAr": "الاسم (العربية)",
    "description_en": "الوصف (الإنجليزية)",
    "description_ar": "الوصف (العربية)",
    "content_en": "المحتوى (الإنجليزية)",
    "content_ar": "المحتوى (العربية)",
    "imageAr": "الصورة (العربية)",
    "imageEn": "الصورة (الإنجليزية)",
    "SeoEn": "رابط SEO (الإنجليزية)",
    "SeoAr": "رابط SEO (العربية)",
    "sort": "ترتيب الفرز",
    "HideFromStores": "إخفاء من المتاجر",
    "showInHome": "عرض في الصفحة الرئيسية"
  },
  "activities": {
    "activeTicket": "التذاكر النشطة",
    "type": "النوع",
    "activity": "النشاط",
    "complain": "شكوى",
    "inquiry": "استفسار",
    "tableTitle": "جميع التذاكر",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء الأنشطة",
    "noShowPermission": "ليس لديك صلاحية لعرض الأنشطة",
    "noTrackPermission": "ليس لديك صلاحية لتتبع الأنشطة",
    "noViewPermission": "ليس لديك صلاحية لعرض الأنشطة",
    "id": "الرقم",
    "customerName": "اسم العميل",
    "customer_phone": "هاتف العميل",
    "agent": "الوكيل",
    "status": "الحالة",
    "department": "القسم",
    "channel": "القناة",
    "details": "التفاصيل",
    "created_at": "تاريخ الإنشاء",
    "created_from": "تاريخ الإنشاء من",
    "created_to": "تاريخ الإنشاء إلى",
    "actions": "الإجراءات",
    "show": "عرض",
    "track": "تتبع",
    "previousComments": "التعليقات السابقة",
    "By": "بواسطة",
    "all": "الكل",
    "search_customer": "الهاتف / الاسم",
    "search_product": "اسم المنتج / الباركود",
    "store": "المتجر",
    "trackingInformation": "معلومات التتبع",
    "employer": "الموظف",
    "timing": "التوقيت",
    "action": "الإجراء",
    "value": "القيمة",
    "callChannel": {
      "actions": "الإجراءات"
    },
    "modal": {
      "title": "تفاصيل النشاط",
      "submit": "إرسال",
      "cancel": "إلغاء"
    },
    "fields": {
      "order_number": "رقم الطلب",
      "customer_number": "رقم العميل",
      "reason": "السبب",
      "section": "القسم",
      "validity": "الصلاحية",
      "branch": "الفرع",
      "productBarcode": "باركود المنتج",
      "productName": "اسم المنتج",
      "last_date": "التاريخ الأخير",
      "addReply": "إضافة رد",
      "replyPlaceholder": "أدخل ردك...",
      "attachFile": "إرفاق ملف",
      "attachment": "مرفق"
    },
    "statusOptions": {
      "open": "مفتوح",
      "in_progress": "قيد التنفيذ",
      "resolved": "تم الحل"
    },
    "changeStatus": {
      "action": "تغيير الحالة",
      "title": "تغيير حالة التذاكر المحددة",
      "selectTickets": "اختر التذاكر لتغيير حالتها",
      "selectedTickets": "التذاكر المحددة",
      "mixedTypes": "يمكن تغيير حالة التذاكر من نفس النوع فقط",
      "unknownType": "نوع هذه التذكرة غير معروف، لذا لا يمكن تغيير حالتها ضمن مجموعة",
      "statusRequired": "من فضلك اختر الحالة",
      "success": "تم تحديث حالة التذاكر بنجاح",
      "partialSuccess": "تم تحديث {{updated}} تذكرة، وفشل {{failed}}",
      "selectedCount": "التذاكر المحددة: {{total}}",
      "moreTickets": "و{{total}} أخرى",
      "tooMany": "يمكن تغيير حالة {{max}} تذكرة كحد أقصى في المرة الواحدة. قلّل عدد التذاكر المحددة وحاول مرة أخرى.",
      "error": "فشل تغيير حالة التذاكر المحددة"
    }
  },
  "unauthorized": {
    "title": "تم رفض الوصول",
    "subtitle": "ليس لديك صلاحية للوصول إلى هذه الصفحة.",
    "subtitleWithPermission": "ليس لديك صلاحية لتنفيذ هذا الإجراء (الصلاحية: {{permission}})",
    "goBack": "العودة",
    "goHome": "الذهاب للرئيسية"
  },
  "users": {
    "title": "إدارة المستخدمين",
    "addNew": "إضافة مستخدم جديد",
    "viewUser": "عرض تفاصيل المستخدم",
    "editUser": "تعديل المستخدم",
    "deleteUser": "حذف المستخدم",
    "deleteConfirm": "هل أنت متأكد من حذف هذا المستخدم؟",
    "deleteSuccess": "تم حذف المستخدم بنجاح",
    "deleteError": "فشل في حذف المستخدم",
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "username": "اسم المستخدم",
    "type": "النوع",
    "status": "الحالة",
    "roles": "الأدوار",
    "createdAt": "تاريخ الإنشاء",
    "admin": "مدير",
    "user": "مستخدم",
    "active": "نشط",
    "inactive": "غير نشط",
    "totalUsers": "إجمالي المستخدمين",
    "activeUsers": "المستخدمين النشطين",
    "inactiveUsers": "المستخدمين غير النشطين",
    "adminUsers": "المديرين",
    "searchPlaceholder": "البحث بالاسم أو البريد الإلكتروني أو اسم المستخدم",
    "selectType": "اختر النوع",
    "selectStatus": "اختر الحالة",
    "view": "عرض المستخدم",
    "edit": "تعديل المستخدم",
    "delete": "حذف المستخدم"
  },
  "manageCustomers": {
    "tableTitle": "إدارة العملاء",
    "noDeletePermission": "ليس لديك صلاحية لحذف العملاء",
    "blockSuccess": "تم حظر العميل بنجاح",
    "unblockSuccess": "تم إلغاء حظر العميل بنجاح",
    "blockError": "فشل في تحديث حالة العميل",
    "deleteSuccess": "تم حذف العميل بنجاح",
    "deleteError": "فشل في حذف العميل",
    "male": "ذكر",
    "female": "أنثى",
    "blockModalTitle": "حظر العميل",
    "unblockModalTitle": "إلغاء حظر العميل",
    "deleteModalTitle": "حذف العميل",
    "blockConfirm": "هل أنت متأكد من حظر هذا العميل؟",
    "unblockConfirm": "هل أنت متأكد من إلغاء حظر هذا العميل؟",
    "deleteConfirm": "هل أنت متأكد من حذف هذا العميل؟ لا يمكن التراجع عن هذا الإجراء.",
    "columns": {
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "birthdate": "تاريخ الميلاد",
      "gender": "الجنس",
      "from": "من",
      "registeredAt": "تاريخ التسجيل",
      "deletedAt": "تاريخ الحذف",
      "age": "العمر",
      "loginWith": "تسجيل الدخول بواسطة"
    },
    "actions": {
      "view": "عرض",
      "block": "حظر",
      "unblock": "إلغاء الحظر",
      "delete": "حذف"
    }
  },
  "validationMessages": {
    "invalidEmail": "بريد الكتروني غير صحيح ",
    "invalidUrl": "رابط غير صحيح",
    "mustBeHttpOrHttps": "يجب ان يكون HTTP او HTTPS"
  },
  "validation": {
    "priceRequired": "السعر مطلوب",
    "priceFormat": "يجب أن يكون السعر رقمًا به حتى منزلتين عشريتين",
    "barcodeRequired": "الباركود مطلوب",
    "stockRequired": "كمية المخزون مطلوبة",
    "stockMin2": "يجب أن يكون المخزون 2 على الأقل",
    "stockMin0": "لا يمكن أن يكون المخزون سالبًا",
    "stepsRequired": "الخطوات مطلوبة",
    "stepsMin1": "يجب أن تكون الخطوات 1 على الأقل",
    "stepsGreaterThan0": "يجب أن تكون الخطوات أكبر من 0",
    "minQtyRequired": "الحد الأدنى للكمية مطلوب",
    "nameEnRequired": "الاسم بالإنجليزية مطلوب",
    "nameArRequired": "الاسم بالعربية مطلوب",
    "max255": "الحد الأقصى للطول هو 255 حرفًا",
    "formError": "يرجى تصحيح الأخطاء في النموذج",
    "unitNameRequired": "اسم الوحدة مطلوب",
    "unitTypeRequired": "نوع الوحدة مطلوب",
    "priceEffectRequired": "تأثير السعر مطلوب",
    "stockEffectRequired": "تأثير المخزون مطلوب",
    "quantityRequired": "الكمية مطلوبة",
    "required": "هذا الحقل مطلوب"
  },
  "paymentSetting": {
    "paymentMethods": "طرق الدفع",
    "visaOnline": "فيزا عبر الإنترنت",
    "visaOnDelivery": "فيزا عند التسليم",
    "cashOnDelivery": "الدفع نقدًا عند التسليم",
    "title1": "الدفع عند الاستلام",
    "title2": "الدفع عند الاستلام التأمين"
  },
  "invoiceLinkSettings": {
    "cardTitle": "رابط الفاتورة",
    "title": "إعدادات رابط الفاتورة",
    "provider": "مزود الفاتورة",
    "invoiceBaseUrl": "رابط الفاتورة الأساسي",
    "enabled": "مفعّل",
    "preview": "معاينة",
    "configured": "مُكوَّن",
    "notConfigured": "رابط الفاتورة غير مُكوَّن بعد. املأ النموذج أدناه لتفعيل روابط الفواتير.",
    "notFullyConfigured": "غير مُكوَّن بالكامل",
    "savedSuccessfully": "تم حفظ إعدادات رابط الفاتورة",
    "failedSave": "فشل في حفظ إعدادات رابط الفاتورة",
    "deletedSuccessfully": "تم حذف إعدادات رابط الفاتورة",
    "deleteFailed": "فشل في حذف الإعدادات",
    "deleteConfirm": "حذف إعدادات رابط الفاتورة؟",
    "statusUpdated": "تم تحديث حالة رابط الفاتورة",
    "statusUpdateFailed": "فشل في تحديث الحالة",
    "urlTrailingSlashWarning": "يجب أن ينتهي الرابط الأساسي بـ /",
    "providerRequired": "مزود الفاتورة مطلوب",
    "providerMaxLength": "يجب ألا يتجاوز المزود 100 حرف",
    "baseUrlRequired": "رابط الفاتورة الأساسي مطلوب",
    "baseUrlInvalid": "أدخل رابطًا صالحًا"
  },
  "smsTemplates": {
    "pageTitle": "قوالب الرسائل النصية",
    "subtitle": "قم بتكوين الرسالة النصية التي تُرسل للعملاء بعد إتمام الطلب",
    "infoBanner": "عند التفعيل، تُرسل هذه الرسالة النصية للعميل بمجرد إنشاء طلبه. اترك اللغة فارغة لتخطيها.",
    "orderThankYou": "رسالة شكر على الطلب",
    "orderThankYouSub": "تُرسل تلقائياً بعد إنشاء الطلب.",
    "savedSuccessfully": "تم حفظ قالب الرسالة النصية بنجاح",
    "failedSave": "فشل حفظ قالب الرسالة النصية",
    "fields": {
      "content_en": "الرسالة (بالإنجليزية)",
      "content_ar": "الرسالة (بالعربية)"
    },
    "placeholders": {
      "content_en": "Thanks for your order",
      "content_ar": "شكراً لطلبك"
    },
    "buttons": {
      "save": "حفظ القالب",
      "back": "العودة للإعدادات"
    }
  },
  "emailSettings": {
    "pageTitle": "إعدادات البريد الإلكتروني",
    "subtitle": "قم بتكوين إعدادات SMTP الخاصة بشركتك لرسائل البريد الإلكتروني الخاصة بالتذاكر",
    "infoBanner": "ملاحظة: عند التكوين، سيتم إرسال جميع رسائل البريد الإلكتروني المتعلقة بالتذاكر باستخدام خادم SMTP الخاص بشركتك وعنوان البريد الإلكتروني بدلاً من بريد Awfar الافتراضي.",
    "smtpSection": "تكوين SMTP",
    "senderSection": "تفاصيل المرسل",
    "advancedSection": "إعدادات متقدمة",
    "ticketNotificationSection": "وضع إشعار البريد الإلكتروني للتذاكر",
    "ticketNotificationDescription": "اختر متى يجب إرسال رسائل البريد الإلكتروني المتعلقة بالتذاكر إلى العملاء. يمكنك إرسال رسائل البريد الإلكتروني عند كل تحديث للتذكرة، أو فقط عند إغلاق التذكرة.",
    "ticketFieldSection": "تكوين حقول البريد الإلكتروني للتذاكر",
    "ticketFieldBanner": "ملاحظة: قم بتكوين الحقول المضمنة في رسائل البريد الإلكتروني للتذاكر. يتم دائمًا تضمين معرف التذكرة ولا يمكن تعطيله. إذا تم تعطيل جميع الحقول، فستحتوي رسائل البريد الإلكتروني على معرف التذكرة فقط وتوقيع النظام.",
    "fields": {
      "smtp_host": "مضيف SMTP",
      "smtp_port": "منفذ SMTP",
      "smtp_username": "اسم مستخدم SMTP",
      "smtp_password": "كلمة مرور SMTP",
      "smtp_encryption": "التشفير",
      "from_email": "عنوان البريد الإلكتروني للمرسل",
      "from_name": "اسم المرسل",
      "reply_to": "البريد الإلكتروني للرد",
      "is_enabled": "مفعل",
      "use_fallback": "استخدام البديل",
      "ticket_email_mode": "وضع بريد التذاكر",
      "include_customer_name": "تضمين اسم العميل",
      "include_phone": "تضمين هاتف العميل",
      "include_order_id": "تضمين معرف الطلب",
      "include_ticket_description": "تضمين وصف التذكرة",
      "include_ticket_status": "تضمين حالة التذكرة",
      "include_assigned_agent": "تضمين الوكيل المعين",
      "include_additional_fields": "تضمين حقول إضافية"
    },
    "placeholders": {
      "smtp_host": "smtp-host.example.com",
      "smtp_port": "587",
      "smtp_username": "أدخل اسم مستخدم SMTP",
      "smtp_password": "اتركه فارغًا للاحتفاظ بكلمة المرور الحالية",
      "from_email": "from-email@example.com",
      "from_name": "اسم شركتك",
      "reply_to": "support@example.com"
    },
    "hints": {
      "smtp_host": "اسم خادم SMTP الخاص بك",
      "smtp_port": "المنافذ الشائعة: 587 (TLS)، 465 (SSL)، 25",
      "smtp_encryption": "يوصى بـ TLS للمنفذ 587، و SSL للمنفذ 465",
      "from_email": "سيظهر هذا كبريد إلكتروني للمرسل",
      "from_name": "اسم العرض للمرسل",
      "reply_to": "اختياري: أين يجب إرسال الردود"
    },
    "encryptionOptions": {
      "tls": "TLS",
      "ssl": "SSL",
      "none": "بدون"
    },
    "companyEmailCard": {
      "title": "إعدادات بريد الشركة",
      "description": "عند التمكين، سيتم إرسال جميع رسائل البريد الإلكتروني المتعلقة بالتذاكر باستخدام تكوين SMTP الخاص بشركتك. عند التعطيل، سيستخدم النظام إعدادات بريد Awfar الافتراضية."
    },
    "fallbackCard": {
      "title": "حماية بديلة",
      "description": "عند التمكين، إذا فشل SMTP في إرسال بريد إلكتروني، فسيقوم النظام تلقائيًا بالانتقال إلى مرسل Awfar الافتراضي لضمان تسليم البريد الإلكتروني."
    },
    "ticketModeOptions": {
      "on_update": "إرسال بريد إلكتروني عند كل تحديث للتذكرة",
      "on_update_sub": "سيستلم العملاء إشعارًا بالبريد الإلكتروني كلما تم تحديث حالة التذكرة.",
      "on_close": "إرسال بريد إلكتروني فقط عند إغلاق التذكرة",
      "on_close_sub": "سيستلم العملاء إشعارًا بالبريد الإلكتروني فقط عند تغيير حالة التذكرة إلى مغلقة."
    },
    "fieldCards": {
      "customerInfo": "معلومات العميل",
      "orderInfo": "معلومات الطلب",
      "ticketContent": "محتوى التذكرة",
      "additionalFields": "حقول إضافية",
      "additionalFieldsSub": "تضمين الحقول المخصصة مثل الأولوية، الفئة، الملاحظات، إلخ. (إذا كانت متاحة)"
    },
    "buttons": {
      "save": "حفظ التكوين",
      "testEmail": "اختبار البريد الإلكتروني",
      "back": "العودة إلى الإعدادات"
    },
    "testEmailModal": {
      "title": "إرسال بريد إلكتروني تجريبي",
      "label": "عنوان البريد الإلكتروني التجريبي",
      "placeholder": "أدخل عنوان البريد الإلكتروني لإرسال الاختبار",
      "send": "إرسال بريد تجريبي",
      "cancel": "إلغاء"
    },
    "savedSuccessfully": "تم حفظ إعدادات البريد الإلكتروني بنجاح",
    "failedSave": "فشل في حفظ إعدادات البريد الإلكتروني",
    "testEmailSuccess": "تم إرسال البريد الإلكتروني التجريبي بنجاح",
    "testEmailFailed": "فشل في إرسال البريد الإلكتروني التجريبي",
    "fetchFailed": "فشل في تحميل إعدادات البريد الإلكتروني",
    "validation": {
      "smtpHostRequired": "مضيف SMTP مطلوب",
      "smtpPortRequired": "منفذ SMTP مطلوب",
      "smtpPortInvalid": "يجب أن يكون منفذ SMTP رقمًا صالحًا",
      "encryptionRequired": "نوع التشفير مطلوب",
      "fromEmailRequired": "البريد الإلكتروني للمرسل مطلوب",
      "fromEmailInvalid": "يرجى إدخال عنوان بريد إلكتروني صالح",
      "replyToInvalid": "يرجى إدخال عنوان بريد إلكتروني صالح",
      "testEmailRequired": "عنوان البريد الإلكتروني التجريبي مطلوب",
      "testEmailInvalid": "يرجى إدخال عنوان بريد إلكتروني صالح"
    }
  },
  "pushNotifications": {
    "excelParsed": "تم العثور على {{count}} من معرفات العملاء",
    "excelParseFailed": "تعذّرت قراءة ملف الإكسل. تأكد من احتوائه على عمود customer_id.",
    "fileReadFailed": "تعذّرت قراءة الملف",
    "noSendPermission": "ليس لديك صلاحية إرسال الإشعارات",
    "sendType": {
      "custom": "مخصص",
      "schedule": "جدولة",
      "excel": "ملف إكسل",
      "sendAll": "إرسال للجميع",
      "abandonedCart": "السلة المتروكة",
      "branchSpecific": "إشعار خاص بفرع محدد"
    },
    "offerTypeOptions": {
      "product": "منتج",
      "brand": "علامة تجارية",
      "category": "الفئة",
      "offer": "عرض"
    },
    "pageTitle": "إشعارات الدفع",
    "addNew": "إضافة جديد",
    "tableTitle": "جميع الإشعارات",
    "columns": {
      "id": "المعرف",
      "tags": "العلامات",
      "title": "عنوان الإشعار",
      "successCount": "عدد النجاح",
      "invalidCount": "عدد غير الصالح",
      "unknownCount": "عدد غير المعروف",
      "totalCount": "الإجمالي",
      "actions": "الإجراءات"
    },
    "sendModal": {
      "sendTypePlaceholder": "اختر نوع الإرسال",
      "sendToAll": "إرسال للجميع",
      "scheduleNotification": "جدولة الإشعار",
      "scheduleHint": "اتركه فارغًا للإرسال فورًا.",
      "schedulePlaceholder": "اختر التاريخ والوقت",
      "uploadCustomerIds": "رفع ملف إكسل بمعرفات العملاء",
      "uploadCustomerIdsHint": "ارفع ملف إكسل يحتوي على عمود customer_id بمعرفات العملاء الذين تريد إرسال الإشعار إليهم.",
      "uploadFile": "رفع ملف إكسل",
      "notifyAbandonedCart": "إشعار السلة المتروكة",
      "fromDate": "من تاريخ",
      "toDate": "إلى تاريخ",
      "branches": "الفروع",
      "branchesHint": "المستلمون هم العملاء الذين طلبوا من الفرع المحدد؛ كل فرع يُرسل له بشكل منفصل (قد يصل للعميل نفسه أكثر من إشعار)",
      "branchesPlaceholder": "ابحث واختر الفروع",
      "title": "إرسال إشعار",
      "sendType": "نوع الإرسال",
      "notificationTitle": "عنوان الإشعار",
      "notificationTitlePlaceholder": "عنوان الإشعار",
      "body": "المحتوى",
      "bodyPlaceholder": "اكتب شيئًا...",
      "image": "صورة",
      "chooseFile": "اختر ملف",
      "authType": "نوع المصادقة",
      "authTypePlaceholder": "اختر نوع المصادقة",
      "gender": "الجنس",
      "genderPlaceholder": "اختر الجنس",
      "offerType": "نوع العرض",
      "selectItem": "اختر عنصر",
      "send": "إرسال",
      "cancel": "إلغاء"
    },
    "genderOptions": {
      "male": "ذكر",
      "female": "أنثى"
    },
    "authTypeOptions": {
      "guest": "زائر",
      "verified": "موثق",
      "unverified": "غير موثق",
      "all": "الكل"
    },
    "offerTypeOptions": {
      "product": "منتج",
      "brand": "علامة تجارية",
      "category": "فئة",
      "offer": "عروض",
      "favorite": "المفضلة",
      "insurance": "تأمين",
      "prescription": "وصفة طبية"
    },
    "actions": {
      "view": "عرض",
      "resend": "إعادة إرسال",
      "delete": "حذف"
    },
    "confirmDelete": "هل أنت متأكد من حذف هذا الإشعار؟",
    "confirmResend": "هل أنت متأكد من إعادة إرسال هذا الإشعار؟",
    "sentSuccessfully": "تم إرسال الإشعار بنجاح",
    "sendFailed": "فشل في إرسال الإشعار",
    "deletedSuccessfully": "تم حذف الإشعار بنجاح",
    "deleteFailed": "فشل في حذف الإشعار",
    "resentSuccessfully": "تم إعادة إرسال الإشعار بنجاح",
    "resendFailed": "فشل في إعادة إرسال الإشعار",
    "fetchFailed": "فشل في تحميل الإشعارات",
    "validation": {
      "branchesRequired": "يرجى اختيار فرع واحد على الأقل",
      "titleRequired": "عنوان الإشعار مطلوب",
      "bodyRequired": "المحتوى مطلوب",
      "offerItemRequired": "يرجى اختيار عنصر"
    }
  },
  "organization": {
    "tableTitle": "جميع المؤسسات",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المؤسسات",
    "noEditPermission": "ليس لديك صلاحية لتعديل المؤسسات",
    "noDeletePermission": "ليس لديك صلاحية لحذف المؤسسات",
    "savedSuccessfully": "تم حفظ المؤسسة بنجاح",
    "failedSave": "فشل في حفظ المؤسسة",
    "editOrganization": "تعديل المؤسسة",
    "addOrganization": "إضافة مؤسسة",
    "columns": {
      "id": "المعرف",
      "nameEn": "الاسم (الإنجليزية)",
      "nameAr": "الاسم (العربية)",
      "status": "الحالة",
      "actions": "الإجراءات"
    },
    "fields": {
      "name_ar": "الاسم بالعربية",
      "name_en": "الاسم بالإنجليزية",
      "description_ar": "الوصف بالعربية",
      "description_en": "الوصف بالإنجليزية",
      "status": "الحالة",
      "sort": "الترتيب"
    },
    "placeholders": {
      "name_ar": "أدخل الاسم بالعربية...",
      "name_en": "أدخل الاسم بالإنجليزية...",
      "description_ar": "أدخل الوصف بالعربية...",
      "description_en": "أدخل الوصف بالإنجليزية...",
      "sort": "أدخل ترتيب العرض..."
    },
    "activation": "التفعيل",
    "validation": {
      "nameArRequired": "الاسم بالعربية مطلوب",
      "nameEnRequired": "الاسم بالإنجليزية مطلوب",
      "descriptionArRequired": "الوصف بالعربية مطلوب",
      "descriptionEnRequired": "الوصف بالإنجليزية مطلوب"
    }
  },
  "trackingOrder": {
    "order tracking": "تتبع الطلب",
    "employee": "الموظف",
    "timing": "التوقيت",
    "value": "القيمة",
    "orderNumber": "رقم الطلب ",
    "timeline": "الخط الزمني",
    "customer": "العميل",
    "phone": "الهاتف",
    "store": "المتجر",
    "createdAt": "تاريخ الإنشاء",
    "total": "الإجمالي",
    "currentStatus": "الحالة الحالية",
    "eventsCount": "{{value}} حدث",
    "totalDuration": "المدة الكلية",
    "from": "من",
    "to": "إلى",
    "after": "بعد",
    "first": "البداية",
    "latest": "الأحدث",
    "roleUser": "موظف",
    "roleShopper": "مندوب",
    "roleCustomer": "عميل",
    "roleUnknown": "غير معروف",
    "unitDay": "يوم",
    "unitHour": "ساعة",
    "unitMinute": "دقيقة",
    "unitSecond": "ثانية",
    "and": "و",
    "genericEvent": "حدث على الطلب",
    "noEvents": "لا توجد أحداث مسجلة لهذا الطلب",
    "noViewPermission": "ليس لديك صلاحية لعرض تتبع هذا الطلب.",
    "loadFailed": "فشل تحميل تتبع الطلب",
    "opCreateOrder": "إنشاء طلب جديد",
    "opAssignShopper": "تعيين مندوب",
    "opItemRefund": "مرتجع منتج",
    "opChangeDeliveryTime": "تغيير موعد التوصيل",
    "opChangeStatus": "تغيير حالة الطلب",
    "opSettleOrder": "تسوية الطلب",
    "opTransferStore": "تحويل الطلب بين الفروع",
    "opUpdateShippingFees": "تعديل مصاريف الشحن",
    "opChangePaymentType": "تغيير طريقة الدفع",
    "opUpdateDiscount": "تعديل الخصم",
    "opOpenOrder": "فتح الطلب",
    "opUpdateAddress": "تعديل العنوان",
    "opUpdateComments": "تعديل التعليقات",
    "opAddProduct": "إضافة منتج",
    "opUpdateProduct": "تعديل منتج",
    "opDeleteProduct": "حذف منتج",
    "opReturnItem": "إرجاع منتج",
    "valCreateOrder": "إنشاء طلب جديد",
    "valShopperAssigned": "اسم المندوب: {{name}}",
    "valStatusChangedTo": "تم تغيير الحالة إلى: {{status}}",
    "valItemRefundUpdated": "تم تعديل مرتجع المنتج: {{item}}",
    "valOpenOrderFirstTime": "تم فتح الطلب لأول مرة",
    "valOrderSettled": "تم تسوية الطلب في الفرع",
    "valAddressUpdated": "تم تعديل عنوان الطلب",
    "valCommentsUpdated": "تم تعديل التعليقات",
    "valTransferBetweenStores": "تم تحويل الطلب من فرع رقم {{fromId}} ({{fromName}}) إلى فرع رقم {{toId}} ({{toName}})",
    "valTransferToStore": "تم تحويل الطلب إلى فرع رقم {{toId}}",
    "valShippingFeesChanged": "تم تعديل مصاريف الشحن من {{from}} إلى {{to}}",
    "valDiscountChanged": "تم تعديل الخصم من {{from}} إلى {{to}}",
    "valPaymentChanged": "تم تغيير طريقة الدفع من {{from}} إلى {{to}}",
    "valStatusChanged": "تم تغيير حالة الطلب من {{from}} إلى {{to}}",
    "valDeliveryTimeChanged": "تم تغيير موعد التوصيل من {{from}} إلى {{to}}",
    "valProductAdded": "تمت إضافة منتج رقم {{id}}، تعليق العميل: {{comment}}",
    "valProductUpdated": "تم تعديل منتج رقم {{id}}، تعليق العميل: {{comment}}",
    "valOfferProductUpdated": "تم تعديل منتج العرض رقم {{id}}",
    "valGroupOfferUpdated": "تم تعديل عرض المجموعة رقم {{id}}",
    "valAlternativeAdded": "تمت إضافة منتج بديل: {{name}}",
    "valProductDeleted": "تم حذف منتج رقم {{id}}",
    "valItemReturned": "تم إرجاع {{qty}} من المنتج رقم {{id}} بمبلغ {{amount}}",
    "valServiceCommentChanged": "تم تغيير تعليق خدمة العملاء من \"{{from}}\" إلى \"{{to}}\"",
    "valAgentCommentChanged": "تم تغيير تعليق مندوب التوصيل من \"{{from}}\" إلى \"{{to}}\""
  },
  "shippingModal": {
    "shippingFee": "مصاريف الشحن"
  },
  "discountModal": {
    "modalTitle": "إضافة خصم",
    "discountType": "نوع الخصم",
    "fixedAmount": "مبلغ ثابت",
    "percentage": "نسبة مئوية",
    "discountValue": "قيمة"
  },
  "deliveryTime": {
    "tableTitle": "وقت التسليم",
    "from": "من",
    "to": "إلى",
    "title": "العنوان",
    "fees": "الرسوم",
    "closeTime": "وقت الإغلاق",
    "capacity": "السعة",
    "actions": "إجراءات",
    "activation": "التفعيل",
    "savedSuccessfully": "تم حفظ وقت التسليم بنجاح",
    "failedSave": "فشل في حفظ وقت التسليم",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء وقت التوصيل",
    "noEditPermission": "ليس لديك صلاحية لتعديل وقت التوصيل",
    "noDeletePermission": "ليس لديك صلاحية لحذف وقت التوصيل",
    "titlePlaceholder": "أدخل عنوان وقت التسليم...",
    "feesPlaceholder": "أدخل رسوم التوصيل...",
    "closeTimePlaceholder": "أدخل وقت الإغلاق بالدقائق...",
    "capacityPlaceholder": "أدخل السعة القصوى...",
    "timeFormat": "h:mm a"
  },
  "stores": {
    "tableTitle": "المتاجر",
    "name": "الاسم",
    "activation": "التفعيل",
    "actions": "الإجراءات",
    "editStoreAreasFees": "تعديل رسوم مناطق المتجر",
    "deleteStore": "حذف المتجر",
    "deleteConfirmTitle": "هل تريد حذف هذا المتجر؟",
    "deleteConfirmContent": "سيتم حذف المتجر من قائمة المتاجر وإلغاء تفعيله، مع الاحتفاظ بطلباته وتقاريره.",
    "deletedSuccessfully": "تم حذف المتجر بنجاح",
    "deleteFailed": "فشل حذف المتجر",
    "deleted": "محذوف",
    "restoreStore": "استعادة المتجر",
    "restore": "استعادة",
    "restoreConfirmTitle": "هل تريد استعادة هذا المتجر؟",
    "restoreConfirmContent": "سيعود المتجر غير مفعل، وسيُحتسب ضمن الحد الأقصى لمتاجر الشركة مرة أخرى.",
    "restoredSuccessfully": "تمت استعادة المتجر بنجاح",
    "restoreFailed": "فشل استعادة المتجر",
    "mainCannotDelete": "لا يمكن حذف المتجر الرئيسي",
    "onlyStoreCannotDelete": "لا يمكن حذف المتجر الوحيد للشركة",
    "hasBranchesCannotDelete": "لا يمكن حذف هذا المتجر لأن متاجر أخرى تستخدمه كمتجر رئيسي",
    "outboundDeliveryFeesId": "معرف الرسوم الصادرة",
    "outboundDeliveryFeesIdInfo": "معرف منتج أودو المستخدم كبند رسوم التوصيل لهذه المنطقة. اتركه فارغًا لإلغاء الربط.",
    "editStoreAreas": "تعديل مناطق المتجر",
    "editStoreSetting": "تعديل إعدادات المتجر",
    "editStoreDelivery": "تعديل أوقات التوصيل للمتجر",
    "setStoreDeliveryLocation": "تحديد موقع التوصيل للمتجر",
    "deliveryZones": "مناطق التوصيل",
    "addZone": "إضافة منطقة",
    "newZone": "منطقة توصيل جديدة",
    "editZone": "تعديل منطقة التوصيل",
    "noZones": "لا توجد مناطق توصيل",
    "zoneSaved": "تم حفظ منطقة التوصيل بنجاح",
    "zoneDeleted": "تم حذف منطقة التوصيل بنجاح",
    "zoneSaveFailed": "فشل في حفظ منطقة التوصيل",
    "zoneDeleteFailed": "فشل في حذف منطقة التوصيل",
    "zoneLoadFailed": "فشل في تحميل منطقة التوصيل",
    "zonesLoadFailed": "فشل في تحميل مناطق التوصيل",
    "timeSlotsLoadFailed": "فشل في تحميل أوقات التوصيل",
    "deleteZoneConfirm": "هل تريد حذف منطقة التوصيل هذه؟",
    "drawShapeRequired": "يرجى رسم الشكل على الخريطة أولاً",
    "drawShapeHint": "استخدم شريط الأدوات لرسم منطقة التوصيل",
    "feeTiers": "رسوم التوصيل",
    "addFeeTier": "إضافة شريحة رسوم",
    "kmRange": "نطاق الكيلومترات",
    "deliveryFees": "رسوم التوصيل",
    "additionalFees": "رسوم إضافية",
    "shape": {
      "circle": "دائرة",
      "polygon": "مضلع",
      "rectangle": "مستطيل",
      "marker": "علامة",
      "polyline": "خط"
    },
    "StoreDelivery": "أوقات التوصيل للمتجر",
    "selectAll": "تحديد الكل",
    "deselectAll": "إلغاء تحديد الكل",
    "AllStores": "كل المتاجر",
    "fees": "الرسوم",
    "areasUpdatedSuccessfully": "تم تحديث مناطق المتجر بنجاح",
    "areasUpdateFailed": "فشل في تحديث مناطق المتجر",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المتاجر",
    "noEditPermission": "ليس لديك صلاحية لتعديل المتاجر",
    "noDeletePermission": "ليس لديك صلاحية لحذف المتاجر",
    "deliveryTimes": "أوقات التوصيل",
    "selectTimesForDelivery": "اختر أوقات التوصيل"
  },
  "companySettings": {
    "nameEN": "الاسم (الإنجليزية)",
    "currencyEn": "العملة (الإنجليزية)",
    "phone": "الهاتف",
    "url": "الرابط",
    "nameAr": "الاسم (العربية)",
    "currencyAr": "العملة (العربية)",
    "whatsappNumber": "رقم الواتساب",
    "sallaId": "معرّف سالا",
    "Email": "البريد الإلكتروني",
    "ReportMail": "بريد التقرير",
    "shareMessageAr": "رسالة المشاركة (العربية)",
    "shareMessageEr": "رسالة المشاركة (الإنجليزية)",
    "descriptionAr": "الوصف (العربية)",
    "descriptionEn": "الوصف (الإنجليزية)",
    "Company Information": "معلومات الشركة",
    "Main Setting": "الاعدادات الاساسية ",
    "arLogo": " شعار الشركة (عربي)",
    "enLogo": "شعار الشركة (إنجليزي)",
    "favIcon": "أيقونة الموقع",
    "notificationSound": "صوت الإشعارات",
    "Company Setting": "إعدادات الشركة",
    "Call Chanel": "قناة الاتصال",
    "Order Status": "حالة الطلب",
    "Delivery Times": "أوقات التوصيل",
    "Stores": "المتاجر",
    "Delivery Management": "إدارة التوصيل",
    "Loyalty Settings": "إعدادات الولاء",
    "Loyalty Disabled": "برنامج الولاء غير مفعل لشركتك",
    "Api Keys": "مفاتيح API",
    "Payment Settings": "إعدادات الدفع",
    "Customer Segmentation": "تقسيم العملاء",
    "Notification Sounds": "أصوات الإشعارات",
    "userLimit": "حد المستخدم",
    "storeLimit": "حد المتاجر",
    "shopperUserLimit": "الحد الأقصى لمستخدمي الشوبر",
    "shopperUserLimitInfo": "أقصى عدد لمستخدمي الشوبر. يُحسب بشكل منفصل عن حد المستخدمين. القيمة 0 تعني عدم السماح بإضافة مستخدمي شوبر.",
    "orderMonthlyLimit": "الحد الأقصى للطلبات شهرياً",
    "orderMonthlyLimitInfo": "اتركه فارغاً لغير المحدود",
    "orderMonthlyLimitPlaceholder": "غير محدود",
    "orderMonthlyLimitInvalid": "يجب أن يكون الحد الأقصى للطلبات شهرياً عدداً صحيحاً أكبر من أو يساوي 0، أو يُترك فارغاً لغير المحدود.",
    "expireDate": "تاريخ الانتهاء",
    "selectExpireDate": "اختر تاريخ الانتهاء",
    "loyalityNotifcationExpireTime": "وقت إشعار انتهاء الصلاحية",
    "loyalityNotifcationExpireTimeInfo": "إرسال إشعار للعميل قبل انتهاء صلاحية النقاط (الوقت بالأيام).",
    "loyalityNotifcationExpireTimePlaceholder": "مثال: 3",
    "days": "أيام",
    "Status": "الحالة",
    "savedSuccessfully": "تم حفظ إعدادات الشركة بنجاح",
    "createdSuccessfully": "تم إنشاء الشركة بنجاح",
    "failedSave": "فشل في حفظ إعدادات الشركة",
    "setupRequired": {
      "title": "عزيزي المسؤول",
      "message": "انت بحاجه لاستكمال الاعدادات قبل البدء في الاستخدام ..",
      "cta": "ابدأ الآن"
    },
    "orderMonthlyLimitReached": {
      "title": "الحد الأقصى للطلبات شهرياً",
      "message": "تم الوصول إلى الحد الأقصى للطلبات شهرياً. يرجى التواصل مع الدعم.",
      "cta": "حسناً"
    },
    "enableDelayedOrderNotification": "تفعيل تنبيهات الطلبات المتأخرة",
    "delayedOrderNotificationDescription": "إرسال تنبيهات تلقائية للعملاء الذين لم تتم معالجة طلباتهم بعد 15 و 30 يومًا",
    "invalidLogoType": "يجب أن يكون الشعار ملفًا من نوع: jpeg أو png أو jpg أو svg.",
    "Company Shipping fees": "رسوم شحن الشركة",
    "Prescription Doc": "مستند الوصفة الطبية",
    "Notional Id Doc": "مستند الهوية الوطنية",
    "Company Id Doc": "مستند هوية الشركة",
    "Insurances Id Doc": "مستند هوية التأمين",
    "MainSetting": {
      "Docs": "المستندات",
      "permissions": "الصلاحيات",
      "assign product base on": "تعيين المنتج بناءً على",
      "assign product base on ( API )": "تعيين المنتج بناءً على (API)",
      "assign product base on ( CRM )": "تعيين المنتج بناءً على (CRM)",
      "delivery fees base on": "رسوم التوصيل بناءً على",
      "CategoryType": "نوع الفئة",
      "GlobalModels": "النماذج ",
      "WithChat": "مع الدردشة",
      "manual verification": "التحقق اليدوي",
      "reportMail": "البريد الإلكتروني للتقرير",
      "BasicInfo": "المعلومات الأساسية",
      "StockDetails": "تفاصيل المخزن",
      "Links": "روابط",
      "CompanyType": "نوع الشركة",
      "Country": "الدولة",
      "DeliveryType": "نوع التوصيل",
      "CompanyProductType": "نوع المنتج",
      "StoreLocation": "موقع المتجر",
      "showNotPaidOrders": "عرض الطلبات غير المدفوعة",
      "WithStore": "مع متجر",
      "MainStore": "المتجر الرئيسي",
      "HasMainStore": "يوجد متجر رئيسي",
      "CanOpenOrderFirstTime": "السماح بفتح الطلب الأولي",
      "changeStatusFrom": "تغيير الحالة من",
      "changeStatusTo": "تغيير الحالة إلى",
      "changeStatusFromRequired": "حالة البداية مطلوبة",
      "changeStatusToRequired": "حالة النهاية مطلوبة",
      "fetchOrderStatus": "جلب حالة الطلب",
      "minimumOrderAmount": "الحد الأدنى لمبلغ الطلب",
      "Ordering Days Limit": "الحد اليومي للطلبات",
      "minimumOrderAmountRequired": "الحد الأدنى لمبلغ الطلب مطلوب",
      "firstColor": "اللون الأساسي",
      "secondColor": "اللون الثانوي",
      "StoreLocationSetting": "إعداد موقع المتجر",
      "Company Shipping fees": "رسوم شحن الشركة",
      "userShopper": "استخدام المتسوق",
      "Min Prescription Doc": "الحد الأدنى لمستند الوصفة الطبية",
      "Max Prescription Doc": "الحد الأقصى لمستند الوصفة الطبية",
      "Max Notional Id Doc": "الحد الأقصى لمستند الهوية الوطنية",
      "Min Notional Id Doc": "الحد الأدنى لمستند الهوية الوطنية",
      "Max Insurances Doc": "الحد الأقصى لمستند التأمينات",
      "Min Insurances Doc": "الحد الأدنى لمستند التأمينات",
      "Max Company Doc": "الحد الأقصى لمستند الشركة",
      "Min Company Doc": "الحد الأدنى لمستند الشركة",
      "Max Company Id Doc": "الحد الأقصى لمستند هوية الشركة",
      "Min Company Id Doc": "الحد الأدنى لمستند هوية الشركة",
      "Max Insurances Id Doc": "الحد الأقصى لمستند هوية التأمين",
      "Min Insurances Id Doc": "الحد الأدنى لمستند هوية التأمين",
      "Home Category Limit": "حد فئة الصفحة الرئيسية",
      "Assign Product base on": "تعيين قاعدة المنتج على",
      "GetProductFromCrm": "تعيين  المنتجات بناء على إدارة علاقات العملاء",
      "GetProductFromApi": "تعيين  المنتجات بناء على واجهة برمجة التطبيقات",
      "price from": "السعر من",
      "integration from": "التكامل من",
      "Upload Magazine": "رفع المجلة",
      "Stop Transfer After Minutes": "إيقاف النقل بعد (دقائق)",
      "Use Polygon Delivery": "استخدام التوصيل بالمضلّع",
      "MoreSetting": "اعدادات اخري",
      "stock_level_1": "مستوى المخزون 1",
      "stock_level_2": "مستوى المخزون 2",
      "stock_level_3": "مستوى المخزون 3",
      "stockLevel1": "لون مستوى المخزون 1",
      "stockLevel2": "لون مستوى المخزون 2",
      "stockLevel3": "لون مستوى المخزون 3",
      "hide out of stock product": "إخفاء المنتجات غير المتوفرة",
      "makeOrderOutOfStockCrm": "السماح بالطلبات للمنتجات غير المتوفرة (CRM)",
      "makeOrderOutOfStockCrmInfo": "عند التفعيل، يمكن لوكلاء CRM إضافة المنتجات وإتمام الطلب حتى عندما يكون المخزون صفراً.",
      "enableCartStockReservation": "حجز المخزون في السلة",
      "enableCartStockReservationInfo": "عند التفعيل، يتم خصم الكميات الموجودة في السلال المفتوحة الأخرى من المخزون المتاح. عند التعطيل، تُحتسب فقط الكميات الموجودة في سلة العميل نفسه من المخزون.",
      "StockFrom": "المخزن من ",
      "Terms View is HTML": "عرض الشروط بصيغة HTML",
      "Privacy View is HTML": "عرض الخصوصية بصيغة HTML",
      "About View is HTML": "عرض معلومات عنا بصيغة HTML",
      "domain": "النطاق",
      "Share app link": "رابط مشاركة التطبيق",
      "ios_app_link": "رابط تطبيق iOS",
      "android_app_link": "رابط تطبيق Android",
      "website_version": "إصدار الموقع الإلكتروني",
      "companyTypes": {
        "retail": "تجزئة",
        "wholesale": "جملة",
        "ecommerce": "التجارة الإلكترونية"
      },
      "countries": {
        "sa": "المملكة العربية السعودية",
        "ae": "الإمارات العربية المتحدة",
        "eg": "مصر"
      },
      "deliveryTypes": {
        "standard": "توصيل عادي",
        "express": "توصيل سريع"
      },
      "CountryOptions": {
        "Egypt": "مصر",
        "Syria": "سوريا",
        "SaudiArabia": "المملكة العربية السعودية",
        "Iraq": "العراق"
      },
      "CompanyTypeOptions": {
        "MAIN_STORE": "المتجر الرئيسي",
        "MARKETPLACE": "السوق",
        "MULTI_STORE": "متجر متعدد",
        "BOX": "صندوق",
        "LINE": "خط",
        "type": "النوع",
        "default": "الافتراضيي",
        "market place": "السوق"
      },
      "DeliveryTypeOptions": {
        "Company": "الشركة",
        "Store": "المتجر",
        "DeliveryTimes": "أوقات التسليم",
        "Region": "المنطقة",
        "FeesByDistance": "الرسوم حسب المسافة"
      },
      "ProductTypeOptions": {
        "Grocery": "بقالة",
        "Pharmacy": "صيدلية",
        "Both": "كلاهما"
      },
      "StoreLocationSettingOptions": {
        "NearestStore": "أقرب متجر",
        "MainStore": "المتجر الرئيسي"
      },
      "IntegrationFromOptions": {
        "Database": "قاعدة البيانات",
        "File": "ملف",
        "Mongo": "مونجو"
      },
      "StockFromOptions": {
        "Offline": "غير متصل",
        "Inventory": "المخزون",
        "Integration": "التكامل"
      },
      "ProductBaseOptions": {
        "Company": "الشركة",
        "Store": "المتجر"
      },
      "PriceFromTypeOptions": {
        "Offline": "غير متصل",
        "Integration": "التكامل"
      },
      "FetchOrderStatusOptions": {
        "AllAvailableStatuses": "اختيار جميع الحالات المتاحة",
        "NextComingStatusOnly": "اختيار الحالة القادمة التالية فقط (واحدة فقط)",
        "AllNextAvailableStatuses": "اختيار جميع الحالات المتاحة التالية"
      },
      "CompanyTypeInfo": "تصنيف الشركة: متجر رئيسي، أو سوق إلكتروني، أو متعدد المتاجر.",
      "DeliveryTypeInfo": "مصدر تنفيذ التوصيل: من الشركة، أو من المتجر، أو حسب أوقات التوصيل المجدولة.",
      "CompanyProductTypeInfo": "نوع الكتالوج: بقالة، أو صيدلية، أو كلاهما. خيار الصيدلية يفعّل متطلبات المستندات مثل الروشتة.",
      "StoreLocationSettingInfo": "كيفية اختيار متجر العميل: أقرب متجر حسب الموقع، أو المتجر الرئيسي دائمًا.",
      "showNotPaidOrdersInfo": "إظهار الطلبات التي لم تُدفع بعد ضمن قوائم الطلبات.",
      "WithStoreInfo": "فعّله إذا كانت الشركة تعمل بعدة متاجر أو فروع.",
      "HasMainStoreInfo": "فعّله إذا كان للشركة متجر رئيسي محدد، ثم اختره.",
      "MainStoreInfo": "اختر المتجر الذي يُعتبر المتجر الرئيسي للشركة.",
      "CanOpenOrderFirstTimeInfo": "عند التفعيل، يتم عرض خياري تغيير الحالة من وتغيير الحالة إلى.\nعند فتح الموظف للطلب، تتغير حالة الطلب تلقائيًا:\n• من الحالة المحددة في تغيير الحالة من\n• إلى الحالة المحددة في تغيير الحالة إلى.",
      "changeStatusFromInfo": "الحالة التي يجب أن يكون عليها الطلب عند فتحه من قبل الموظف ليتم تطبيق التغيير.",
      "changeStatusToInfo": "الحالة التي ينتقل إليها الطلب تلقائيًا عند فتحه من قبل الموظف.",
      "fetchOrderStatusInfo": "الحالات التي تظهر عند تغيير حالة الطلب: كل الحالات المتاحة، أو الحالة التالية فقط، أو كل الحالات القادمة.",
      "minimumOrderAmountInfo": "أقل إجمالي للطلب يجب أن يصل إليه العميل لإتمام الشراء.",
      "OrderingDaysLimitInfo": "عدد الأيام المستخدمة كنافذة للطلب.",
      "GetProductFromCrmInfo": "نطاق كتالوج المنتجات من النظام: شركة (كل المتاجر تشترك في كتالوج واحد) أو متجر (لكل متجر منتجاته الخاصة).",
      "GetProductFromApiInfo": "جلب المنتجات من واجهة خارجية (مثل أودو): على مستوى الشركة أو على مستوى المتجر.",
      "CompanyShippingFeesInfo": "رسوم الشحن الافتراضية المطبقة على الطلبات.",
      "priceFromInfo": "مصدر أسعار المنتجات: محلي (قاعدة البيانات المحلية) أو تكامل (نظام خارجي مثل أودو).",
      "integrationFromInfo": "مصدر بيانات التكامل. المخزون غير المتصل يستخدم قاعدة البيانات، ومخزون التكامل يستخدم ملف أو مونجو.",
      "integrationFromNotAllowed": "هذا الخيار غير متاح لمصدر المخزون المحدد.",
      "HomeCategoryLimitInfo": "الحد الأقصى لعدد الأقسام المعروضة في الصفحة الرئيسية.",
      "StopTransferAfterInfo": "إيقاف تحويل أو إسناد الطلب بعد هذا العدد من الدقائق.",
      "UsePolygonDeliveryInfo": "عند التفعيل، تحدّد المتاجر منطقة التوصيل الخاصة بها عن طريق رسم مضلّع بدلاً من استخدام نطاق المسافة.",
      "UsePolygonDeliveryConfirmTitle": "تغيير وضع منطقة التوصيل؟",
      "UsePolygonDeliveryConfirmContent": "سيؤدي هذا إلى تغيير طريقة تحديد المتاجر لمنطقة التوصيل (مضلّع بدلاً من نطاق المسافة). هل أنت متأكد أنك تريد المتابعة؟",
      "StockFromInfo": "مصدر كميات المخزون: محلي (قاعدة البيانات المحلية)، أو مخزون (يدوي)، أو تكامل (نظام خارجي مثل أودو).",
      "stockLevelInfo": "حد الكمية لمستوى تنبيه المخزون هذا؛ يميّز اللون المنتجات عند هذا الحد أو أقل.",
      "hideOutOfStockInfo": "إخفاء المنتجات غير المتوفرة في المخزون عن العملاء.",
      "TermsViewIsHTMLInfo": "عند التفعيل، يُعرض محتوى صفحة الشروط بصيغة HTML بدلًا من نص عادي.",
      "PrivacyViewIsHTMLInfo": "عند التفعيل، يُعرض محتوى صفحة الخصوصية بصيغة HTML بدلًا من نص عادي.",
      "AboutViewIsHTMLInfo": "عند التفعيل، يُعرض محتوى صفحة من نحن بصيغة HTML بدلًا من نص عادي.",
      "domainInfo": "النطاق المخصص لمتجر الشركة.",
      "websiteVersionInfo": "رقم إصدار واجهة الموقع أو التطبيق."
    },
    "sallaIdInfo": "معرّف تكامل سالا الفريد المستخدم لربط هذه الشركة بسالا.",
    "ReportMailInfo": "إرسال رسائل تقارير دورية إلى الشركة."
  },
  "units": {
    "PCS": "قطعة",
    "BOX": "علبة",
    "KG": "كجم",
    "GM": "جم",
    "LTR": "لتر",
    "ML": "مل",
    "PACK": "باكيت",
    "CARTON": "كرتونة",
    "STRIP": "شريط",
    "BOTTLE": "زجاجة"
  },
  "orderFilter": {
    "orderDateFrom": "تاريخ الطلب من",
    "orderDateTo": "تاريخ الطلب إلى",
    "deliveryDateFrom": "تاريخ التسليم من",
    "deliveryDateTo": "تاريخ التسليم إلى",
    "paymentMethod": "طريقة الدفع",
    "orderStatus": "حالة الطلب",
    "store": "المتجر",
    "orderCreator": "منشئ الطلب",
    "customerPhone": "هاتف العميل",
    "customerName": "اسم العميل",
    "barcode": "الباركود",
    "callChannel": "قناة الاتصال",
    "area": "المنطقة",
    "region": "المنطقة",
    "createdFrom": "تم الإنشاء بواسطة",
    "totalAmount": "الإجمالي",
    "orderId": "رقم الطلب",
    "deliveryTime": "وقت التسليم",
    "deliveryDate": "تاريخ التسليم",
    "phoneOrName": "الهاتف / الاسم",
    "crm": "CRM",
    "app": "التطبيق",
    "website": "الموقع الإلكتروني"
  },
  "companyDetails": {
    "title": "عرض الشركة",
    "englishName": "الاسم بالإنجليزية",
    "arabicName": "الاسم بالعربية",
    "url": "الرابط",
    "phone": "الهاتف",
    "userLimit": "حد المستخدمين",
    "shopperUserLimit": "الحد الأقصى لمستخدمي الشوبر",
    "status": "الحالة",
    "email": "البريد الإلكتروني",
    "reportMail": "بريد التقرير",
    "expiredDate": "تاريخ الانتهاء"
  },
  "invoiceDetails": {
    "title": "تفاصيل الفاتورة",
    "firstTotal": "المجموع الأول",
    "subTotal": "المجموع الفرعي",
    "deliveryFees": "رسوم التوصيل",
    "serviceFees": "رسوم الخدمة",
    "discount": "خصم",
    "youSave": "توفيرك",
    "total": "المجموع",
    "collectorTotal": "مجموع الجامع",
    "missingTotal": "المجموع المفقود",
    "refundTotal": "مجموع الاسترداد",
    "deletedTotal": "المجموع المحذوف",
    "addDiscount": "إضافة خصم",
    "updateShippingFees": "تحديث رسوم الشحن",
    "errorFetching": "خطأ في جلب تفاصيل الفاتورة",
    "stockInformation": "معلومات المخزون",
    "stockDescription": "عدد المنتجات في الفروع",
    "totalStock": "إجمالي المخزون",
    "stockByBranch": "المخزون حسب الفرع",
    "loadingStockInfo": "جاري تحميل معلومات المخزون...",
    "noStockInfo": "لا توجد معلومات مخزون متاحة",
    "stockInfoError": "فشل في تحميل معلومات المخزون",
    "minimumOrder": "الحد الأدنى للطلب",
    "loyaltyAmount": "مبلغ الولاء",
    "codeAmount": "مبلغ الكود",
    "promoCode": "كود الخصم"
  },
  "e-commerce": {
    "slider": {
      "tableTitle": "جميع الشرائح",
      "savedSuccessfully": "تم حفظ السلايدر بنجاح",
      "failedSave": "فشل في حفظ السلايدر",
      "editSlider": "تعديل سلايدر",
      "addSlider": "اضافة سلايدر",
      "fields": {
        "id": "المعرف",
        "company": "الشركة",
        "imageAlt": "صورة الشريحة",
        "type": "النوع",
        "status": "الحالة",
        "sliderType": "نوع السلايدر",
        "link": "الرابط",
        "product": "المنتج",
        "brands": "العلامات التجارية",
        "categories": "الفئات",
        "fromDate": "تاريخ البدء",
        "expireDate": "تاريخ الانتهاء",
        "fromDatePlaceholder": "اختر تاريخ البدء",
        "expireDatePlaceholder": "اختر تاريخ الانتهاء",
        "sort": "الترتيب",
        "image": "الصورة",
        "platforms": "المنصات",
        "platformsPlaceholder": "كل المنصات"
      },
      "platformsHint": "اتركه فارغًا لعرض السلايدر على كل المنصات.",
      "allPlatforms": "كل المنصات",
      "platforms": {
        "ios": "iOS",
        "android": "أندرويد",
        "website": "الموقع الإلكتروني"
      },
      "options": {
        "link": "الرابط",
        "product": "المنتج",
        "Multi product": "منتجات متعددة",
        "Brand": "العلامة التجارية",
        "Category": "الفئة",
        "Offers": "العروض",
        "Insurance": "التأمين"
      }
    },
    "flashDeal": {
      "tableTitle": "جميع العروض الفورية",
      "savedSuccessfully": "تم حفظ العرض الفوري بنجاح",
      "failedSave": "فشل في حفظ العرض الفوري",
      "editFlashDeal": "تعديل عرض فوري",
      "addFlashDeal": "إضافة عرض فوري",
      "fields": {
        "id": "المعرف",
        "nameEn": "الاسم (إنجليزي)",
        "nameAr": "الاسم (عربي)",
        "btnTextEn": "نص الزر (إنجليزي)",
        "btnTextAr": "نص الزر (عربي)",
        "type": "النوع",
        "product": "المنتج",
        "brand": "العلامة التجارية",
        "category": "الفئة",
        "expiredDate": "تاريخ الانتهاء",
        "fromDate": "تاريخ البدء",
        "toDate": "تاريخ النهاية",
        "image": "الصورة",
        "status": "الحالة"
      },
      "types": {
        "product": "منتج",
        "brand": "علامة تجارية",
        "category": "فئة"
      }
    },
    "cancelReasons": {
      "tableTitle": "جميع أسباب الإلغاء",
      "noCreatePermission": "ليس لديك صلاحية لإنشاء أسباب الإلغاء",
      "activate": "تفعيل",
      "deactivate": "إلغاء التفعيل",
      "enable": "تفعيل",
      "disable": "إلغاء التفعيل",
      "fields": {
        "id": "المعرف",
        "arabicName": "الاسم العربي",
        "englishName": "الاسم الإنجليزي",
        "status": "الحالة",
        "showInApp": "إظهار في التطبيق",
        "showInCrm": "إظهار في CRM",
        "actions": "الإجراءات"
      }
    },
    "uncompletedOrderReasons": {
      "tableTitle": "جميع أسباب الطلبات غير المكتملة",
      "noCreatePermission": "ليس لديك صلاحية لإنشاء أسباب الطلبات غير المكتملة",
      "activate": "تفعيل",
      "deactivate": "إلغاء التفعيل",
      "enable": "تفعيل",
      "disable": "إلغاء التفعيل",
      "fields": {
        "id": "المعرف",
        "arabicName": "الاسم العربي",
        "englishName": "الاسم الإنجليزي",
        "status": "الحالة",
        "actions": "الإجراءات"
      }
    },
    "promocode": {
      "allCustomers": "جميع العملاء",
      "createOptions": {
        "title": "إضافة كود خصم جديد",
        "uploadGroup": {
          "title": "رفع مجموعة أكواد خصم",
          "description": "ارفع أكواد الخصم وعملاءها بملف إكسل"
        },
        "addSingle": {
          "title": "إضافة كود خصم واحد",
          "description": "أضف أكواد الخصم واحدًا تلو الآخر بسهولة"
        },
        "downloadSample": "تحميل نموذج الملف"
      },
      "importInstructions": {
        "title": "تعليمات الاستيراد",
        "oneRowPerCustomer": "صف لكل عميل، مجمعة حسب الكود",
        "firstRowFields": "تُقرأ بيانات كود الخصم من أول صف لكل كود",
        "customerColumns": "املأ customer_id أو internal_id (رقم أودو)؛ اتركهما فارغين لجميع العملاء",
        "existingCode": "الكود الموجود يتم تحديثه واستبدال قائمة عملائه",
        "commaSeparated": "الفروع والمنتجات والعلامات التجارية والفئات أرقام مفصولة بفواصل",
        "supportedFormats": "الصيغ المدعومة"
      },
      "import": {
        "importing": "جاري استيراد أكواد الخصم...",
        "success": "تم استيراد أكواد الخصم بنجاح!",
        "created": "تم الإنشاء",
        "updated": "تم التحديث",
        "failed": "فشل",
        "failedRows": "بعض الصفوف لم يتم استيرادها:",
        "rowError": "صف {{row}}{{code}}: {{message}}",
        "moreErrors": "...و {{count}} أخرى",
        "error": "فشل استيراد أكواد الخصم. حاول مرة أخرى.",
        "fileTooLarge": "الملف كبير جدًا. الحد الأقصى 10 ميجابايت."
      },
      "tableTitle": "جميع أكواد الخصم",
      "noCreatePermission": "ليس لديك صلاحية لإنشاء أكواد الخصم",
      "noEditPermission": "ليس لديك صلاحية لتعديل أكواد الخصم",
      "noDeletePermission": "ليس لديك صلاحية لحذف أكواد الخصم",
      "savedSuccessfully": "تم حفظ كود الخصم بنجاح",
      "failedSave": "فشل في حفظ كود الخصم",
      "editPromocode": "تعديل كود الخصم",
      "addPromocode": "إضافة كود خصم",
      "fields": {
        "customers": "العملاء",
        "id": "المعرف",
        "code": "الكود",
        "discount_type": "نوع الخصم",
        "type": "النوع",
        "amount": "المبلغ",
        "startdate": "تاريخ البدء",
        "enddate": "تاريخ الانتهاء",
        "minimum": "الحد الأدنى",
        "max_count": "الحد الأقصى",
        "max_use_per_customer": "الحد الأقصى للاستخدام لكل عميل",
        "max_discount_amount": "الحد الأقصى لمبلغ الخصم",
        "status": "الحالة",
        "first_order_only": "الطلب الأول فقط",
        "promo_store": "متجر العرض",
        "stores": "المتاجر",
        "all": "الكل",
        "custom_stores": "متاجر مخصصة",
        "product": "المنتج",
        "brand": "العلامة التجارية",
        "category": "الفئة",
        "medicine_discount": "خصم الأدوية",
        "cosmetic_discount": "خصم مستحضرات التجميل",
        "accessory_discount": "خصم الإكسسوارات",
        "actions": "الإجراءات",
        "maximum": "الحد الأقصى لقيمة الطلب"
      },
      "discountTypes": {
        "fixAmount": "مبلغ ثابت",
        "percentage": "نسبة مئوية"
      },
      "types": {
        "general": "عام",
        "product": "منتج",
        "brand": "علامة تجارية",
        "category": "فئة",
        "firstorder": "الطلب الأول",
        "shipping": "الشحن"
      },
      "noLimit": "بدون حد",
      "validation": {
        "maxGreaterThanMin": "الحد الأقصى يجب أن يكون أكبر من أو يساوي الحد الأدنى"
      },
      "enable": "تفعيل",
      "disable": "إلغاء التفعيل"
    },
    "homeStaticContent": {
      "tableTitle": "كل محتويات الصفحة الرئيسية الثابتة",
      "activate": "تفعيل",
      "deactivate": "إلغاء التفعيل",
      "enable": "مفعل",
      "disable": "غير مفعل",
      "fields": {
        "id": "الرقم",
        "arabicName": "الاسم بالعربية",
        "englishName": "الاسم بالإنجليزية",
        "sortOrder": "الترتيب",
        "status": "الحالة",
        "actions": "الإجراءات"
      }
    },
    "homeLayout": {
      "tableTitle": "تخطيط الصفحة الرئيسية (تطبيق الموبايل)",
      "activate": "تفعيل",
      "deactivate": "إلغاء التفعيل",
      "enable": "مفعل",
      "disable": "غير مفعل",
      "fields": {
        "sortOrder": "الترتيب",
        "type": "نوع القسم",
        "arabicTitle": "العنوان بالعربية",
        "englishTitle": "العنوان بالإنجليزية",
        "limit": "عدد العناصر",
        "status": "الحالة",
        "actions": "الإجراءات"
      }
    },
    "prescriptionStatuses": {
      "tableTitle": "حالات الروشتة",
      "noCreatePermission": "ليس لديك صلاحية إنشاء حالات الروشتة",
      "activate": "تفعيل",
      "deactivate": "تعطيل",
      "enable": "مفعل",
      "disable": "معطل",
      "fields": {
        "code": "الكود",
        "arabicName": "الاسم بالعربي",
        "englishName": "الاسم بالإنجليزي",
        "sort": "الترتيب",
        "status": "الحالة",
        "actions": "إجراءات"
      }
    },
    "prescriptionRejectReasons": {
      "tableTitle": "أسباب رفض الروشتة",
      "noCreatePermission": "ليس لديك صلاحية إنشاء أسباب الرفض",
      "activate": "تفعيل",
      "deactivate": "تعطيل",
      "enable": "مفعل",
      "disable": "معطل",
      "fields": {
        "arabicName": "الاسم بالعربي",
        "englishName": "الاسم بالإنجليزي",
        "status": "الحالة",
        "actions": "إجراءات"
      }
    }
  },
  "homeStaticContentModal": {
    "createContent": "إنشاء محتوى ثابت",
    "editContent": "تعديل محتوى ثابت",
    "savedSuccessfully": "تم حفظ المحتوى الثابت بنجاح",
    "failedSave": "فشل في حفظ المحتوى الثابت",
    "fields": {
      "arabicName": "الاسم بالعربية",
      "englishName": "الاسم بالإنجليزية",
      "arabicContent": "المحتوى بالعربية",
      "englishContent": "المحتوى بالإنجليزية",
      "sortOrder": "الترتيب",
      "status": "الحالة"
    }
  },
  "homeBlockModal": {
    "createBlock": "إنشاء قسم للصفحة الرئيسية",
    "editBlock": "تعديل قسم الصفحة الرئيسية",
    "savedSuccessfully": "تم حفظ القسم بنجاح",
    "failedSave": "فشل في حفظ القسم",
    "titleHint": "اتركه فارغاً لاستخدام العنوان الافتراضي في التطبيق",
    "fields": {
      "type": "نوع القسم",
      "arabicTitle": "العنوان بالعربية",
      "englishTitle": "العنوان بالإنجليزية",
      "limit": "عدد العناصر",
      "sortOrder": "الترتيب",
      "status": "الحالة"
    }
  },
  "homeBlockTypes": {
    "slider": "السلايدر الرئيسي",
    "categories": "الفئات الشائعة",
    "flash_deal": "عروض اليوم",
    "sections": "الأقسام المختارة",
    "brands": "تسوق حسب الماركة",
    "recommendations": "مقترحات لك",
    "videos_short": "فيديوهات قصيرة",
    "videos_wellness": "فيديوهات العافية",
    "blogs": "مقالات صحية",
    "symptoms": "تسوق حسب الأعراض",
    "static_contents": "المحتوى الثابت"
  },
  "homeLayoutBuilder": {
    "pageHint": "اسحب الأقسام لإعادة ترتيب الصفحة الرئيسية للتطبيق. يتم الحفظ تلقائياً.",
    "availableBlocks": "الأقسام المتاحة",
    "paletteHint": "اسحب القسم إلى الهاتف، أو اضغط + لإضافته في النهاية.",
    "allUsed": "كل الأقسام موجودة في الصفحة الرئيسية.",
    "saving": "جارٍ الحفظ...",
    "emptyHint": "لا يوجد تخطيط بعد: يعرض التطبيق الترتيب الافتراضي. اسحب الأقسام هنا أو ابدأ من الترتيب الافتراضي.",
    "startFromDefault": "ابدأ من التخطيط الافتراضي",
    "hidden": "مخفي في التطبيق",
    "editBlock": "تعديل القسم",
    "selectHint": "اضغط على قسم في الهاتف لتعديل العنوان وعدد العناصر والظهور.",
    "contentHint": "يتم إدارة المحتوى من",
    "contentLinks": {
      "slider": "السلايدر",
      "flash_deal": "العروض الفورية",
      "sections": "الأقسام",
      "videos_short": "الفيديوهات",
      "videos_wellness": "الفيديوهات",
      "blogs": "المقالات الصحية",
      "symptoms": "تسوق حسب الأعراض",
      "static_contents": "محتوى الصفحة الرئيسية الثابت"
    },
    "visibleInApp": "ظاهر في التطبيق",
    "removeConfirm": "إزالة هذا القسم من الصفحة الرئيسية؟",
    "removeBlock": "إزالة من الصفحة الرئيسية",
    "saveFailed": "تعذر حفظ التغيير",
    "orderSaved": "تم حفظ الترتيب",
    "blockAdded": "تمت إضافة القسم",
    "defaultCreated": "تم إنشاء التخطيط الافتراضي",
    "blockRemoved": "تمت إزالة القسم",
    "blockSaved": "تم حفظ القسم",
    "showInApp": "إظهار في التطبيق",
    "hideInApp": "إخفاء في التطبيق"
  },
  "mobileContent": {
    "blogsTitle": "المقالات الصحية (تطبيق الموبايل)",
    "videosTitle": "الفيديوهات (تطبيق الموبايل)",
    "symptomsTitle": "تسوق حسب الأعراض (تطبيق الموبايل)",
    "activate": "تفعيل",
    "deactivate": "إلغاء التفعيل",
    "enable": "مفعل",
    "disable": "غير مفعل",
    "fields": {
      "id": "الرقم",
      "image": "الصورة",
      "arabicTitle": "العنوان بالعربية",
      "englishTitle": "العنوان بالإنجليزية",
      "arabicName": "الاسم بالعربية",
      "englishName": "الاسم بالإنجليزية",
      "author": "الكاتب",
      "publishedAt": "تاريخ النشر",
      "row": "قسم الصفحة الرئيسية",
      "products": "المنتجات",
      "sortOrder": "الترتيب",
      "status": "الحالة",
      "actions": "الإجراءات"
    }
  },
  "blogModal": {
    "createBlog": "إنشاء مقال",
    "editBlog": "تعديل مقال",
    "savedSuccessfully": "تم حفظ المقال بنجاح",
    "failedSave": "فشل في حفظ المقال",
    "publishHint": "فارغ = يظهر الآن؛ تاريخ مستقبلي يجدول النشر",
    "fields": {
      "arabicTitle": "العنوان بالعربية",
      "englishTitle": "العنوان بالإنجليزية",
      "arabicExcerpt": "الملخص بالعربية",
      "englishExcerpt": "الملخص بالإنجليزية",
      "arabicBody": "المحتوى بالعربية",
      "englishBody": "المحتوى بالإنجليزية",
      "author": "الكاتب",
      "publishedAt": "تاريخ النشر",
      "sortOrder": "الترتيب",
      "status": "الحالة",
      "coverImage": "صورة الغلاف"
    }
  },
  "videoModal": {
    "createVideo": "إنشاء فيديو",
    "editVideo": "تعديل فيديو",
    "savedSuccessfully": "تم حفظ الفيديو بنجاح",
    "failedSave": "فشل في حفظ الفيديو",
    "invalidUrl": "أدخل رابطاً صحيحاً",
    "selectProducts": "اختر المنتجات...",
    "fields": {
      "type": "قسم الصفحة الرئيسية",
      "arabicTitle": "العنوان بالعربية",
      "englishTitle": "العنوان بالإنجليزية",
      "arabicDescription": "الوصف بالعربية",
      "englishDescription": "الوصف بالإنجليزية",
      "videoUrl": "رابط الفيديو",
      "duration": "المدة (بالثواني)",
      "products": "المنتجات المرتبطة",
      "thumbnail": "الصورة المصغرة",
      "sortOrder": "الترتيب",
      "status": "الحالة"
    }
  },
  "videoTypes": {
    "short": "فيديوهات قصيرة",
    "wellness": "فيديوهات العافية"
  },
  "symptomModal": {
    "createSymptom": "إضافة عَرَض مرضي",
    "editSymptom": "تعديل عَرَض مرضي",
    "savedSuccessfully": "تم حفظ العَرَض المرضي بنجاح",
    "failedSave": "فشل في حفظ العَرَض المرضي",
    "selectProducts": "اختر المنتجات...",
    "fields": {
      "arabicName": "الاسم بالعربية",
      "englishName": "الاسم بالإنجليزية",
      "products": "المنتجات",
      "image": "الصورة",
      "sortOrder": "الترتيب",
      "status": "الحالة"
    }
  },
  "cancelReasonModal": {
    "createCancelReason": "إنشاء سبب إلغاء",
    "editCancelReason": "تعديل سبب إلغاء",
    "savedSuccessfully": "تم حفظ سبب الإلغاء بنجاح",
    "failedSave": "فشل في حفظ سبب الإلغاء",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء أسباب الإلغاء",
    "noEditPermission": "ليس لديك صلاحية لتعديل أسباب الإلغاء",
    "fields": {
      "arabicName": "الاسم العربي",
      "englishName": "الاسم الإنجليزي",
      "status": "الحالة",
      "showInApp": "إظهار في التطبيق",
      "showInCrm": "إظهار في CRM"
    }
  },
  "uncompletedOrderReasonModal": {
    "createReason": "إنشاء سبب طلب غير مكتمل",
    "editReason": "تعديل سبب طلب غير مكتمل",
    "savedSuccessfully": "تم حفظ سبب الطلب غير المكتمل بنجاح",
    "failedSave": "فشل في حفظ سبب الطلب غير المكتمل",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء أسباب الطلبات غير المكتملة",
    "noEditPermission": "ليس لديك صلاحية لتعديل أسباب الطلبات غير المكتملة",
    "fields": {
      "arabicName": "الاسم العربي",
      "englishName": "الاسم الإنجليزي",
      "status": "الحالة"
    }
  },
  "sliderList": {
    "noCreatePermission": "ليس لديك صلاحية لإنشاء الشرائح",
    "noEditPermission": "ليس لديك صلاحية لتعديل الشرائح",
    "noDeletePermission": "ليس لديك صلاحية لحذف الشرائح"
  },
  "sliderModal": {
    "noCreatePermission": "ليس لديك صلاحية لإنشاء الشرائح",
    "noEditPermission": "ليس لديك صلاحية لتعديل الشرائح"
  },
  "tableFiltersModal": {
    "filter": "تصفية",
    "filterBy": "تصفية حسب",
    "apply": "تطبيق",
    "cancel": "إلغاء",
    "reset": "إعادة ضبط"
  },
  "table": {
    "search": "البحث",
    "id": "الرقم التعريفي",
    "edit": "تعديل",
    "exportExcel": "تصدير إكسل",
    "of": "من",
    "entries": "مدخلات"
  },
  "orders": {
    "tableTitle": "الطلبات",
    "activeTableTitle": "الطلبات النشطة",
    "order": "الطلب",
    "items": "الاصناف",
    "columns": {
      "id": "المعرف",
      "creator": "المنشئ",
      "customerName": "الاسم",
      "customerSegment": "تصنيف العميل",
      "telephone": "الهاتف",
      "store": "المتجر",
      "region": "المنطقة",
      "area": "الحي",
      "orderStatus": "حالة الطلب",
      "createdFrom": "تم الإنشاء بواسطة",
      "createdAt": "تاريخ الإنشاء",
      "deliveryDate": "تاريخ التسليم",
      "actions": "الإجراءات",
      "call_channel": "قناة الاتصال",
      "order_timer": "عمر الطلب",
      "pickup": "استلام",
      "transferred": "منقول",
      "item_count": "الاصناف",
      "total": "المجموع",
      "sub_total": "المجموع الفرعي",
      "total_after_discount": "المجموع بعد الخصم",
      "loyalty_discount": "خصم الولاء",
      "delivery_time": "وقت التوصيل",
      "address": "الشارع / العنوان"
    },
    "actions": {
      "track": "تتبع",
      "print": "طباعة",
      "transferSelected": "نقل",
      "show": "عرض",
      "assign": "تعيين"
    },
    "noAssignPermission": "ليس لديك صلاحية لتعيين الطلبات",
    "selectOrdersToTransfer": "حدد الطلبات المراد نقلها",
    "noTransferAllowed": "النقل غير متاح (يتطلب صلاحية، طلب مفتوح، خلال 30 دقيقة)",
    "transferOrderClosed": "الطلب ملغي أو منتهي — لا يمكن النقل",
    "transferWindowExpired": "انتهت المهلة المسموح بها لنقل هذا الطلب",
    "noTrackPermission": "ليس لديك صلاحية لتتبع الطلبات",
    "noShowPermission": "ليس لديك صلاحية لعرض تفاصيل الطلب",
    "noPrintPermission": "ليس لديك صلاحية لطباعة الطلبات",
    "noChangeStatusPermission": "ليس لديك صلاحية لتغيير حالة الطلب",
    "noChangeAddressPermission": "ليس لديك صلاحية لتغيير عنوان الطلب",
    "noChangeDeliveryTimePermission": "ليس لديك صلاحية لتغيير وقت التوصيل",
    "noShippingUpdatePermission": "ليس لديك صلاحية لتحديث معلومات الشحن",
    "noTransferPermission": "ليس لديك صلاحية لنقل الطلبات",
    "noUpdatePermission": "ليس لديك صلاحية لتحديث الطلبات",
    "noDeletePermission": "ليس لديك صلاحية لحذف عناصر الطلب",
    "noEditPermission": "ليس لديك صلاحية لتعديل عناصر الطلب",
    "noAddProductPermission": "ليس لديك صلاحية لإضافة منتجات للطلب",
    "noAddDiscountPermission": "ليس لديك صلاحية لإضافة خصم للطلب",
    "pdfDownloadError": "حدث خطأ أثناء تحميل ملف PDF. يرجى المحاولة مرة أخرى.",
    "popupBlocked": "يرجى السماح بالنوافذ المنبثقة لمعاينة الطلب.",
    "noTokenError": "رمز المصادقة غير موجود. يرجى تسجيل الدخول مرة أخرى.",
    "errorLoadingOrder": "خطأ في تحميل الطلب",
    "errorLoadingOrderDescription": "حدث خطأ في تحميل تفاصيل الطلب. يرجى المحاولة مرة أخرى.",
    "orderStatusGroupProgress": "تقدّم مجموعة الحالة",
    "orderStatusGroupSection": "مجموعة حالة الطلب",
    "printPreview": "معاينة الطباعة",
    "printA4": "طباعة ورق A4",
    "printReceipt": "طباعة الإيصال"
  },
  "orderDetails": {
    "orderId": "رقم الطلب",
    "customerId": "رقم العميل",
    "customerName": "اسم العميل",
    "phone": "الهاتف",
    "phone2": "الهاتف 2",
    "orderStatus": "حالة الطلب",
    "customerAddress": "عنوان العميل",
    "storeName": "اسم المتجر",
    "registeredPhone": "الهاتف المسجل",
    "deliveryDate": "تاريخ التسليم",
    "createdAt": "تاريخ الإنشاء",
    "orderBuilder": "باني الطلب",
    "pickup": "استلام",
    "requiredCalling": "مطلوب اتصال",
    "customerSegment": "تصنيف العميل",
    "chooseCustomerSegment": "اختر تصنيف العميل",
    "segmentUpdateSuccess": "تم تحديث تصنيف العميل بنجاح",
    "segmentUpdateError": "فشل تحديث تصنيف العميل",
    "customerComment": "تعليق العميل",
    "collectorComment": "تعليق المجمع",
    "driverComment": "تعليق السائق",
    "agentComment": "تعليق الوكيل",
    "paymentType": "طريقة الدفع",
    "billingComment": "تعليق الفاتورة",
    "transferOrder": "نقل الطلب",
    "transferTimeRemaining": "الوقت المتبقي للنقل",
    "yes": "نعم",
    "no": "لا",
    "image": "الصورة",
    "productName": "اسم المنتج",
    "qty": "الكمية",
    "barcode": "الباركود",
    "unitPrice": "سعر الوحدة",
    "total": "الإجمالي",
    "notes": "ملاحظات",
    "products": "المنتجات",
    "printA4": "طباعة A4",
    "finalTotal": "الإجمالي النهائي",
    "dms": "التوصيل",
    "odoo": "أودو",
    "odooId": "المعرف",
    "odooPosReference": "المرجع",
    "thanksSmsSentAt": "تاريخ رسالة الشكر",
    "viewRefund": "عرض الاسترجاع",
    "odooRefund": "استرجاع أودو",
    "refundFullOrder": "استرجاع الطلب بالكامل",
    "odooRefundConfirm": "هل تريد استرجاع الطلب بالكامل إلى أودو؟",
    "odooRefundSuccess": "تم استرجاع الطلب إلى أودو بنجاح",
    "odooRefundFailed": "فشل استرجاع الطلب إلى أودو",
    "refundSummaryFetchFailed": "فشل جلب ملخص الاسترجاع",
    "noRefunds": "لا توجد مرتجعات",
    "refundCount": "عدد المرتجعات",
    "totalRefundedQty": "إجمالي الكمية المرتجعة",
    "refundId": "معرف الاسترجاع",
    "refundState": "الحالة",
    "refundedAt": "تاريخ الاسترجاع",
    "refundTotalQty": "إجمالي الكمية",
    "refundProduct": "المنتج",
    "refundQty": "الكمية",
    "refundOrderItemId": "معرف عنصر الطلب",
    "refundLineId": "معرف سطر الاسترجاع",
    "refundHistoryNoPermission": "ليس لديك صلاحية لعرض سجل المرتجعات",
    "collectorName": "اسم المجمع",
    "driverName": "اسم السائق",
    "invoiceLink": "رابط الفاتورة",
    "attachInvoiceLink": "إرفاق رابط الفاتورة",
    "invoiceNumber": "رقم الفاتورة",
    "invoiceNumberRequired": "رقم الفاتورة مطلوب",
    "invoiceUrl": "رابط الفاتورة",
    "invoiceUrlOptionalHelp": "اتركه فارغًا للبناء التلقائي من الإعدادات",
    "viewInvoice": "عرض الفاتورة",
    "copyInvoiceLink": "نسخ رابط الفاتورة",
    "invoicePaid": "مدفوع",
    "invoiceUnpaid": "غير مدفوع",
    "invoiceProvider": "مزود الفاتورة",
    "noInvoiceYet": "لا توجد فاتورة بعد",
    "invoiceLinkAttached": "تم إرفاق رابط الفاتورة بنجاح",
    "invoiceLinkAttachFailed": "فشل في إرفاق رابط الفاتورة",
    "invoiceLinkCopied": "تم نسخ رابط الفاتورة",
    "invoiceLinkCopyFailed": "فشل في نسخ رابط الفاتورة",
    "customerInfo": "بيانات العميل",
    "communications": "الاتصالات",
    "addressPhone": "هاتف العنوان",
    "additionalAddressPhone": "هاتف العنوان الإضافي",
    "orderInfo": "بيانات الطلب",
    "deliveryTime": "وقت التسليم",
    "comments": "التعليقات",
    "rateComment": "تعليق التقييم",
    "transferComment": "تعليق التحويل",
    "customerServiceComment": "تعليق خدمة العملاء",
    "branchComment": "تعليق الفرع",
    "receiptNumber": "رقم الإيصال",
    "viewDriverRoute": "عرض المسار على الخريطة",
    "viewOnOdoo": "عرض في أودو",
    "redirectingToOdoo": "جاري التحويل إلى أودو...",
    "paymentInfo": "بيانات الدفع",
    "refundRequested": "تم طلب الاسترداد",
    "refundFailed": "فشل طلب الاسترداد",
    "refund": "استرداد",
    "attachments": "المرفقات",
    "updateOrderAction": "تحديث الطلب",
    "updateOrderSuccess": "تم تحديث الطلب بنجاح",
    "updateOrderFailed": "فشل في تحديث الطلب",
    "calculateOrderTotalAction": "إعادة حساب المجموع",
    "calculateOrderTotalSuccess": "تم إعادة حساب مجموع الطلب بنجاح",
    "calculateOrderTotalFailed": "فشل في إعادة حساب مجموع الطلب",
    "orderType": "نوع الطلب",
    "orderTypePickup": "استلام من الفرع",
    "orderTypeDelivery": "توصيل",
    "street": "الشارع",
    "buildingNumber": "رقم المبنى",
    "floorNumber": "رقم الطابق",
    "flatNumber": "رقم الشقة",
    "landMark": "علامة مميزة",
    "address": "العنوان",
    "paymentMethod": "طريقة الدفع"
  },
  "paymentTypes": {
    "cashOnDelivery": "الدفع عند الاستلام",
    "visaOnDelivery": "فيزا عند الاستلام",
    "visaOnline": "فيزا أونلاين",
    "unknown": "طريقة دفع غير معروفة"
  },
  "paymentModal": {
    "updateError": "خطأ في تحديث الدفع",
    "modalTitle": "تغيير  الدفع",
    "required": "مطلوب",
    "label": "تغيير  طريقة الدفع",
    "updateSuccess": "تم تحديث طريقة الدفع بنجاح",
    "noPermission": "ليس لديك صلاحية لتغيير طريقة الدفع"
  },
  "headerBar": {
    "updateOrderStatus": "تحديث حالة الطلب",
    "assignTo": "تعيين إلى",
    "assignDeliveryRep": "تعيين إلى مندوب التوصيل",
    "assignShopper": "تعيين إلى المجمع",
    "refreshSuccess": "تم تحديث الطلب بنجاح!",
    "refreshFailed": "فشل في تحديث الطلب.",
    "updateOrderModify": "تعديل الطلب"
  },
  "status": {
    "pending": "قيد الانتظار",
    "processing": "قيد المعالجة",
    "assigned": "تم التعيين",
    "inTransit": "قيد التوصيل",
    "delivered": "تم التوصيل",
    "cancelled": "ملغى"
  },
  "modal": {
    "updateStatusTitle": "تحديث الحالة",
    "selectStatus": "اختر الحالة",
    "updateStatus": "تحديث الحالة",
    "assignDeliveryRepTitle": "تعيين إلى مندوب التوصيل",
    "assignRep": "تعيين المندوب",
    "assignShopperTitle": "تعيين إلى المجمع",
    "assignShopper": "تعيين المجمع",
    "selectCancelReason": "اختر سبب الإلغاء",
    "cancelReason": "سبب الإلغاء",
    "canceledBy": "تم الإلغاء بواسطة",
    "comment": "تعليق",
    "cancelReasonRequired": "سبب الإلغاء مطلوب",
    "canceledByRequired": "الشخص الذي ألغى مطلوب",
    "enterCancelReason": "أدخل سبب الإلغاء",
    "enterCanceledBy": "أدخل من ألغى",
    "enterComments": "أدخل التعليقات"
  },
  "orderTabs": {
    "orderDetails": "تفاصيل الطلب",
    "shippingDetails": "تفاصيل الشحن"
  },
  "transfer": {
    "order": {
      "title": "نقل الطلب"
    },
    "bulk": {
      "title": "نقل الطلبات",
      "selectedOrders": "الطلبات المحددة"
    },
    "branch": {
      "label": "الفرع",
      "required": "الرجاء اختيار الفرع",
      "placeholder": "اختر الفرع لنقل الطلب إليه",
      "current": "الفرع الحالي",
      "main": "الفرع الرئيسي",
      "help": "الفرع الحالي للطلب محدد ولا يمكن اختياره."
    },
    "reason": {
      "label": "السبب",
      "required": "الرجاء إدخال السبب",
      "placeholder": "أدخل سبب النقل"
    },
    "actionBy": {
      "label": "تم بواسطة",
      "required": "الرجاء اختيار من قام بهذا الإجراء",
      "placeholder": "اختر من قام بالإجراء",
      "options": {
        "admin": "المشرف",
        "manager": "المدير",
        "operator": "المشغل"
      }
    },
    "error": "خطأ في نقل الطلب",
    "success": "تم نقل الطلب بنجاح!"
  },
  "time": {
    "days": "يوم",
    "hours": "ساعة",
    "minutes": "دقيقة",
    "seconds": "ثانية"
  },
  "chatFilter": {
    "All": "الكل",
    "Admin": "مدير النظام",
    "Agent": "عميل",
    "Supervisor": "مشرف",
    "Unknown_Contacts": "عملاء غير معروفة",
    "Unread_Messages": "محادثات غير مقروءة",
    "Status_Count": "عدد الحالات",
    "Chats": "المحادثات",
    "Comments": "تعليق",
    "Groups": "مجموعات",
    "search_for": "البحث",
    "Messages": "الرسائل",
    "Users": "المستخدمين",
    "Manage": "ادارة"
  },
  "chatContent": {
    "Move_To_Done": "تحويل الى انتهت",
    "Assign_conversation": "ارسال الى",
    "conversations_selected": "المحادثات المختارة",
    "Mark_as_Follow_up": "بتمييز المتابعة",
    "Mark_as_Unread": "تمييز غير مقروءة",
    "Remove_Follow_up": "حذف المتابعة",
    "Delete_Conversation": "جدف المحادثة",
    "Mark_As_Follow_up": "بتمييز المتابعة"
  },
  "chatHeader": {
    "Contact_Updated_Successfully": "تم تحديث البيانات",
    "Are_sure_restore_contact": "هل متاكدة من اعادة العميل",
    "Restore_Contact": "اعادة",
    "Are_sure_delete_contact": "هل متاكد من حذف العميل",
    "Delete_Contact": "حذف العميل",
    "Contact_Info": "معلومات العميل",
    "Remove_Pin": "إزالة الدبوس",
    "Pin": "Pin",
    "Unmute": "الغاء كتم الصوت",
    "mute": "كتم الصوت",
    "Mark_as_Processing": "وضع علامة كمعالجة",
    "Pending": "قيد الانتظار",
    "Mark_as_Pending": "وضع علامة قيد الانتظار",
    "Follow_up": "متابعة",
    "Mark_as_Follow_up": "وضع علامة متابعة",
    "Move_to_done": "تحويل ",
    "Add_Tags": "تحويل الى انتهت",
    "Deleted": "محذوف",
    "successfully": "ناجح",
    "Contact": "عميل",
    "Processing": "قيد المعالجة",
    "Unassigned": "غير معين",
    "Done": "انتهت",
    "Follow_Up": "متابعه",
    "Group": "مجموعة"
  },
  "usersList": {
    "tableTitle": "جميع المستخدمين",
    "addUser": "إضافة مستخدم",
    "editUser": "تعديل المستخدم",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المستخدمين",
    "selectAll": "اختر الكل",
    "deselectAll": "إلغاء اختيار الكل",
    "stores": "متاجر",
    "roles": "أدوار",
    "customizeColumns": "تخصيص الأعمدة",
    "columns": {
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "username": "اسم المستخدم",
      "password": "كلمة المرور",
      "type": "نوع المستخدم",
      "showOwnOrdersOnly": "عرض طلباتي فقط",
      "showStoreTicketsOnly": "عرض تذاكر المتجر فقط",
      "showStoreTicketsOnlyDescription": "عند التمكين، يمكن لهذا الوكيل رؤية التذاكر التي تنتمي إلى متاجره المعينة فقط ولا يمكنه عرض التذاكر من المتاجر الأخرى.",
      "showReportsOnlyForAssignedStores": "عرض التقارير فقط للمتاجر المعينة",
      "showReportsOnlyForAssignedStoresDescription": "عند التمكين، يمكن لهذا الوكيل عرض التقارير لمتاجره المعينة فقط ولا يمكنه الوصول إلى التقارير من المتاجر الأخرى.",
      "assignedStores": "المتاجر المعينة",
      "assignedRoles": "الأدوار المعينة",
      "enterName": "أدخل الاسم",
      "enterEmail": "أدخل البريد الإلكتروني",
      "enterUsername": "أدخل اسم المستخدم",
      "enterPassword": "أدخل كلمة المرور",
      "selectType": "اختر نوع المستخدم",
      "selectStores": "اختر المتاجر",
      "selectRoles": "اختر الأدوار",
      "rolesRequired": "يرجى اختيار دور واحد على الأقل",
      "storesRequired": "يرجى اختيار متجر واحد على الأقل",
      "invalidUserType": "نوع المستخدم المحدد غير مسموح",
      "cannotCreateAdminAwfar": "لا يمكنك إنشاء مستخدمي أوفار",
      "invalidEmail": "يرجى إدخال بريد إلكتروني صحيح",
      "passwordMinLength": "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
      "updatedSuccessfully": "تم تحديث المستخدم بنجاح",
      "savedSuccessfully": "تم حفظ المستخدم بنجاح",
      "failedUpdate": "فشل في تحديث المستخدم",
      "failedSave": "فشل في حفظ المستخدم"
    },
    "types": {
      "adminAwfar": "مدير أوفار",
      "adminCompany": "مدير الشركة",
      "agent": "وكيل",
      "store": "متجر"
    },
    "loadingStores": "جاري تحميل المتاجر...",
    "selectedStores": "تم اختيار {count} متاجر",
    "failedLoadStores": "فشل في تحميل المتاجر. يرجى المحاولة مرة أخرى.",
    "deselectedAllStores": "تم إلغاء اختيار جميع المتاجر",
    "loadingRoles": "جاري تحميل الأدوار...",
    "selectedRoles": "تم اختيار {count} أدوار",
    "failedLoadRoles": "فشل في تحميل الأدوار. يرجى المحاولة مرة أخرى.",
    "deselectedAllRoles": "تم إلغاء اختيار جميع الأدوار"
  },
  "customizeColumns": {
    "pageTitle": "تخصيص الأعمدة",
    "previewTitle": "معاينة: ما سيراه هذا المستخدم",
    "views": {
      "orders": "الطلبات",
      "categories": "الفئات"
    },
    "idAlwaysIncluded": "المعرف (مضمن دائمًا)",
    "confirmEmptyTitle": "حفظ تحديد أعمدة فارغ؟",
    "confirmEmpty": "سيؤدي هذا إلى إخفاء جميع الأعمدة تقريبًا — سيبقى المعرف فقط ظاهرًا. هل تريد المتابعة؟",
    "save": "حفظ",
    "cancel": "إلغاء",
    "saveSuccess": "تم تحديث إعدادات الأعمدة",
    "errors": {
      "forbidden": "ليس لديك صلاحية لإدارة العروض المخصصة لهذا المستخدم",
      "loadFailed": "فشل في تحميل إعدادات الأعمدة",
      "invalidColumn": "عمود واحد أو أكثر من الأعمدة المحددة غير صالح لهذا العرض",
      "saveFailed": "فشل في حفظ إعدادات الأعمدة"
    }
  },
  "moveToDone": {
    "Chat_Reason": "سبب المحادثة",
    "Chat_Type_is_required": "نوع المحادثة مطلوب",
    "Select_Chat_Type": "اختر نوع المحادثة",
    "Leave_a_Comment": "أضف تعليق",
    "Status_Change_to": "حالة التغيير إلى",
    "Chat_Type": "نوع المحادثة"
  },
  "CustomerInfo": {
    "Customer_Info": "معلومات العميل",
    "User_Name": "اسم المستخدم",
    "Excel_Name": "اسم اكسل",
    "Whatsapp_Name": "اسم واتساب",
    "Conversation_Phone": "هاتف المحادثة",
    "Customer_Phone": "هاتف العميل",
    "Customer_Email": "بريد العميل الإلكتروني",
    "Customer_Address": "عنوان العميل",
    "Customer_Comment": "تعليق العميل",
    "Customer_New_Location": "موقع العميل الجديد",
    "Drop_location_here": "ضع الموقع هنا",
    "location_updated": "تم تغيير العنوان بنجاح",
    "Customer_Location": "موقع العميل",
    "Customer_Tags": "علامات العميل",
    "Star_Messages": "الرسائل المميزة"
  },
  "alternativeProducts": {
    "title": "المنتجات البديلة",
    "id": "الرقم",
    "name": "الاسم",
    "price": "السعر",
    "quantity": "الكمية",
    "comment": "تعليق",
    "select": "اختر"
  },
  "orderItems": {
    "name": "الاسم",
    "quantity": "الكمية",
    "returned": "المرتجع",
    "unit": "الوحدة",
    "attributes": "الخصائص",
    "extras": "الإضافات",
    "status": "الحالة",
    "barcode": "الباركود",
    "unitPrice": "سعر الوحدة",
    "totalPrice": "السعر الإجمالي",
    "remove_offer": "حذف العرض",
    "edit_offer": "تعديل العرض",
    "add-more-products": "+ إضافة منتج جديد",
    "clickToViewAll": "انقر لعرض الكل",
    "productDetails": "تفاصيل المنتج",
    "noAttributesOrExtras": "لا توجد خصائص أو إضافات متاحة لهذا المنتج",
    "adjustedByShopper": "تم التعديل بواسطة المُحضّر",
    "weightTooltipOriginal": "الأصلي: {{quantity}} {{unit}}",
    "weightTooltipReported": "المُبلَّغ عنه: {{weight}} {{unit}}",
    "originalQuantity": "الكمية المطلوبة أصلاً: {{quantity}}",
    "remainingQuantity": "الكمية بعد المرتجع",
    "pickedQuantity": "الكمية المُجمّعة",
    "returnedTooltip": "المرتجع: {{returned}}\nالمتبقي: {{remaining}}",
    "returnedAmount": "المبلغ المسترد: {{amount}}",
    "viewComments": "عرض التعليقات",
    "comments": "التعليقات",
    "customerComment": "تعليق العميل",
    "shopperComment": "تعليق المجمع",
    "returnItem": "إرجاع",
    "returnItemTitle": "إرجاع منتج",
    "returnedQty": "الكمية المرتجعة",
    "returnRemaining": "المتبقي: {{qty}}",
    "returnQtyRequired": "أدخل الكمية المراد إرجاعها",
    "returnQtyPositive": "يجب أن تكون الكمية أكبر من صفر",
    "returnQtyExceeds": "لا يمكن إرجاع أكثر من {{qty}}",
    "returnReason": "السبب",
    "returnReasonPlaceholder": "اختياري",
    "editCollectedWeight": "تعديل الوزن المُجمَّع",
    "collectedWeight": "الوزن المُجمَّع",
    "collectedWeightRequired": "أدخل الوزن المُجمَّع",
    "collectedWeightPositive": "يجب أن يكون الوزن أكبر من صفر",
    "clearCollectedWeight": "مسح الوزن",
    "saveCollectedWeight": "حفظ",
    "orderedQuantity": "المطلوب: {{qty}} {{unit}}"
  },
  "editProduct": {
    "title": "تعديل المنتج",
    "addNewProductTitle": "اضف منتج جديد",
    "selectProduct": "اختر منتج",
    "quantity": "الكمية",
    "price": "السعر",
    "comment": "ملاحظة على المنتج",
    "cancel": "إلغاء",
    "submit": "حفظ",
    "quantityRequired": "الكمية مطلوبة",
    "quantityMustBePositive": "يجب أن تكون الكمية أكبر من 0",
    "quantityMustBeInteger": "يجب أن تكون الكمية رقمًا صحيحًا",
    "quantityBelowMin": "أقل كمية مسموح بها {{min}}",
    "quantityExceedsStock": "الكمية أكبر من المخزون المتاح ({{stock}})"
  },
  "orderSummary": {
    "statusChangeSuccess": "تم تغيير الحالة بنجاح",
    "statusChangeError": "فشل في تغيير الحالة",
    "driverAssignSuccess": "تم تعيين السائق بنجاح",
    "driverAssignError": "فشل في تعيين السائق",
    "shopperAssignSuccess": "تم تعيين المتسوق بنجاح",
    "shopperAssignError": "فشل في تعيين المتسوق",
    "itemDeleteSuccess": "تم حذف المنتج بنجاح",
    "itemDeleteError": "فشل في حذف المنتج",
    "itemUpdateSuccess": "تم تحديث المنتج بنجاح",
    "itemUpdateError": "فشل في تحديث المنتج",
    "itemReturnSuccess": "تم إرجاع المنتج بنجاح",
    "itemReturnError": "فشل في إرجاع المنتج",
    "reportedWeightUpdateSuccess": "تم تحديث الوزن المُجمَّع",
    "reportedWeightUpdateError": "فشل في تحديث الوزن المُجمَّع",
    "offerDeleteSuccess": "تم حذف العرض بنجاح",
    "offerDeleteError": "فشل في حذف العرض",
    "offerUpdateSuccess": "تم تحديث العرض بنجاح",
    "offerUpdateError": "فشل في تحديث العرض",
    "offerLoadError": "فشل في تحميل تفاصيل العرض",
    "itemAddedSuccess": "تم إضافة المنتج بنجاح.",
    "itemAddError": "فشل في إضافة المنتج. حاول مرة أخرى.",
    "weightAdjustmentsBanner": "قام المُحضّر بتسجيل أوزان جديدة لعدد {{count}} من المنتجات. تم تحديث الإجمالي تلقائياً.",
    "updateOrderModifySuccess": "تم تحديث الطلب بنجاح",
    "updateOrderModifyError": "فشل في تحديث الطلب"
  },
  "SettingSideMenu": {
    "WhatsApp": "واتساب",
    "Facebook": "فيس بوك"
  },
  "SendNewNumber": {
    "Send_New_Message": "إرسال رسالة جديدة",
    "Enter_Phone_Message_Send": "أدخل رقم الهاتف لإرسال الرسالة",
    "Phone_is_required": "رقم الهاتف مطلوب",
    "Must_valid_number": "يجب أن يكون رقمًا صالحًا",
    "Must_be_required": "يجب أن يكون مطلوبًا",
    "Leave_a_Comment": "أضف تعليق"
  },
  "MessagesMenuActions": {
    "delete_message": "حذف الرسالة",
    "Star": "مميّز",
    "Click_To_Copy": "انقر للنسخ",
    "Save_Location": "حفظ الموقع",
    "Reply": "رد",
    "Add_Note": "إضافة ملاحظة",
    "Forward": "إعادة توجيه",
    "Copied_to_Clipboard": "تم النسخ إلى الحافظة",
    "Save_All": "حفظ الكل",
    "reaction_success": "reacted added successfully",
    "reaction_fail": "failed to add emoji reaction"
  },
  "SendToDriver": {
    "Send_To_Driver": "إرسال إلى سائق",
    "Driver_is_required": "السائق مطلوب!",
    "Select_Driver": "إختر سائق",
    "comment": "تعليق",
    "price": "السعر",
    "Order_Id": "رقم الطلب",
    "Cash": "نقدي",
    "Visa": "فيزا",
    "Paid": "مدفوع",
    "Note_This_doesnt_saved_Location": "ملاحظة: هذا العميل ليس لديه موقع محفظ"
  },
  "ChatFooter": {
    "attach": "إرفاق",
    "file": "ملف",
    "send_ex_file": "إرسال ملف خارجي",
    "Stop_Recording": "إيقاف التسجيل",
    "type_your_message": "اكتب رسالتك ...",
    "choose_template": "اختر تمبليت",
    "send_template_failed": "فشل ارسال التمبليت",
    "not_connected_instance": "هذا الرقم غير متصل"
  },
  "MessageNoteModal": {
    "attach": "إرفاق",
    "Note_Added_Successfully": "تمت إضافة الملاحظة بنجاح",
    "Note_From": "ملاحظة من",
    "Add_Note": "إضافة ملاحظة",
    "note_is_required": "مطلوب ملاحظة"
  },
  "SelectImageModal": {
    "select_one": "اختر صورة واحدة للرد عليها"
  },
  "CommentComponent": {
    "See_Chat": "عرض المحادثة",
    "send_message": "إرسال رسالة",
    "Tag": "إشارة",
    "Like": "أعجبني",
    "Delete_Comment": "حذف التعليق",
    "Hide_Comment": "إخفاء التعليق",
    "Block_User": "حظر المستخدم",
    "User_Blocked_Successfully": "تم حظر المستخدم بنجاح",
    "Comment_Updated_Successfully": "تم تحديث التعليق بنجاح"
  },
  "trackingOrderTabs": {
    "orders": "الطلبات",
    "collectors": "المجمعون",
    "drivers": "السائقون",
    "applySearch": "بحث"
  },
  "countries": {
    "noCreatePermission": "ليس لديك صلاحية لإنشاء البلدان",
    "addModalTitle": "إضافة دولة",
    "editModalTitle": "تعديل دولة",
    "createdSuccessfully": "تم إنشاء الدولة بنجاح",
    "updatedSuccessfully": "تم تحديث الدولة بنجاح",
    "failedSave": "فشل في حفظ الدولة"
  },
  "cities": {
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المدن",
    "addModalTitle": "إضافة مدينة",
    "editModalTitle": "تعديل مدينة",
    "createdSuccessfully": "تم إنشاء المدينة بنجاح",
    "updatedSuccessfully": "تم تحديث المدينة بنجاح",
    "failedSave": "فشل في حفظ المدينة",
    "importSuccess": "تم استيراد المدن بنجاح!",
    "importError": "فشل في استيراد المدن. برجاء المحاولة مرة أخرى.",
    "createOptions": {
      "title": "إضافة مدينة جديدة",
      "uploadGroup": {
        "title": "رفع مجموعة من المدن",
        "description": "ارفع جميع المدن بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة مدينة واحدة",
        "description": "أضف مدينة واحدة بسهولة واحدة تلو الأخرى"
      },
      "downloadSample": "تحميل ملف النموذج"
    }
  },
  "areas": {
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المناطق",
    "addModalTitle": "إضافة منطقة",
    "editModalTitle": "تعديل منطقة",
    "createdSuccessfully": "تم إنشاء المنطقة بنجاح",
    "updatedSuccessfully": "تم تحديث المنطقة بنجاح",
    "failedSave": "فشل في حفظ المنطقة",
    "importSuccess": "تم استيراد المناطق بنجاح!",
    "importError": "فشل في استيراد المناطق. برجاء المحاولة مرة أخرى.",
    "createOptions": {
      "title": "إضافة منطقة جديدة",
      "uploadGroup": {
        "title": "رفع مجموعة من المناطق",
        "description": "ارفع جميع المناطق بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة منطقة واحدة",
        "description": "أضف منطقة واحدة بسهولة واحدة تلو الأخرى"
      },
      "downloadSample": "تحميل ملف النموذج"
    }
  },
  "regions": {
    "noCreatePermission": "ليس لديك صلاحية لإنشاء الأقاليم",
    "addModalTitle": "إضافة إقليم",
    "editModalTitle": "تعديل إقليم",
    "createdSuccessfully": "تم إنشاء الإقليم بنجاح",
    "updatedSuccessfully": "تم تحديث الإقليم بنجاح",
    "failedSave": "فشل في حفظ الإقليم",
    "showInApp": "إظهار في التطبيق",
    "importSuccess": "تم استيراد الأقاليم بنجاح!",
    "importError": "فشل في استيراد الأقاليم. برجاء المحاولة مرة أخرى.",
    "createOptions": {
      "title": "إضافة إقليم جديد",
      "uploadGroup": {
        "title": "رفع مجموعة من الأقاليم",
        "description": "ارفع جميع الأقاليم بسهولة بواسطة ملف إكسل"
      },
      "addSingle": {
        "title": "إضافة إقليم واحد",
        "description": "أضف إقليماً واحداً بسهولة واحداً تلو الآخر"
      },
      "downloadSample": "تحميل ملف النموذج"
    }
  },
  "locations": {
    "country": {
      "nameEn": "الاسم الإنجليزي",
      "nameAr": "الاسم العربي",
      "code": "رمز الدولة",
      "flag": "العلم"
    },
    "city": {
      "nameEn": "الاسم الإنجليزي",
      "nameAr": "الاسم العربي"
    },
    "area": {
      "nameEn": "الاسم الإنجليزي",
      "nameAr": "الاسم العربي"
    },
    "region": {
      "nameEn": "الاسم الإنجليزي",
      "nameAr": "الاسم العربي"
    }
  },
  "offers": {
    "pageTitle": "جميع العروض",
    "createNew": "إنشاء عرض جديد",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء العروض",
    "offer_for": "العرض لـ",
    "upload": {
      "title": "رفع العروض",
      "selectFile": "اختر ملف",
      "fileRequired": "يرجى رفع ملف",
      "dragText": "انقر أو اسحب الملف إلى هذه المنطقة للتحميل",
      "hint": "دعم ملفات Excel و CSV فقط",
      "upload": "رفع"
    },
    "import": {
      "success": "تمت جدولة استيراد العروض بنجاح",
      "partialSuccess": "تم استيراد {{imported}} عرض، وفشل {{failed}} صف",
      "viewErrors": "عرض الأخطاء",
      "allFailed": "فشل الاستيراد — لم تتم معالجة أي صفوف صالحة"
    },
    "columns": {
      "id": "معرف العرض",
      "nameAr": "الاسم العربي",
      "nameEn": "الاسم الإنجليزي",
      "percentage": "النسبة المئوية",
      "expDate": "تاريخ الانتهاء",
      "type": "النوع",
      "offerFor": "العرض لـ",
      "activation": "التفعيل",
      "actions": "الإجراءات"
    },
    "filter": {
      "sortBy": "ترتيب حسب",
      "oldest": "الأقدم",
      "newest": "الأحدث",
      "allBranches": "جميع الفروع",
      "fromDate": "من تاريخ",
      "expOfferDate": "تاريخ انتهاء العرض",
      "activeOffersOnly": "العروض النشطة فقط",
      "inactiveOffersOnly": "العروض غير النشطة فقط",
      "offerType": "نوع العرض",
      "allTypes": "جميع الأنواع",
      "offerFor": "العرض لـ",
      "all": "جميع",
      "products": "المنتجات",
      "categories": "الفئات",
      "brands": "العلامات التجارية",
      "group": "المجموعة"
    },
    "types": {
      "special": "عرض خاص",
      "percentage": "النسبة المئوية",
      "buyOneGetOne": "اشتري واحد واحصل على واحد",
      "buyOneGetPercentageOther": "اشتري واحد واحصل على نسبة مئوية آخر",
      "buyOneGetOther": "اشتري واحد واحصل على آخر",
      "amount": "المبلغ",
      "buyOneGetPercentage": "اشتري واحد واحصل على نسبة مئوية"
    },
    "offerFor": {
      "product": "منتج",
      "brand": "علامة تجارية",
      "category": "فئة",
      "group": "مجموعة",
      "for": "العرض لـ"
    },
    "activation": {
      "active": "نشط",
      "inactive": "غير نشط"
    },
    "form": {
      "percentagePlaceholder": "أدخل النسبة",
      "for": "العرض لـ",
      "offerForRequired": "يرجى اختيار العرض لـ",
      "selectOfferFor": "اختر العرض لـ",
      "arabicNameRequired": "الاسم العربي مطلوب",
      "englishNameRequired": "الاسم الإنجليزي مطلوب",
      "arabicNamePlaceholder": "أدخل الاسم العربي",
      "englishNamePlaceholder": "أدخل الاسم الإنجليزي",
      "startDateRequired": "تاريخ البداية مطلوب",
      "startDatePlaceholder": "اختر تاريخ البداية",
      "expiredDateRequired": "تاريخ الانتهاء مطلوب",
      "expiredDatePlaceholder": "اختر تاريخ الانتهاء",
      "totalOrderAmount": "الحد الادنى",
      "showInApp": "إظهار في التطبيق",
      "showInCrm": "إظهار في CRM",
      "allBranches": "جميع الفروع",
      "stores": "الفروع",
      "storesRequired": "يرجى اختيار الفروع",
      "selectStores": "اختر الفروع",
      "status": "الحالة",
      "products": "المنتجات",
      "productsRequired": "يرجى اختيار المنتجات",
      "selectProducts": "اختر المنتجات",
      "type": "النوع",
      "typeRequired": "يرجى اختيار النوع",
      "typeNotAllowedForOfferFor": "هذا النوع من العروض متاح فقط عندما يكون العرض للمنتجات أو المجموعات",
      "selectType": "اختر النوع",
      "percentage": "النسبة المئوية",
      "buyOneGetOne": "اشتري واحد واحصل على واحد",
      "buyOneGetPercentageOther": "اشتري واحد واحصل على نسبة مئوية آخر",
      "buyOneGetOther": "اشتري واحد واحصل على آخر",
      "buyOneGetPercentage": "اشتري واحد واحصل على نسبة مئوية",
      "arabicName": "الاسم العربي",
      "englishName": "الاسم الإنجليزي",
      "startDate": "تاريخ البداية",
      "expiredDate": "تاريخ الانتهاء",
      "amount": "المبلغ",
      "amountRequired": "المبلغ مطلوب",
      "minAmount": "الحد الأدنى للمبلغ",
      "minAmountRequired": "الحد الأدنى للمبلغ مطلوب",
      "related": "مرتبط",
      "lowPrice": "السعر المنخفض",
      "lowPriceRequired": "السعر المنخفض مطلوب",
      "groups": "المجموعات",
      "groupsRequired": "يرجى اختيار المجموعات",
      "selectGroups": "اختر المجموعات",
      "buyCount": "عدد الشراء",
      "buyCountRequired": "يرجى إدخال عدد الشراء",
      "buyCountPlaceholder": "أدخل عدد الشراء",
      "getCount": "عدد المجاني",
      "getCountRequired": "يرجى إدخال عدد المجاني",
      "getCountPlaceholder": "أدخل عدد المجاني"
    },
    "sections": {
      "offerDetails": "تفاصيل العرض",
      "buyDetails": "تفاصيل الشراء"
    },
    "updateSuccess": "تم تحديث العرض بنجاح!",
    "createSuccess": "تم إنشاء العرض بنجاح!",
    "updateError": "فشل في تحديث العرض",
    "createError": "فشل في إنشاء العرض",
    "createGroupModal": {
      "title": "إنشاء عرض باستخدام المجموعة",
      "offerFor": "العرض لـ",
      "offerType": "نوع العرض",
      "uploadFile": "رفع ملف",
      "offerForRequired": "يرجى اختيار العرض لـ",
      "offerTypeRequired": "يرجى اختيار نوع العرض",
      "fileRequired": "يرجى رفع ملف",
      "selectOfferFor": "اختر العرض لـ",
      "selectOfferType": "اختر نوع العرض",
      "dragFileText": "انقر أو اسحب الملف إلى هذه المنطقة للتحميل",
      "fileHint": "دعم ملفات Excel و CSV فقط",
      "fileSelected": "تم اختيار الملف بنجاح",
      "fileUploadSuccess": "تم رفع الملف بنجاح",
      "invalidFileType": "يمكنك رفع ملفات Excel أو CSV فقط!",
      "cancel": "إلغاء",
      "create": "إنشاء",
      "success": "تم إنشاء العروض بنجاح من المجموعة",
      "error": "فشل في إنشاء العروض من المجموعة",
      "downloadSample": "تحميل نموذج",
      "downloadSampleFile": "تحميل ملف النموذج",
      "downloadSampleForType": "تحميل نموذج {{type}}",
      "sampleDescription": "قم بتحميل ملف Excel نموذجي حسب نوع العرض المحدد لرؤية التنسيق المطلوب",
      "sampleDownloaded": "تم تحميل ملف النموذج بنجاح",
      "sampleDownloadError": "فشل في تحميل ملف النموذج",
      "selectBothFields": "يرجى اختيار العرض لـ ونوع العرض قبل تحميل النموذج",
      "invalidOfferType": "نوع عرض غير صالح"
    },
    "createOptions": {
      "title": "إضافة عروض جديدة",
      "uploadFile": {
        "title": "رفع مجموعة من العروض",
        "description": "رفع جميع العروض بسهولة من خلال ملف Excel"
      },
      "createOne": {
        "title": "إضافة عرض واحد",
        "description": "إضافة عرض واحد بسهولة واحد تلو الآخر"
      },
      "createGroup": {
        "title": "إنشاء عرض باستخدام المجموعة",
        "description": "إنشاء عروض باختيار نوع العرض ورفع الجدول"
      }
    }
  },
  "offersGroup": {
    "pageTitle": "مجموعات العروض",
    "createNew": "إنشاء مجموعة عروض جديدة",
    "editTitle": "تعديل مجموعة العروض",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء مجموعات العروض",
    "noEditPermission": "ليس لديك صلاحية لتعديل مجموعات العروض",
    "columns": {
      "id": "معرف المجموعة",
      "nameAr": "الاسم العربي",
      "nameEn": "الاسم الإنجليزي",
      "productCount": "عدد المنتجات",
      "status": "الحالة",
      "actions": "الإجراءات"
    },
    "form": {
      "name": "الاسم",
      "nameAr": "الاسم (عربي)",
      "nameEn": "الاسم (إنجليزي)",
      "nameArRequired": "الاسم العربي مطلوب",
      "nameEnRequired": "الاسم الإنجليزي مطلوب",
      "nameArPlaceholder": "أدخل الاسم العربي",
      "nameEnPlaceholder": "أدخل الاسم الإنجليزي",
      "productSelectionMethod": "طريقة اختيار المنتجات",
      "productSelection": "طريقة اختيار المنتجات",
      "selectProductMethod": "اختر كيفية إضافة المنتجات",
      "multiselect": "اختيار متعدد للمنتجات",
      "fileUpload": "رفع ملف",
      "status": "الحالة",
      "products": "المنتجات",
      "selectProducts": "اختر المنتجات",
      "productsRequired": "يرجى اختيار المنتجات",
      "uploadFile": "تحميل ملف",
      "downloadSample": "تحميل نموذج",
      "downloadSampleFile": "تحميل ملف النموذج",
      "sampleDescription": "قم بتحميل ملف Excel النموذجي لرؤية التنسيق المطلوب لملف المنتجات",
      "dragFileText": "انقر أو اسحب الملف إلى هذه المنطقة للتحميل",
      "fileHint": "دعم ملفات Excel و CSV فقط",
      "fileRequired": "يرجى تحميل ملف",
      "fileSelected": "تم اختيار الملف بنجاح",
      "save": "حفظ",
      "cancel": "إلغاء",
      "categories": "الفئات",
      "categoriesRequired": "يرجى اختيار الفئات",
      "selectCategories": "اختر الفئات",
      "brands": "العلامات التجارية",
      "brandsRequired": "يرجى اختيار العلامات التجارية",
      "selectBrands": "اختر العلامات التجارية",
      "relatedProducts": "المنتجات المرتبطة",
      "relatedProductsRequired": "يرجى اختيار المنتجات المرتبطة",
      "selectRelatedProducts": "اختر المنتجات المرتبطة",
      "relatedGroups": "المجموعات المرتبطة",
      "relatedGroupsRequired": "يرجى اختيار المجموعات المرتبطة",
      "selectRelatedGroups": "اختر المجموعات المرتبطة"
    },
    "productSelectionOptions": {
      "multiselect": "اختيار متعدد للمنتجات",
      "file": "رفع ملف"
    },
    "activation": {
      "active": "نشط",
      "inactive": "غير نشط"
    },
    "messages": {
      "createdSuccessfully": "تم إنشاء مجموعة العروض بنجاح",
      "updatedSuccessfully": "تم تحديث مجموعة العروض بنجاح",
      "failedSave": "فشل في حفظ مجموعة العروض",
      "importing": "جارٍ استيراد المنتجات…",
      "importDone": "تم استيراد المنتجات بنجاح",
      "importFailed": "فشل في استيراد المنتجات",
      "invalidFileType": "نوع الملف غير صالح. الرجاء اختيار ملف Excel أو CSV.",
      "fileTooLarge": "حجم الملف كبير جدًا. الحد الأقصى 10 ميجابايت."
    }
  },
  "customers": {
    "customerDetails": "تفاصيل العميل",
    "customerInformation": "معلومات العميل",
    "customerId": "رقم العميل",
    "name": "الاسم",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "birthdate": "تاريخ الميلاد",
    "gender": "الجنس",
    "male": "ذكر",
    "female": "أنثى",
    "registeredAt": "تاريخ التسجيل",
    "status": "الحالة",
    "blocked": "محظور",
    "active": "نشط",
    "addresses": "العناوين",
    "address": "العنوان",
    "default": "افتراضي",
    "orders": "الطلبات",
    "actions": "الإجراءات",
    "viewDetails": "عرض التفاصيل",
    "orderId": "رقم الطلب",
    "orderDate": "التاريخ",
    "orderStatus": "الحالة",
    "orderTotal": "الإجمالي",
    "activities": "الأنشطة",
    "activityId": "الرقم التعريفي",
    "activityDate": "التاريخ",
    "activityType": "النوع",
    "activityReason": "السبب",
    "activityNote": "ملاحظة",
    "inquiries": "الاستفسارات",
    "complaints": "الشكاوى",
    "loyaltyHistory": "سجل الولاء",
    "loyaltyPoints": "النقاط",
    "loyaltyActivatedAt": "تاريخ التفعيل",
    "loyaltyExpiresAt": "تاريخ الانتهاء",
    "mostOrderedProducts": "أكثر المنتجات طلباً",
    "productImage": "الصورة",
    "productName": "الاسم",
    "productQuantity": "الكمية الإجمالية",
    "noOrders": "لا توجد طلبات",
    "noActivities": "لا توجد أنشطة",
    "noInquiries": "لا توجد استفسارات",
    "noComplaints": "لا توجد شكاوى",
    "noLoyaltyHistory": "لا يوجد سجل ولاء",
    "noProducts": "لا توجد منتجات",
    "noDataFound": "لا توجد بيانات للعميل",
    "errorLoadingCustomer": "خطأ في تحميل العميل",
    "errorLoadingDetails": "فشل في تحميل تفاصيل العميل",
    "exportOrders": "تصدير الطلبات",
    "exportOrdersSuccess": "تم تصدير الطلبات بنجاح",
    "exportOrdersError": "فشل تصدير الطلبات. حاول مرة أخرى."
  },
  "sections": {
    "offerDetails": "تفاصيل العرض",
    "buyDetails": "تفاصيل الشراء"
  },
  "form": {
    "offerFor": "العرض لـ",
    "offerForRequired": "يرجى اختيار العرض لـ",
    "selectOfferFor": "اختر العرض لـ",
    "arabicName": "الاسم العربي",
    "arabicNameRequired": "الاسم العربي مطلوب",
    "arabicNamePlaceholder": "أدخل الاسم العربي",
    "englishName": "الاسم الإنجليزي",
    "englishNameRequired": "الاسم الإنجليزي مطلوب",
    "englishNamePlaceholder": "أدخل الاسم الإنجليزي",
    "startDate": "تاريخ البداية",
    "startDateRequired": "تاريخ البداية مطلوب",
    "startDatePlaceholder": "اختر تاريخ البداية",
    "expiredDate": "تاريخ الانتهاء",
    "expiredDateRequired": "تاريخ الانتهاء مطلوب",
    "expiredDatePlaceholder": "اختر تاريخ الانتهاء",
    "totalOrderAmount": "الحد الأدنى ",
    "showInApp": "إظهار في التطبيق",
    "showInCrm": "إظهار في CRM",
    "allBranches": "جميع الفروع",
    "products": "المنتجات",
    "productsRequired": "يرجى اختيار المنتجات",
    "selectProducts": "اختر المنتجات",
    "type": "النوع",
    "typeRequired": "يرجى اختيار النوع",
    "selectType": "اختر النوع",
    "percentage": "النسبة المئوية"
  },
  "types": {
    "amount": "المبلغ",
    "percentage": "النسبة المئوية",
    "buyOneGetOne": "اشتري واحد واحصل على واحد",
    "buyOneGetPercentage": "اشتري واحد واحصل على نسبة مئوية"
  },
  "saveAndAddMore": "حفظ وإضافة المزيد",
  "createSuccess": "تم إنشاء العرض بنجاح",
  "createError": "فشل في إنشاء العرض",
  "failedOfferImports": {
    "title": "فشل استيراد العروض",
    "pageTitle": "جميع فشل استيراد العروض",
    "columns": {
      "id": "المعرف",
      "fileName": "اسم الملف",
      "batchId": "معرف الدفعة",
      "errorType": "نوع الخطأ",
      "errorMessage": "رسالة الخطأ",
      "date": "التاريخ",
      "actions": "الإجراءات"
    },
    "errorTypes": {
      "validation": "التحقق",
      "processing": "المعالجة"
    },
    "statistics": {
      "totalFailures": "إجمالي الأخطاء",
      "validationErrors": "أخطاء التحقق",
      "processingErrors": "أخطاء المعالجة",
      "filesWithErrors": "الملفات التي تحتوي على أخطاء"
    },
    "filters": {
      "searchPlaceholder": "البحث في اسم الملف أو رسالة الخطأ",
      "batchIdPlaceholder": "تصفية حسب معرف الدفعة",
      "batchFilterActive": "عرض أخطاء الدفعة: {{batchId}}",
      "errorTypePlaceholder": "نوع الخطأ",
      "dateRangePlaceholderStart": "تاريخ البداية",
      "dateRangePlaceholderEnd": "تاريخ النهاية"
    },
    "actions": {
      "refresh": "تحديث",
      "export": "تصدير",
      "clearAll": "مسح الكل",
      "viewDetails": "عرض التفاصيل",
      "delete": "حذف"
    },
    "messages": {
      "deleteConfirm": "حذف فشل الاستيراد",
      "deleteConfirmContent": "هل أنت متأكد من أنك تريد حذف فشل الاستيراد هذا؟",
      "clearAllConfirm": "مسح جميع فشل الاستيراد",
      "clearAllConfirmContent": "هل أنت متأكد من أنك تريد مسح جميع فشل الاستيراد؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteSuccess": "تم حذف فشل الاستيراد بنجاح",
      "deleteError": "فشل في حذف الاستيراد",
      "clearAllSuccess": "تم مسح جميع فشل الاستيراد بنجاح",
      "clearAllError": "فشل في مسح الاستيراد",
      "exportNotAvailable": "وظيفة التصدير غير متاحة بعد",
      "loadError": "فشل في جلب فشل استيراد العروض",
      "noData": "لم يتم العثور على فشل استيراد"
    },
    "details": {
      "title": "تفاصيل فشل الاستيراد",
      "importInformation": "معلومات الاستيراد",
      "errorDetails": "تفاصيل الخطأ",
      "rowData": "بيانات الصف",
      "fields": {
        "id": "المعرف",
        "fileName": "اسم الملف",
        "errorType": "نوع الخطأ",
        "date": "التاريخ",
        "rowNumber": "رقم الصف"
      }
    },
    "rowSummary": {
      "title": "أكثر الصفوف فشلاً شيوعاً",
      "noData": "لا توجد بيانات رقم الصف متاحة",
      "rowLabel": "الصف",
      "failuresLabel": "فشل",
      "description": "فشلت أرقام صفوف Excel هذه بشكل متكرر. افتح ملف Excel الخاص بك وتحقق من هذه الصفوف المحددة أولاً.",
      "failureCount": "عدد حالات الفشل",
      "failure": "فشل",
      "failures": "حالات فشل"
    }
  },
  "failedCategoryImports": {
    "title": "فشل استيراد الأقسام",
    "pageTitle": "جميع فشل استيراد الأقسام",
    "columns": {
      "id": "المعرف",
      "fileName": "اسم الملف",
      "batchId": "معرف الدفعة",
      "errorType": "نوع الخطأ",
      "errorMessage": "رسالة الخطأ",
      "date": "التاريخ",
      "actions": "الإجراءات"
    },
    "errorTypes": {
      "validation": "التحقق",
      "processing": "المعالجة"
    },
    "statistics": {
      "totalFailures": "إجمالي الأخطاء",
      "validationErrors": "أخطاء التحقق",
      "processingErrors": "أخطاء المعالجة",
      "filesWithErrors": "الملفات التي تحتوي على أخطاء"
    },
    "filters": {
      "searchPlaceholder": "البحث في اسم الملف أو رسالة الخطأ",
      "errorTypePlaceholder": "نوع الخطأ",
      "dateRangePlaceholderStart": "تاريخ البداية",
      "dateRangePlaceholderEnd": "تاريخ النهاية"
    },
    "actions": {
      "refresh": "تحديث",
      "export": "تصدير",
      "clearAll": "مسح الكل",
      "viewDetails": "عرض التفاصيل",
      "delete": "حذف",
      "readMore": "قراءة المزيد",
      "copy": "نسخ إلى الحافظة",
      "close": "إغلاق"
    },
    "messages": {
      "deleteConfirm": "حذف فشل الاستيراد",
      "deleteConfirmContent": "هل أنت متأكد من أنك تريد حذف فشل الاستيراد هذا؟",
      "clearAllConfirm": "مسح جميع فشل الاستيراد",
      "clearAllConfirmContent": "هل أنت متأكد من أنك تريد مسح جميع فشل الاستيراد؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteSuccess": "تم حذف فشل الاستيراد بنجاح",
      "deleteError": "فشل في حذف الاستيراد",
      "clearAllSuccess": "تم مسح جميع فشل الاستيراد بنجاح",
      "clearAllError": "فشل في مسح الاستيراد",
      "exportNotAvailable": "وظيفة التصدير غير متاحة بعد",
      "loadError": "فشل في جلب فشل استيراد الأقسام",
      "noData": "لم يتم العثور على فشل استيراد",
      "copySuccess": "تم نسخ رسالة الخطأ إلى الحافظة",
      "copyError": "فشل نسخ رسالة الخطأ"
    },
    "details": {
      "title": "تفاصيل فشل الاستيراد",
      "importInformation": "معلومات الاستيراد",
      "errorDetails": "تفاصيل الخطأ",
      "rowData": "بيانات الصف",
      "fields": {
        "id": "المعرف",
        "fileName": "اسم الملف",
        "errorType": "نوع الخطأ",
        "date": "التاريخ",
        "rowNumber": "رقم الصف"
      }
    },
    "rowSummary": {
      "title": "أكثر الصفوف فشلاً شيوعاً",
      "noData": "لا توجد بيانات رقم الصف متاحة",
      "rowLabel": "الصف",
      "failuresLabel": "فشل",
      "description": "فشلت أرقام صفوف Excel هذه بشكل متكرر. افتح ملف Excel الخاص بك وتحقق من هذه الصفوف المحددة أولاً.",
      "failureCount": "عدد حالات الفشل",
      "failure": "فشل",
      "failures": "حالات فشل"
    }
  },
  "integrationMonitoring": {
    "title": "مراقبة التكاملات",
    "actions": {
      "refresh": "تحديث",
      "viewDetails": "عرض التفاصيل"
    },
    "summary": {
      "title": "ملخص الحالة",
      "window": "الفترة",
      "hours": "{{count}} ساعة",
      "lastRun": "آخر تشغيل",
      "showLogs": "عرض السجلات",
      "empty": "لا يوجد تكامل تم تشغيله في هذه الفترة. الأنواع بدون نشاط لا تظهر إطلاقًا."
    },
    "stuck": {
      "title": "تكاملات متوقفة",
      "threshold": "معلقة لأكثر من",
      "minutes": "{{count}} دقيقة",
      "alert": "{{count}} تكامل متوقف في حالة معلقة. لن تتم إعادة المحاولة تلقائيًا.",
      "oldest": "الأقدم",
      "capped": "عرض {{returned}} من {{count}} — القائمة محدودة بـ 50 صفًا، الأقدم أولًا.",
      "none": "لا توجد تكاملات متوقفة ضمن هذه المدة."
    },
    "list": {
      "title": "السجلات"
    },
    "filters": {
      "type": "نوع التكامل",
      "status": "الحالة",
      "objectId": "معرف السجل (مع تحديد النوع)",
      "from": "من",
      "to": "إلى",
      "reset": "إعادة تعيين"
    },
    "columns": {
      "id": "المعرف",
      "type": "النوع",
      "status": "الحالة",
      "objectId": "معرف السجل",
      "companyId": "معرف الشركة",
      "responsePreview": "معاينة الاستجابة",
      "createdAt": "وقت البدء",
      "updatedAt": "وقت الانتهاء",
      "actions": "الإجراءات"
    },
    "table": {
      "wholeRun": "تشغيل كامل"
    },
    "statuses": {
      "pending": "معلق",
      "success": "ناجح",
      "failed": "فشل",
      "unknown": "غير معروف"
    },
    "types": {
      "dms_order_integration": "إرسال الطلب إلى شمس",
      "odoo_order_push_integration": "إرسال الطلب إلى أودو",
      "odoo_order_pull_integration": "استيراد الطلب من أودو",
      "odoo_order_status_push_integration": "إرسال حالة الطلب إلى أودو",
      "odoo_order_status_pull_integration": "استيراد حالة الطلب من أودو",
      "odoo_customer_push_integration": "إرسال العميل إلى أودو",
      "odoo_customer_pull_integration": "استيراد العملاء من أودو",
      "odoo_product_pull_integration": "مزامنة المنتجات والمخزون",
      "odoo_category_pull_integration": "مزامنة الأقسام",
      "odoo_store_pull_integration": "مزامنة الفروع",
      "odoo_location_pull_integration": "مزامنة المدن والمناطق"
    },
    "details": {
      "title": "تفاصيل سجل التكامل",
      "payload": "محتوى الاستجابة",
      "wholeRun": "تشغيل كامل (بدون سجل محدد)",
      "personalDataWarning": "هذا المحتوى هو ما أعاده النظام الخارجي. في حالات العملاء والعناوين قد يحتوي على أسماء وأرقام هواتف وعناوين — لا تنسخه إلى مكان أقل حماية.",
      "truncated": "تجاوز هذا المحتوى حد التخزين 60 كيلوبايت وتم حفظه مقتطعًا.",
      "noPayload": "لا يوجد محتوى بعد — يُكتب عند عودة الاستجابة من النظام الخارجي."
    }
  },
  "failedProductImports": {
    "title": "فشل استيراد المنتجات",
    "pageTitle": "جميع فشل استيراد المنتجات",
    "columns": {
      "id": "المعرف",
      "fileName": "اسم الملف",
      "errorType": "نوع الخطأ",
      "errorMessage": "رسالة الخطأ",
      "date": "التاريخ",
      "actions": "الإجراءات"
    },
    "errorTypes": {
      "validation": "التحقق",
      "processing": "المعالجة"
    },
    "statistics": {
      "totalFailures": "إجمالي الأخطاء",
      "validationErrors": "أخطاء التحقق",
      "processingErrors": "أخطاء المعالجة",
      "filesWithErrors": "الملفات التي تحتوي على أخطاء"
    },
    "filters": {
      "searchPlaceholder": "البحث في اسم الملف أو رسالة الخطأ",
      "errorTypePlaceholder": "نوع الخطأ",
      "dateRangePlaceholderStart": "تاريخ البداية",
      "dateRangePlaceholderEnd": "تاريخ النهاية"
    },
    "actions": {
      "refresh": "تحديث",
      "export": "تصدير",
      "clearAll": "مسح الكل",
      "viewDetails": "عرض التفاصيل",
      "delete": "حذف"
    },
    "messages": {
      "deleteConfirm": "حذف فشل الاستيراد",
      "deleteConfirmContent": "هل أنت متأكد من أنك تريد حذف فشل الاستيراد هذا؟",
      "clearAllConfirm": "مسح جميع فشل الاستيراد",
      "clearAllConfirmContent": "هل أنت متأكد من أنك تريد مسح جميع فشل الاستيراد؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteSuccess": "تم حذف فشل الاستيراد بنجاح",
      "deleteError": "فشل في حذف الاستيراد",
      "clearAllSuccess": "تم مسح جميع فشل الاستيراد بنجاح",
      "clearAllError": "فشل في مسح الاستيراد",
      "exportSuccess": "تم التصدير بنجاح",
      "exportError": "فشل في تصدير البيانات",
      "loadError": "فشل في جلب فشل استيراد المنتجات",
      "noData": "لم يتم العثور على فشل استيراد"
    },
    "details": {
      "title": "تفاصيل فشل الاستيراد",
      "importInformation": "معلومات الاستيراد",
      "errorMessage": "رسالة الخطأ",
      "rowData": "بيانات الصف",
      "validationErrors": "أخطاء التحقق",
      "fields": {
        "id": "المعرف",
        "fileName": "اسم الملف",
        "errorType": "نوع الخطأ",
        "date": "التاريخ",
        "companyId": "معرف الشركة",
        "field": "الحقل",
        "value": "القيمة"
      }
    },
    "rowSummary": {
      "title": "أكثر أرقام صفوف Excel فشلاً شيوعاً",
      "description": "فشلت أرقام صفوف Excel هذه بشكل متكرر. افتح ملف Excel الخاص بك وتحقق من هذه الصفوف المحددة أولاً.",
      "failureCount": "عدد حالات الفشل",
      "failure": "فشل",
      "failures": "حالات فشل"
    }
  },
  "exportReports": {
    "title": "تصدير التقارير",
    "savedSuccessfully": "تم حفظ إعدادات تصدير التقارير بنجاح",
    "saveFailed": "فشل حفظ إعدادات تصدير التقارير",
    "fetchFailed": "فشل تحميل إعدادات تصدير التقارير",
    "name": "اسم التقرير",
    "id": "معرف التقرير",
    "group": "المجموعة",
    "status": "الحالة",
    "companySectionTitle": "تقارير التصدير للشركة",
    "userSectionTitle": "تعيين التقارير لمستخدم",
    "selectUserTitle": "اختر المستخدم",
    "userReportsTitle": "تقارير تصدير المستخدم",
    "selectAll": "تحديد كل التقارير",
    "deselectAll": "إلغاء تحديد الكل",
    "selectUser": "المستخدم",
    "selectUserPlaceholder": "اختر مستخدمًا",
    "selectUserFirst": "اختر مستخدمًا لإدارة صلاحية وصوله إلى التقارير",
    "userHelp": "التقارير المحددة هي التي يمكن لهذا المستخدم الوصول إليها وتصديرها. أزل تحديد أي تقرير لحظره على هذا المستخدم؛ تحديد كل التقارير يعني صلاحية وصول كاملة.",
    "userSavedSuccessfully": "تم حفظ صلاحيات تقارير المستخدم بنجاح",
    "userSaveFailed": "فشل حفظ صلاحيات تقارير المستخدم",
    "userFetchFailed": "فشل تحميل صلاحيات تقارير المستخدم",
    "complaintResponses": {
      "title": "تقرير ردود الشكاوى",
      "dateRange": "النطاق الزمني",
      "search": "بحث",
      "noData": "لا توجد بيانات للنطاق الزمني المحدد",
      "selectDateFirst": "يرجى تحديد النطاق الزمني أولاً",
      "fetchFailed": "فشل تحميل تقرير ردود الشكاوى",
      "viewAttachment": "عرض",
      "columns": {
        "complaintId": "معرف الشكوى",
        "type": "النوع",
        "agentName": "اسم الوكيل",
        "customerPhone": "هاتف العميل",
        "customerName": "اسم العميل",
        "customerId": "معرف العميل",
        "storeName": "اسم المتجر",
        "activityType": "نوع النشاط",
        "callChannel": "قناة الاتصال",
        "complaintDetails": "تفاصيل الشكوى",
        "status": "الحالة",
        "section": "القسم",
        "lastDate": "آخر تاريخ",
        "orderId": "معرف الطلب",
        "isValid": "صالحة",
        "productName": "اسم المنتج",
        "productBarcode": "باركود المنتج",
        "complaintCreatedAt": "تاريخ إنشاء الشكوى",
        "commentId": "معرف الرد",
        "responseComment": "نص الرد",
        "responseAgentName": "اسم وكيل الرد",
        "responseCreatedAt": "تاريخ إنشاء الرد",
        "responseUpdatedAt": "تاريخ تحديث الرد",
        "attachmentUrl": "المرفق"
      }
    },
    "chooseReportType": "اختر نوع التقرير",
    "chooseReportTypePlaceholder": "اختر نوع التقرير",
    "inquiryResponses": {
      "title": "تقرير ردود الاستفسارات",
      "selectDateLabel": "النطاق الزمني",
      "selectDate": "يرجى اختيار النطاق الزمني",
      "selectTypeAndDate": "يرجى اختيار نوع التقرير والنطاق الزمني",
      "search": "بحث",
      "searchCompleted": "اكتمل البحث",
      "searchFailed": "فشل البحث",
      "noDataFound": "لا توجد بيانات",
      "viewAttachment": "عرض",
      "inquiry_id": "معرف الاستفسار",
      "type": "النوع",
      "agent_name": "اسم الموظف",
      "customer_phone": "هاتف العميل",
      "customer_name": "اسم العميل",
      "customer_id": "معرف العميل",
      "store_name": "اسم المتجر",
      "activity_type": "نوع النشاط",
      "call_channel": "قناة الاتصال",
      "inquiry_details": "تفاصيل الاستفسار",
      "status": "الحالة",
      "section": "القسم",
      "last_date": "آخر تاريخ",
      "order_id": "معرف الطلب",
      "is_valid": "صالح",
      "product_name": "اسم المنتج",
      "product_barcode": "باركود المنتج",
      "inquiry_created_at": "تاريخ إنشاء الاستفسار",
      "comment_id": "معرف التعليق",
      "response_comment": "نص الرد",
      "response_agent_name": "اسم موظف الرد",
      "response_created_at": "تاريخ إنشاء الرد",
      "response_updated_at": "تاريخ تحديث الرد",
      "attachment_url": "المرفق"
    }
  },
  "exportLogs": {
    "title": "سجلات التصدير",
    "employeeName": "اسم الموظف",
    "allEmployees": "كل الموظفين",
    "reportType": "نوع التقرير",
    "selectReportType": "اختر نوع التقرير",
    "downloadDate": "تاريخ التنزيل",
    "from": "من",
    "to": "إلى",
    "filter": "تصفية",
    "employee": "الموظف",
    "reportName": "اسم التقرير",
    "dateFrom": "من تاريخ",
    "dateTo": "إلى تاريخ",
    "downloadedAt": "تم التنزيل في",
    "fetchFailed": "فشل تحميل سجل التنزيلات"
  },
  "payment": {
    "edit": "تعديل",
    "set": "تعيين",
    "createNewGateway": "إنشاء بوابة دفع جديدة",
    "editCredentials": "تعديل بيانات {gateway}",
    "callbackInstruction": "* يرجى إدراج هذا الرابط في لوحة تكامل الدفع لـ {gateway}:",
    "apiKey": "مفتاح API",
    "hmacSecret": "سر hmac",
    "iframeId": "معرف iFrame",
    "integrationId": "معرف التكامل",
    "enterApiKey": "أدخل مفتاح API",
    "enterHmacSecret": "أدخل سر hmac",
    "enterIframeId": "أدخل معرف iFrame",
    "enterIntegrationId": "أدخل معرف التكامل",
    "apiKeyRequired": "مفتاح API مطلوب",
    "hmacSecretRequired": "سر hmac مطلوب",
    "iframeIdRequired": "معرف iFrame مطلوب",
    "integrationIdRequired": "معرف التكامل مطلوب",
    "credentialsSaved": "تم حفظ البيانات بنجاح",
    "credentialsSaveFailed": "فشل في حفظ البيانات",
    "gatewayCreated": "تم إنشاء بوابة الدفع بنجاح",
    "gatewayCreateFailed": "فشل في إنشاء بوابة الدفع",
    "uploadLogo": "رفع الشعار",
    "clickOrDrag": "انقر أو اسحب الملف إلى هذه المنطقة للرفع",
    "logoHint": "يدعم رفع ملف واحد",
    "nameEn": "الاسم بالإنجليزية",
    "nameAr": "الاسم بالعربية",
    "nameEnRequired": "يرجى إدخال الاسم بالإنجليزية",
    "nameArRequired": "يرجى إدخال الاسم بالعربية",
    "unsupportedGateway": "إعدادات بوابة الدفع هذه غير مدعومة بعد.",
    "fieldRequired": "{field} مطلوب",
    "enterField": "أدخل {field}",
    "gatewayCredentials": "بيانات بوابة الدفع",
    "api_key": "مفتاح API",
    "integration_id": "معرف التكامل",
    "iframe_id": "معرف iFrame",
    "hmac_secret": "سر HMAC",
    "entityId": "معرف الكيان",
    "access_token": "رمز الوصول",
    "authorization": "التفويض",
    "logo": "الشعار"
  },
  "reportsDashboard": {
    "title": "لوحة التحكم",
    "dateRange": "النطاق الزمني",
    "store": "المتجر",
    "allStores": "كل المتاجر",
    "applyFilters": "تطبيق",
    "selectDateRange": "يرجى اختيار النطاق الزمني",
    "fetchError": "فشل في جلب بيانات لوحة التحكم",
    "noData": "لا توجد بيانات",
    "congratulations": "تهانينا",
    "bestStoreSeller": "أفضل متجر مبيعًا خلال الفترة",
    "ordersThisPeriod": "{{count}} طلب خلال الفترة",
    "soldProducts": "المنتجات المباعة",
    "newCustomers": "عملاء جدد",
    "salesByMonth": "الطلبات والمبيعات شهريًا",
    "salesByArea": "المبيعات حسب المنطقة",
    "ordersCount": "الطلبات",
    "totalSales": "إجمالي المبيعات",
    "ordersCountLabel": "{{count}} طلب",
    "branchPerformance": "أداء الفروع",
    "branchPerformanceSubtitle": "مؤشرات لحظية لعمليات الفروع",
    "totalTickets": "إجمالي التذاكر",
    "inquiries": "الاستفسارات",
    "complaints": "الشكاوى",
    "activities": "الأنشطة",
    "openTickets": "التذاكر المفتوحة",
    "closedTickets": "التذاكر المغلقة",
    "totalOrders": "إجمالي الطلبات"
  },
  "reports": {
    "title": "تصدير التقارير",
    "otherInsuranceCompany": "شركة تأمين أخرى",
    "chooseReportType": "اختر نوع التقرير",
    "chooseReportTypePlaceholder": "اختر",
    "chooseReportTypeDescription": "اختر نوع التقرير. يتم معالجة البيانات بناءً على اختيارك",
    "noReportTypeFound": "لا يوجد تقرير مطابق",
    "selectDate": "اختر التاريخ",
    "store": "المتجر",
    "storePlaceholder": "جميع المتاجر",
    "returnType": "نوع الإرجاع",
    "returnTypes": {
      "partial": "إرجاع جزئي",
      "full": "إرجاع كامل",
      "all": "كل المرتجعات"
    },
    "partialReturnSummary": {
      "partialOrdersCount": "الطلبات المرتجعة جزئيًا",
      "partialOrdersValue": "قيمة الطلبات المرتجعة جزئيًا",
      "partialReturnedAmount": "قيمة المرتجع الجزئي",
      "fullOrdersCount": "الطلبات المرتجعة بالكامل",
      "fullOrdersValue": "قيمة الطلبات المرتجعة بالكامل",
      "fullReturnedAmount": "قيمة المرتجع الكامل"
    },
    "search": "بحث",
    "reportName": "اسم التقرير",
    "exportPageToExcel": "تصدير الصفحة إلى CSV",
    "exportAllToExcel": "تصدير الكل إلى CSV",
    "noDataFound": "لا توجد بيانات، اختر المرشحات أعلاه وابحث!",
    "yes": "نعم",
    "no": "لا",
    "searchCompleted": "تم البحث بنجاح!",
    "exportCompleted": "تم التصدير بنجاح!",
    "searchFailed": "فشل البحث. يرجى المحاولة مرة أخرى.",
    "exportFailed": "فشل التصدير. يرجى المحاولة مرة أخرى.",
    "selectReportTypeAndDate": "يرجى اختيار نوع التقرير ونطاق التاريخ",
    "notifyStatus": "حالة الإشعار",
    "notifyStatusPending": "قيد الانتظار",
    "notifyStatusSent": "تم الإرسال",
    "notifyStatusAll": "الكل",
    "notifyMeSearchPlaceholder": "ابحث عن منتج (مثال: بانادول)",
    "resetInquiry": "إعادة تعيين الاستفسار",
    "resetInquirySuccess": "تمت إعادة تعيين الاستفسار بنجاح",
    "resetInquiryFailed": "فشل في إعادة تعيين الاستفسار",
    "resetInquiryInvalidRow": "بيانات المتجر أو المنتج مفقودة في هذا الصف",
    "resetInquiryPendingConfig": "لم يتم إعداد واجهة إعادة تعيين الاستفسار بعد",
    "fileDownloaded": "تم تحميل الملف بنجاح",
    "fileEmpty": "الملف المحمل فارغ. يرجى المحاولة مرة أخرى.",
    "downloadFailed": "فشل التحميل. يرجى المحاولة مرة أخرى.",
    "reportTypes": {
      "orderReport": "تقرير الطلبات",
      "cancelOrders": "الطلبات الملغية",
      "orderItemsReport": "تقرير عناصر الطلب",
      "inquiryReport": "تقرير الاستفسارات",
      "complaintReport": "تقرير الشكاوى",
      "complaintResponsesReport": "تقرير ردود الشكاوى",
      "activityReport": "تقرير النشاط",
      "allTicketReport": "تقرير جميع التذاكر",
      "allAgentTicketCountReport": "تقرير عدد تذاكر جميع الوكلاء",
      "masterDataReport": "تقرير البيانات الرئيسية",
      "offerReport": "تقرير العروض",
      "categoriesReport": "تقرير الفئات",
      "brandsReport": "تقرير العلامات التجارية",
      "customerOrdersReport": "تقرير طلبات العملاء",
      "itemSalesReport": "تقرير مبيعات العناصر",
      "itemSalesByStoreReport": "تقرير مبيعات العناصر حسب المتجر",
      "productsStockReport": "تقرير مخزون المنتجات",
      "orderItemsDiscountReport": "تقرير خصومات عناصر الطلب",
      "promoCodeReport": "تقرير أكواد الخصم",
      "promoCodeCountReport": "تقرير عدد أكواد الخصم",
      "newOrderItemsReport": "تقرير عناصر الطلبات الجديدة",
      "transferReport": "تقرير التحويل",
      "inactiveCustomers": "العملاء غير النشطين",
      "totalSupportQuestionsResponsesReport": "تقرير إجمالي أسئلة وردود الدعم",
      "supportQuestionsResponsesReport": "تقرير أسئلة وردود الدعم",
      "notificationReport": "تقرير الإشعارات",
      "customerReport": "تقرير العملاء",
      "inquiryResponsesReport": "تقرير ردود الاستفسارات",
      "attributeReport": "تقرير الخصائص",
      "extrasReport": "تقرير الإضافات",
      "partialReturnedOrdersReport": "تقرير الطلبات المرتجعة جزئيًا",
      "trackNotifyProductRequests": "المبيعات المفقودة",
      "collectorPerformanceReport": "أداء المُحصّل",
      "deliveryPerformanceReport": "أداء التوصيل"
    },
    "companyReport": {
      "title": "تقرير الشركة",
      "filter": "تصفية",
      "loadError": "تعذر تحميل تقرير الشركة. تحقق من مسار الواجهة أو حاول مرة أخرى.",
      "orders": "الطلبات",
      "customers": "العملاء",
      "canceledOrders": "الطلبات الملغاة",
      "collectedOrders": "الطلبات المجمعة",
      "soldProducts": "المنتجات المباعة",
      "totalAmount": "المبلغ الإجمالي",
      "complaints": "الشكاوى",
      "enquiries": "الاستفسارات",
      "mostSellingProducts": "الأكثر مبيعًا",
      "leastSellingProducts": "الأقل مبيعًا",
      "avgTimeOrderComplete": "متوسط وقت إكمال الطلب",
      "avgTimeOrderCollected": "متوسط وقت تحصيل الطلب",
      "avgTimeOrderToShopper": "متوسط وقت التوصيل",
      "topCustomers": "أفضل العملاء",
      "customersNoOrders": "عملاء بلا طلبات",
      "customer": "العميل",
      "phone": "الهاتف",
      "ordersNum": "عدد الطلبات",
      "shoppers": "المُخْزِنون",
      "agentActions": "إجراءات الوكلاء",
      "name": "الاسم",
      "branch": "الفرع",
      "action": "الإجراء",
      "date": "التاريخ",
      "cancelledOrders": "الطلبات الملغاة",
      "id": "المعرف",
      "agent": "الوكيل",
      "comment": "التعليق",
      "deliveredToArea": "التسليم حسب المنطقة",
      "callChannel": "قناة الاتصال",
      "sales": "المبيعات",
      "noData": "لا توجد بيانات",
      "scopeType": "نوع النطاق",
      "scopeCompany": "الشركة",
      "scopeAgent": "الوكيل",
      "scopeStore": "المتجر",
      "scopeStorePlaceholder": "اختر المتجر",
      "scopeAgentPlaceholder": "اختر الوكيل",
      "scopeIdRequired": "يرجى اختيار المتجر أو الوكيل"
    },
    "storeCompare": {
      "title": "مقارنة الفروع",
      "filter": "بحث",
      "loadError": "تعذر تحميل مقارنة الفروع.",
      "storesRequired": "يرجى اختيار فرع واحد على الأقل.",
      "storesPlaceholder": "اختر الفروع",
      "collectedOrders": "الطلبات المحصّلة",
      "totalSalesPerBranch": "إجمالي المبيعات لكل فرع",
      "mostSelling": "الأكثر مبيعاً",
      "leastSelling": "الأقل مبيعاً",
      "callChannel": "قناة الطلب",
      "enquiries": "الاستفسارات",
      "complains": "الشكاوى",
      "branch": "الفرع",
      "product": "المنتج",
      "quantity": "الكمية",
      "channel": "القناة",
      "count": "العدد"
    },
    "growthReport": {
      "title": "تقرير النمو",
      "loadError": "تعذر تحميل تقرير النمو.",
      "vsYear": "مقارنةً بـ {{year}}",
      "totalOrders": "إجمالي الطلبات {{year}}",
      "totalRevenue": "إجمالي الإيرادات {{year}}",
      "avgBasket": "متوسط قيمة الطلب {{year}}",
      "basketSize": "حجم السلة",
      "newCustomers": "عملاء جدد {{year}}",
      "ordersMonthly": "عدد الطلبات شهرياً",
      "revenueMonthly": "الإيرادات شهرياً",
      "basketMonthly": "متوسط قيمة الطلب (حجم السلة) شهرياً",
      "customersMonthly": "العملاء الجدد شهرياً",
      "activitiesMonthly": "الأنشطة والاستفسارات شهرياً",
      "notificationsMonthly": "الإشعارات المُرسلة شهرياً",
      "monthlySummary": "ملخص شهري مقارن",
      "activity": "نشاط",
      "inquiry": "استفسار",
      "complaint": "شكوى",
      "month": "الشهر",
      "orders": "عدد الطلبات",
      "revenue": "الإيرادات",
      "avgOrder": "متوسط الطلب",
      "newCustomersShort": "عملاء جدد",
      "notifications": "إشعارات"
    },
    "productReport": {
      "title": "تقرير المنتجات",
      "loadError": "تعذر تحميل تقرير المنتجات.",
      "allStores": "كل الفروع",
      "show": "عرض",
      "uniqueProductsCard": "منتجات فريدة",
      "totalItems": "إجمالي القطع",
      "totalRevenue": "إجمالي الإيرادات",
      "avgQtyPerLine": "متوسط الكمية / السطر",
      "tabProducts": "المنتجات",
      "tabBrands": "العلامات التجارية",
      "tabCategories": "الفئات",
      "mostOrdered": "الأكثر طلباً",
      "leastOrdered": "الأقل طلباً",
      "topRevenue": "الأعلى إيراداً",
      "topBrands": "أعلى العلامات التجارية",
      "brandRevenue": "إيرادات العلامات التجارية",
      "topCategories": "أعلى الفئات",
      "categoryRevenue": "إيرادات الفئات",
      "name": "الاسم",
      "barcode": "الباركود",
      "ordersCount": "الطلبات",
      "totalQty": "إجمالي الكمية",
      "avgQty": "متوسط الكمية",
      "revenue": "الإيرادات",
      "uniqueProducts": "منتجات فريدة",
      "brand": "العلامة التجارية",
      "category": "الفئة"
    },
    "customerReport": {
      "title": "تقرير العملاء",
      "loadError": "تعذر تحميل تقرير العملاء.",
      "allStores": "كل الفروع",
      "show": "عرض",
      "days": "يوم",
      "uniqueCustomers": "عملاء فريدون",
      "totalOrders": "إجمالي الطلبات",
      "avgOrder": "متوسط قيمة الطلب",
      "dormant": "خاملون",
      "dormantHint": "العملاء الذين آخر طلب لهم أقدم من {{days}} يوم.",
      "tabTop": "أفضل العملاء",
      "tabDormant": "الخاملون",
      "tabNewVsReturning": "جدد مقابل عائدين",
      "name": "الاسم",
      "phone": "الهاتف",
      "ordersCount": "الطلبات",
      "totalSpent": "إجمالي الإنفاق",
      "lastOrder": "آخر طلب",
      "month": "الشهر",
      "newCustomers": "عملاء جدد",
      "returningCustomers": "عملاء عائدون"
    },
    "orderAnalytics": {
      "title": "تحليلات الطلبات",
      "loadError": "تعذر تحميل تحليلات الطلبات.",
      "allStores": "كل الفروع",
      "show": "عرض",
      "totalOrders": "إجمالي الطلبات",
      "cancelledOrders": "الطلبات الملغاة",
      "cancelRate": "معدل الإلغاء",
      "lostRevenue": "الإيرادات المفقودة",
      "tabCancellations": "الإلغاءات",
      "tabPeak": "ساعات الذروة",
      "tabTrend": "الاتجاه اليومي",
      "byReason": "الإلغاءات حسب السبب",
      "byStore": "الإلغاءات حسب الفرع",
      "reason": "السبب",
      "count": "العدد",
      "store": "الفرع",
      "cancelled": "ملغاة",
      "total": "الإجمالي",
      "revenue": "الإيرادات",
      "peakHint": "الطلبات حسب اليوم والساعة",
      "intensity": "الكثافة",
      "days": {
        "sun": "الأحد",
        "mon": "الاثنين",
        "tue": "الثلاثاء",
        "wed": "الأربعاء",
        "thu": "الخميس",
        "fri": "الجمعة",
        "sat": "السبت"
      }
    },
    "revenueReport": {
      "title": "تقرير الإيرادات",
      "loadError": "تعذر تحميل تقرير الإيرادات.",
      "allStores": "كل الفروع",
      "show": "عرض",
      "daily": "يومي",
      "weekly": "أسبوعي",
      "monthly": "شهري",
      "currentRevenue": "الإيرادات (الحالية)",
      "currentOrders": "الطلبات (الحالية)",
      "aov": "متوسط قيمة الطلب",
      "prevRevenue": "الإيرادات (السابقة)",
      "vsPrev": "مقارنةً بالفترة السابقة",
      "trendTitle": "اتجاه الإيرادات",
      "paymentMethods": "الإيرادات حسب طريقة الدفع",
      "detailTable": "تفصيل مفصّل",
      "method": "الطريقة",
      "count": "الطلبات",
      "revenue": "الإيرادات",
      "orders": "الطلبات",
      "period": "الفترة"
    }
  },
  "addOrder": {
    "enterText": "أدخل النص",
    "enterNumber": "أدخل الرقم",
    "selectOption": "اختر الخيار",
    "extras": "الإضافات",
    "yourCart": "سلة المشتريات",
    "itemsCountShort": "عناصر",
    "totalDue": "الإجمالي المستحق",
    "uncompleted": "غير مكتمل",
    "selectChannel": "اختر القناة",
    "chooseChannel": "اختر القناة",
    "customerSegment": "تصنيف العميل",
    "chooseCustomerSegment": "اختر تصنيف العميل",
    "customerNote": "ملاحظة العميل",
    "writeNote": "اكتب ملاحظة",
    "attachments": "المرفقات",
    "attachFiles": "إرفاق ملفات",
    "shoppingCart": "سلة التسوق",
    "expandCart": "عرض تفاصيل السلة",
    "collapseCart": "إخفاء تفاصيل السلة",
    "showCart": "عرض السلة",
    "hideCart": "إخفاء السلة",
    "dateRequired": "الرجاء اختيار التاريخ",
    "selectDate": "اختر التاريخ",
    "timeRequired": "الرجاء اختيار الوقت",
    "selectTime": "اختر الوقت",
    "noDeliveryTimes": "لا توجد أوقات توصيل متاحة",
    "maxAttachments": "بحد أقصى 5 مرفقات",
    "errorLoadingAddress": "فشل تحميل العنوان",
    "viewCustomerInfo": "عرض بيانات العميل",
    "loadingCustomer": "جاري تحميل بيانات العميل...",
    "noPermission": "ليس لديك صلاحية",
    "stockInformation": "بيانات المخزون",
    "stockDescription": "عدد المنتجات في الفروع",
    "totalStock": "إجمالي المخزون",
    "stockByBranch": "المخزون حسب الفرع",
    "loadingStockInfo": "جاري تحميل بيانات المخزون...",
    "noStockInfo": "لا توجد بيانات مخزون",
    "stockInfoError": "فشل في تحميل معلومات المخزون",
    "date": "التاريخ",
    "time": "الوقت",
    "cashOnDelivery": "نقداً عند الاستلام",
    "visaOnDelivery": "بطاقة عند الاستلام",
    "paymentLink": "رابط الدفع",
    "deliveryTitleAndTime": "تاريخ ووقت التوصيل",
    "categories": "الفئات",
    "title": "إضافة طلب جديد",
    "orderDetails": "تفاصيل الطلب",
    "delivery": "توصيل",
    "pickup": "استلام",
    "storePickupOnly": "هذا المتجر للاستلام فقط. التوصيل غير متاح.",
    "storeDeliveryOnly": "هذا المتجر للتوصيل فقط. الاستلام غير متاح.",
    "fulfillmentTypeMismatch": "نوع التنفيذ المحدد غير مسموح به لهذا المتجر.",
    "customer": "العميل",
    "phone": "الهاتف",
    "address": "العنوان",
    "pickupLocation": "مكان الاستلام",
    "paymentMethod": "طريقة الدفع",
    "deliveryTime": "وقت التوصيل",
    "pickupTime": "وقت الاستلام",
    "notes": "ملاحظات",
    "customerRequired": "يرجى اختيار عميل",
    "phoneRequired": "يرجى إدخال رقم الهاتف",
    "addressRequired": "يرجى إدخال العنوان",
    "pickupLocationRequired": "يرجى إدخال مكان الاستلام",
    "paymentMethodRequired": "يرجى اختيار طريقة الدفع",
    "noPaymentMethodsEnabled": "لا توجد طرق دفع مفعّلة للدفع. يُرجى تفعيل طريقة واحدة على الأقل من إعدادات الشركة → طرق الدفع.",
    "apartmentNumberRequired": "يرجى إدخال رقم الشقة",
    "floorRequired": "يرجى إدخال رقم الطابق",
    "selectCustomer": "اختر العميل",
    "noCustomersFound": "لم يتم العثور على عملاء",
    "enterPhone": "أدخل رقم الهاتف",
    "enterAddress": "أدخل عنوان التوصيل",
    "enterPickupLocation": "أدخل مكان الاستلام",
    "selectPaymentMethod": "اختر طريقة الدفع",
    "enterDeliveryTime": "أدخل وقت التوصيل",
    "enterPickupTime": "أدخل وقت الاستلام",
    "enterNotes": "أدخل أي ملاحظات إضافية",
    "cash": "نقداً",
    "card": "بطاقة",
    "online": "عبر الإنترنت",
    "customerCart": "سلة العميل",
    "products": "المنتجات",
    "filterByCategory": "تصفية حسب الفئة",
    "selectCategory": "اختر الفئة",
    "product": "المنتج",
    "productName": "اسم المنتج",
    "price": "السعر",
    "stock": "المخزون",
    "inStock": "متوفر",
    "outOfStock": "غير متوفر",
    "notifyMe": "أبلغني",
    "notifyMeSubscribed": "تم الاشتراك",
    "notifyMeSuccess": "سيتم إشعارك عند توفر المنتج مجدداً",
    "notifyMeFailed": "فشل الاشتراك في إشعار توفر المنتج",
    "addToCart": "أضف للسلة",
    "item": "العنصر",
    "quantity": "الكمية",
    "total": "المجموع",
    "remove": "إزالة",
    "selectUnit": "اختر الوحدة",
    "unitRequired": "الرجاء اختيار وحدة",
    "inCart": "في السلة",
    "orderSummary": "ملخص الطلب",
    "itemsCount": "عدد العناصر",
    "createOrder": "إنشاء الطلب",
    "orderCreatedSuccessfully": "تم إنشاء الطلب بنجاح",
    "checkoutSuccessTitle": "تم إنشاء الطلب رقم <orderId>{{orderId}}</orderId> بنجاح!",
    "checkoutSuccessTitleNoId": "تم إنشاء الطلب بنجاح!",
    "checkoutSuccessSubtitle": "هل يريد العميل إنشاء طلب آخر؟",
    "anotherOrder": "طلب آخر",
    "newOrder": "طلب جديد",
    "orderCreationFailed": "فشل في إنشاء الطلب",
    "buy4Get2Offer": "عرض اشتر 4 واحصل على 2",
    "currency": "جنيه",
    "pieces": "قطعة",
    "specialOffer": "عرض خاص",
    "specialOfferDescription": "هذا المنتج متوفر حالياً في عرض خاص!",
    "productId": "رقم المنتج",
    "free": "مجاني",
    "comment": "تعليق",
    "addComment": "أضف تعليقاً...",
    "totalItems": "إجمالي العناصر",
    "clearAll": "مسح الكل",
    "cartCleared": "تم مسح السلة بنجاح",
    "errorClearingCart": "فشل في مسح السلة",
    "subTotal": "المجموع الفرعي",
    "deliveryFees": "رسوم التوصيل",
    "deliveryFeePending": "اختر وقت التوصيل",
    "deliveryFeeResolving": "جاري الحساب…",
    "deliveryFeeNotResolved": "يرجى اختيار وقت التوصيل لحساب رسوم التوصيل",
    "discount": "خصم",
    "totalAttributes": "إجمالي الخصائص",
    "totalExtras": "إجمالي الإضافات",
    "attributes": "الخصائص",
    "unit": "الوحدة",
    "summary": "ملخص",
    "saveAndAddMore": "حفظ وإضافة المزيد",
    "items": "العناصر",
    "proceedToPay": "المتابعة للدفع",
    "backToOrder": "← العودة إلى الطلب",
    "buy4Get2OfferApplied": "تم تطبيق عرض اشتر 4 واحصل على 2",
    "selectCustomerFirst": "لم يتم اختيار عميل لإنشاء الطلب",
    "staleOrderTitle": "انتبه أيها الوكيل!",
    "staleOrderMessage": "لدى {{name}} طلب تم إنشاؤه اليوم.",
    "selectCustomerToViewProducts": "يرجى اختيار عميل لعرض المنتجات وبدء إنشاء الطلب",
    "selectAddressFirst": "يرجى اختيار العنوان",
    "selectAddressToViewProducts": "يرجى اختيار عنوان لعرض المنتجات للتوصيل",
    "selectStoreFirst": "يرجى اختيار المتجر",
    "selectStoreToViewProducts": "يرجى اختيار متجر لعرض المنتجات",
    "loadingProducts": "جاري تحميل المنتجات...",
    "loadingProductsDescription": "جاري تحميل المنتجات وتطبيق الفلاتر، يرجى الانتظار...",
    "stockLimitReached": "تم الوصول لحد المخزون المتاح",
    "quantityInvalid": "أدخل كمية صحيحة",
    "quantityBelowMinimum": "يجب ألا تقل الكمية عن {{count}} (الحد الأدنى المحدد)",
    "offerQuantityAdjusted": "تم تعديل كمية العرض إلى {{quantity}}",
    "offerQuantityEditInModal": "هذا المنتج مطبق عليه عرض. يرجى فتح المنتج لتعديل الكمية.",
    "qtyLabel": "الكمية",
    "cartItemOutOfStock": "غير متوفر",
    "cartItemExceedsStock": "الكمية تتجاوز المخزون المتاح ({{stock}})",
    "insufficientStock": "المخزون غير كافٍ لهذا المنتج",
    "emptyCart": "لا توجد عناصر في السلة",
    "emptyCartDescription": "أضف منتجات إلى العربة لرؤيتها هنا",
    "loadingCart": "جاري تحميل العربة...",
    "loadingCartDescription": "جاري تحميل عناصر العربة، يرجى الانتظار...",
    "searchByProductName": "البحث باسم المنتج",
    "allCategories": "جميع الفئات",
    "offers": "العروض",
    "noImage": "لا توجد صورة",
    "offer": "عرض",
    "noProductsFound": "لم يتم العثور على منتجات",
    "noProductsAvailable": "لا توجد منتجات متاحة",
    "tryDifferentFilter": "جرب تعديل المرشحات أو شروط البحث",
    "originalPrice": "السعر الأصلي",
    "editCustomer": "تعديل العميل",
    "updateChanges": "تحديث التغييرات",
    "cancel": "إلغاء",
    "name": "الاسم",
    "gender": "النوع",
    "nameRequired": "يرجى إدخال اسم العميل",
    "genderRequired": "يرجى اختيار النوع",
    "enterName": "أدخل اسم العميل",
    "selectGender": "اختر النوع",
    "male": "ذكر",
    "female": "أنثى",
    "phoneInvalid": "يرجى إدخال رقم هاتف صحيح",
    "customerUpdatedSuccessfully": "تم تحديث العميل بنجاح",
    "customerUpdateFailed": "فشل في تحديث العميل",
    "selectAddress": "اختر العنوان",
    "addNewCustomer": "إضافة عميل جديد",
    "addCustomer": "إضافة العميل",
    "customerInformation": "معلومات العميل",
    "writeCustomerName": "اكتب اسم العميل",
    "chooseGender": "اختر النوع",
    "writePhoneNumber": "اكتب رقم الهاتف",
    "additionalPhone": "هاتف إضافي",
    "area": "المنطقة",
    "region": "الحي",
    "areaRequired": "يرجى اختيار المنطقة",
    "regionRequired": "يرجى اختيار الحي",
    "chooseArea": "اختر المنطقة",
    "chooseRegion": "اختر الحي",
    "downtown": "وسط المدينة",
    "suburbs": "الضواحي",
    "industrial": "الصناعي",
    "north": "الشمال",
    "south": "الجنوب",
    "east": "الشرق",
    "west": "الغرب",
    "selectPointOnMap": "اختر نقطة على الخريطة",
    "buildingNumber": "رقم المبنى",
    "street": "الشارع",
    "floor": "الطابق",
    "apartmentNumber": "رقم الشقة",
    "buildingNumberRequired": "يرجى إدخال رقم المبنى",
    "streetRequired": "يرجى إدخال اسم الشارع",
    "writeBuildingNumber": "اكتب رقم المبنى",
    "writeStreetName": "اكتب اسم الشارع",
    "writeFloorNumber": "اكتب رقم الطابق",
    "writeApartmentNumber": "اكتب رقم الشقة",
    "landmark": "معلم",
    "writeLandmark": "اكتب المعلم",
    "notifications": "الإشعارات",
    "addNewAddress": "إضافة عنوان جديد",
    "addAddress": "إضافة عنوان",
    "editAddress": "تعديل العنوان",
    "updateAddress": "تحديث العنوان",
    "addressName": "اسم العنوان",
    "addressNameRequired": "يرجى إدخال اسم العنوان",
    "writeAddressName": "اكتب اسم العنوان",
    "location": "الموقع",
    "default": "افتراضي",
    "selectDefault": "اختر الافتراضي",
    "yes": "نعم",
    "no": "لا",
    "map": "الخريطة",
    "searchPlaceholder": "ابحث عن موقع...",
    "noResultsFound": "لم يتم العثور على نتائج",
    "selectStore": "اختر المتجر",
    "storeSelected": "تم اختيار المتجر بنجاح",
    "pleaseCompleteAllFields": "يرجى إكمال جميع الحقول المطلوبة",
    "formValidatedSuccessfully": "تم التحقق من النموذج بنجاح",
    "formValidationFailed": "فشل في التحقق من النموذج",
    "formValidationErrors": "أخطاء التحقق من النموذج",
    "formReady": "النموذج جاهز",
    "allRequiredFieldsCompleted": "تم إكمال جميع الحقول المطلوبة",
    "validateForm": "التحقق من النموذج",
    "customerLoadedSuccessfully": "تم تحميل بيانات العميل بنجاح",
    "customerLoadFallback": "استخدام بيانات العميل المحلية",
    "customerLoadError": "فشل في تحميل بيانات العميل من الخادم",
    "numberOfProductInBranches": "عدد المنتجات في الفروع",
    "allStock": "إجمالي المخزون",
    "productStockInformation": "معلومات مخزون المنتج في كل مخزن",
    "info": "المعلومات",
    "ordersNo": "عدد الطلبات",
    "lastOrderDate": "تاريخ آخر طلب",
    "lastOrderStatus": "حالة آخر طلب",
    "totalOrdersAmounts": "إجمالي مبالغ الطلبات",
    "loadingOrdersInfo": "جاري تحميل معلومات الطلبات...",
    "ordersHistory": "سجل الطلبات",
    "loading": "جاري التحميل...",
    "noDataAvailable": "لا توجد بيانات متاحة",
    "mostRequestedProducts": "المنتجات الأكثر طلباً",
    "notAvailableProducts": "المنتجات غير المتاحة",
    "lastComplains": "الشكاوى",
    "lastInquiries": "الاستفسارات",
    "lastOrders": "آخر 5 طلبات",
    "complain": "الشكوى",
    "response": "الرد",
    "inquiry": "الاستفسار",
    "description": "الوصف",
    "subject": "الموضوع",
    "complainType": "نوع الشكوى",
    "status": "الحالة",
    "createdAt": "تاريخ الإنشاء",
    "activityType": "نوع النشاط",
    "details": "التفاصيل",
    "orderId": "رقم الطلب",
    "orderCreatedAt": "تاريخ الإنشاء",
    "orderStatus": "حالة الطلب",
    "storeName": "المتجر",
    "action": "الإجراء",
    "view": "عرض",
    "close": "إغلاق",
    "errorLoadingCustomerInfo": "فشل في تحميل معلومات العميل",
    "buyThisProduct": "اشتري هذا المنتج",
    "buy": "اشتري",
    "get": "احصل على",
    "at": "بخصم",
    "off": "",
    "fromGroupOfOtherProducts": "من مجموعة المنتجات الأخرى",
    "loseOffer": "تجاهل العرض",
    "addProductWithoutOffer": "إضافة المنتج للسلة بدون عرض",
    "productUpdatedSuccessfully": "تم تحديث المنتج بنجاح",
    "failedToRemoveOfferFromCart": "فشل في إزالة العرض من السلة",
    "productsRelatedToOffer": "المنتجات المتعلقة بالعرض",
    "chooseOneProductFromThese": "اختر منتجاً واحداً من هذه المنتجات لتطبيق العرض",
    "groupOffer": "عرض المجموعة",
    "selectFromMainAndRelated": "اختر المنتجات من المجموعة الرئيسية والمنتجات المرتبطة",
    "mainProducts": "المنتجات الرئيسية",
    "selectMainProductsInstruction": "اختر المنتجات الرئيسية",
    "relatedProductsFree": "المنتجات المرتبطة (مجانية)",
    "selectRelatedProductsInstruction": "اختر المنتجات المجانية",
    "buyMinProducts": "اشتري {{count}} منتج",
    "getFreeProducts": "احصل على {{count}} منتج مجاناً",
    "getDiscountProducts": "احصل على {{count}} منتج بخصم {{discount}}%",
    "selectMainFirst": "اختر {{count}} منتج من المنتجات الرئيسية أولاً",
    "mustChooseToGetOffer": "يجب عليك اختيار {{count}} منتج من أعلاه للحصول على العرض",
    "chooseProductsUpToQuantity": "اختر منتجات بإجمالي كمية {{current}}/{{max}} (يمكنك توزيعها على عدة منتجات)",
    "lowestPriceDiscount": "يطبق على أقل سعر",
    "units": "وحدات",
    "relatedProductsDiscount": "المنتجات المرتبطة (خصم {{discount}}%)",
    "addOffer": "إضافة العرض",
    "updateOffer": "تحديث العرض",
    "productAddedToCart": "تم إضافة المنتج إلى السلة بنجاح",
    "freeTextItemAdded": "تم إضافة المنتج النصي الحر إلى السلة بنجاح",
    "freeTextItemAddFailed": "فشل في إضافة المنتج النصي الحر إلى السلة",
    "freeTextItemUpdated": "تم تحديث المنتج النصي الحر بنجاح",
    "freeTextItemUpdateFailed": "فشل في تحديث المنتج النصي الحر",
    "freeText": {
      "title": "إضافة منتج نصي حر جديد",
      "editTitle": "تعديل المنتج النصي الحر",
      "productName": "اسم المنتج",
      "productNameRequired": "يرجى إدخال اسم المنتج",
      "productNamePlaceholder": "اكتب اسم المنتج",
      "price": "السعر",
      "priceRequired": "يرجى إدخال السعر",
      "priceInvalid": "يرجى إدخال سعر صحيح",
      "pricePlaceholder": "اكتب سعر المنتج",
      "measureUnit": "وحدة القياس",
      "measureUnitRequired": "يرجى اختيار وحدة القياس",
      "measureUnitQuantity": "الكمية",
      "measureUnitWeight": "الوزن",
      "gram": "جرام",
      "gramHint": "1 كجم = 1000 جرام",
      "gramRequired": "يرجى إدخال الوزن بالجرام",
      "gramInvalid": "يرجى إدخال رقم صحيح",
      "gramPlaceholder": "أدخل الجرام",
      "menuQuantity": "كمية القائمة",
      "menuQuantityRequired": "يرجى إدخال كمية القائمة",
      "menuQuantityInvalid": "يرجى إدخال كمية صحيحة",
      "menuQuantityPlaceholder": "اكتب كمية القائمة",
      "note": "ملاحظة",
      "notePlaceholder": "اكتب ملاحظة",
      "close": "إغلاق",
      "addItem": "إضافة منتج",
      "saveItem": "حفظ"
    },
    "offerAddedToCart": "تم إضافة العرض إلى السلة بنجاح",
    "offerUpdatedInCart": "تم تحديث العرض في السلة بنجاح",
    "errorAddingToCart": "فشل في إضافة المنتج إلى السلة",
    "errorAddingOffer": "فشل في إضافة العرض إلى السلة",
    "quantityMismatch": "يجب أن تتطابق كمية المنتجات المرتبطة مع كمية المنتج الأساسي",
    "groupOfferMinCountError": "يرجى اختيار {{count}} منتج على الأقل للحصول على هذا العرض",
    "minCountRequired": "يجب عليك شراء {{count}} منتج على الأقل للحصول على هذا العرض",
    "relatedQuantityMismatch": "يرجى اختيار {{count}} منتج مرتبط لهذا العرض",
    "buyMinToGetOffer": "اشتري {{min}} على الأقل لتحصل على {{get}} مجاناً",
    "productUpdatedInCart": "تم تحديث المنتج في السلة بنجاح",
    "commentUpdatedSuccessfully": "تم تحديث التعليق بنجاح!",
    "commentUpdateFailed": "فشل في تحديث التعليق. يرجى المحاولة مرة أخرى.",
    "addressUpdatedSuccessfully": "تم تحديث العنوان بنجاح!",
    "addressCreatedSuccessfully": "تم إنشاء العنوان بنجاح!",
    "addressUpdateFailed": "فشل في تحديث العنوان",
    "addressCreateFailed": "فشل في إنشاء العنوان",
    "addressSaveFailed": "فشل في حفظ العنوان. يرجى المحاولة مرة أخرى.",
    "customerCreatedSuccessfully": "تم إنشاء العميل بنجاح!",
    "customerCreateFailed": "فشل في إنشاء العميل",
    "customerSelectFailed": "فشل في اختيار العميل الذي تم إنشاؤه حديثاً. يرجى محاولة اختياره يدوياً.",
    "networkError": "خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
    "unexpectedError": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
    "missingRequiredFields": "يرجى اختيار العميل والمتجر",
    "companyIdRequired": "معرف الشركة مطلوب",
    "offerIdRequired": "معرف العرض مطلوب",
    "cartEmpty": "السلة فارغة",
    "fillRequiredFields": "يرجى ملء جميع الحقول المطلوبة",
    "fieldRequired": "يرجى ملء جميع الحقول المطلوبة",
    "mainQuantityMustBeMultiple": "يجب أن تكون كمية المنتجات الرئيسية من مضاعفات {{count}} (مثال: {{count}}، {{double}}، {{triple}}، إلخ)"
  },
  "cancelOrder": {
    "title": "سبب إيقاف الطلب",
    "customerName": "اسم العميل",
    "customerPhone": "هاتف العميل",
    "reasonToCancel": "سبب الإيقاف",
    "holdOrder": "إيقاف الطلب",
    "comment": "تعليق",
    "selectReason": "اختر السبب",
    "customerNamePlaceholder": "اسم العميل",
    "customerPhonePlaceholder": "هاتف العميل",
    "commentPlaceholder": "أدخل تعليقك هنا...",
    "reasonRequired": "الرجاء اختيار سبب",
    "missingRequiredFields": "معرف العميل أو المتجر مفقود",
    "successMessage": "تم إلغاء الطلب بنجاح",
    "errorMessage": "فشل في إلغاء الطلب",
    "noReasonsFound": "لا توجد أسباب متاحة"
  },
  "aiDistribution": {
    "AIDistribution": " توزيع الذكاء الاصطناعي",
    "priority1": "الأولوية #1",
    "priority2": "الأولوية #2",
    "priority3": "الأولوية #3",
    "priority4": "الأولوية #4",
    "priority5": "الأولوية #5",
    "vipCustomer": "عميل VIP",
    "nearestLocation": "أقرب موقع",
    "orderTotalCash": "إجمالي نقدي للطلب",
    "maxOrderCount": "الحد الأقصى لعدد الطلبات",
    "oldestOrder": "أقدم طلب"
  },
  "skillsList": {
    "tableTitle": "جميع المهارات",
    "addModalTitle": "إضافة مهارة",
    "editModalTitle": "تعديل مهارة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المهارات",
    "savedSuccessfully": "تم حفظ المهارة بنجاح",
    "createdSuccessfully": "تم إنشاء المهارة بنجاح",
    "failedSave": "فشل في حفظ المهارة",
    "writeNameEn": "اكتب الاسم بالإنجليزية...",
    "writeNameAr": "اكتب الاسم بالعربية...",
    "writePoints": "أدخل النقاط...",
    "columns": {
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "points": "النقاط",
      "status": "الحالة"
    }
  },
  "serviceTypesList": {
    "tableTitle": "جميع أنواع الخدمات",
    "addModalTitle": "إضافة نوع خدمة",
    "editModalTitle": "تعديل نوع خدمة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء أنواع الخدمات",
    "savedSuccessfully": "تم حفظ نوع الخدمة بنجاح",
    "createdSuccessfully": "تم إنشاء نوع الخدمة بنجاح",
    "failedSave": "فشل في حفظ نوع الخدمة",
    "writeNameEn": "اكتب الاسم بالإنجليزية...",
    "writeNameAr": "اكتب الاسم بالعربية...",
    "writeDescriptionEn": "اكتب الوصف بالإنجليزية...",
    "writeDescriptionAr": "اكتب الوصف بالعربية...",
    "writePrice": "أدخل السعر...",
    "columns": {
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "descriptionEn": "الوصف بالإنجليزية",
      "descriptionAr": "الوصف بالعربية",
      "price": "السعر",
      "status": "الحالة"
    }
  },
  "tripTypesList": {
    "tableTitle": "جميع أنواع الرحلات",
    "addModalTitle": "إضافة نوع رحلة",
    "editModalTitle": "تعديل نوع رحلة",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء أنواع الرحلات",
    "savedSuccessfully": "تم حفظ نوع الرحلة بنجاح",
    "createdSuccessfully": "تم إنشاء نوع الرحلة بنجاح",
    "failedSave": "فشل في حفظ نوع الرحلة",
    "writeNameEn": "اكتب الاسم بالإنجليزية...",
    "writeNameAr": "اكتب الاسم بالعربية...",
    "columns": {
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية"
    }
  },
  "shoppersList": {
    "tableTitle": "جميع المتسوقين",
    "addModalTitle": "إضافة متسوق",
    "editModalTitle": "تعديل متسوق",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء المتسوقين",
    "savedSuccessfully": "تم حفظ المتسوق بنجاح",
    "createdSuccessfully": "تم إنشاء المتسوق بنجاح",
    "failedSave": "فشل في حفظ المتسوق",
    "writeName": "أدخل الاسم...",
    "writeUserName": "أدخل اسم المستخدم...",
    "writePassword": "أدخل كلمة المرور...",
    "writeFCM": "أدخل رمز FCM...",
    "writeMaxOrder": "أدخل الحد الأقصى للطلبات...",
    "writeSalary": "أدخل الراتب...",
    "writeShipmentCommission": "أدخل عمولة الشحنة...",
    "writeRejectDeduct": "أدخل خصم الرفض...",
    "writeLatitude": "أدخل خط العرض...",
    "writeLongitude": "أدخل خط الطول...",
    "password": "كلمة المرور",
    "passwordRequired": "كلمة المرور مطلوبة",
    "passwordMinLength": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    "fcm": "رمز FCM",
    "latitude": "خط العرض",
    "longitude": "خط الطول",
    "skills": "المهارات",
    "stores": "المتاجر",
    "selectType": "اختر النوع...",
    "selectSkills": "اختر المهارات...",
    "selectStores": "اختر المتاجر...",
    "show": "عرض",
    "viewModalTitle": "عرض المتسوق",
    "columns": {
      "id": "المعرف",
      "name": "الاسم",
      "userName": "اسم المستخدم",
      "type": "النوع",
      "status": "الحالة",
      "active": "نشط",
      "online": "متصل",
      "maxOrder": "الحد الأقصى للطلبات",
      "salary": "الراتب",
      "shipmentCommission": "عمولة الشحنة",
      "rejectDeduct": "خصم الرفض"
    },
    "type": {
      "collector": "جامع",
      "driver": "سائق",
      "joker": "جوكر"
    }
  },
  "shopperOrderStatusList": {
    "tableTitle": "جميع حالات طلب المتسوق",
    "addModalTitle": "إضافة   ",
    "editModalTitle": "تعديل   ",
    "viewModalTitle": "عرض حالة طلب متسوق",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء حالات طلب المتسوق",
    "savedSuccessfully": "تم حفظ حالة طلب المتسوق بنجاح",
    "createdSuccessfully": "تم إنشاء حالة طلب المتسوق بنجاح",
    "failedSave": "فشل في حفظ حالة طلب المتسوق",
    "writeName": "أدخل الاسم...",
    "writeSort": "أدخل ترتيب الفرز...",
    "duplicateSort": "قيمة الترتيب هذه مستخدمة بالفعل من قبل حالة أخرى",
    "selectOrderStatus": "اختر حالة الطلب...",
    "show": "عرض",
    "confirmUnlink": "هل أنت متأكد أنك تريد إلغاء ربط هذه الحالات؟",
    "unlinkedSuccess": "تم إلغاء ربط الحالات بنجاح",
    "linkedSuccess": "تم ربط الحالات بنجاح",
    "alreadyLinked": "هذه الحالات مرتبطة بالفعل",
    "alreadyHasLink": "هذه الحالة مرتبطة بالفعل بحالة أخرى. يرجى إلغاء الربط أولاً.",
    "unlinkedStatuses": "الحالات غير المرتبطة",
    "selectSecondNode": "انقر على حالة أخرى لربطها",
    "linkedSteps": "الخطوات المرتبطة",
    "howToLink": "للربط: انقر على حالة واحدة، ثم انقر على أخرى. لإلغاء الربط: انقر على خط الاتصال. للتعديل: انقر على أيقونة التعديل على الحالة.",
    "removeFromGraph": "إزالة من الرسم البياني",
    "cannotRemoveWithConnections": "لا يمكن إزالة الحالة من الرسم البياني. يرجى إلغاء ربط جميع الاتصالات أولاً.",
    "removedFromGraph": "تم إزالة الحالة من الرسم البياني. يمكنك إضافتها مرة أخرى عن طريق سحبها من قائمة الحالات غير المرتبطة.",
    "columns": {
      "name": "الاسم",
      "orderStatus": "حالة الطلب",
      "sort": "الترتيب",
      "isCollector": "هو جامع",
      "forShopper": "للمتسوق",
      "startCollect": "بدء الجمع",
      "markCollectedItems": "تحديد العناصر المجمعة",
      "collectItemsBtn": "زر جمع العناصر",
      "paidForBtn": "زر الدفع",
      "startDeliveryBtn": "زر بدء التوصيل",
      "reportMissingBtn": "زر الإبلاغ عن المفقود",
      "delivedBtn": "زر التوصيل",
      "returnBtn": "زر الإرجاع",
      "notDeliveredBtn": "زر عدم التوصيل",
      "confirmedBtn": "زر التأكيد",
      "isDone": "تم",
      "isMissing": "مفقود",
      "isNotDelivered": "لم يتم التوصيل",
      "isReturned": "تم الإرجاع",
      "pushToOdoo": "إرسال إلى أودو"
    }
  },
  "dmsDashboard": {
    "title": "لوحة تحكم DMS",
    "dateRange": "نطاق التاريخ",
    "store": "المتجر",
    "allStores": "جميع المتاجر",
    "applyFilters": "تطبيق الفلاتر",
    "selectDateRange": "يرجى تحديد نطاق التاريخ",
    "fetchError": "فشل في جلب بيانات لوحة التحكم",
    "noData": "لا توجد بيانات متاحة. يرجى تطبيق الفلاتر.",
    "totalShopperOrders": "إجمالي طلبات المتسوق",
    "totalShopperSales": "إجمالي مبيعات المتسوق",
    "totalAreaOrders": "إجمالي طلبات المنطقة",
    "totalAreaSales": "إجمالي مبيعات المنطقة",
    "shopperOrders": "طلبات المتسوق",
    "shopperSales": "مبيعات المتسوق",
    "areaOrders": "طلبات المنطقة",
    "areaSales": "مبيعات المنطقة",
    "shopper": "المتسوق",
    "area": "المنطقة",
    "ordersCount": "عدد الطلبات",
    "totalSales": "إجمالي المبيعات"
  },
  "dmsReports": {
    "title": "تقارير DMS",
    "dashboardTab": "لوحة التحكم",
    "top10DriversTab": "أفضل 10 سائقين",
    "driverName": "اسم المندوب",
    "shopperId": "رقم المتسوق",
    "username": "اسم المستخدم",
    "status": "الحالة",
    "active": "نشط",
    "online": "متصل",
    "ordersCount": "عدد الطلبات",
    "noDataFound": "لم يتم العثور على سائقين للمعايير المحددة",
    "averageOrders": "متوسط عدد الطلبات",
    "avgDeliveryTimeDaily": "متوسط زمن التوصل اليومي",
    "avgDeliveryTimeWeekly": "متوسط زمن التوصل الاسبوعي",
    "avgDeliveryTimeMonthly": "متوسط زمن التوصل الشهري",
    "avgDeliveryTimeYearly": "متوسط زمن التوصل السنوي",
    "avgDeliveryTimePerOrder": "متوسط زمن التوصل بالطلب",
    "avgRejectedOrdersDaily": "متوسط الطلبات المرفوضه يوميا",
    "avgRejectedOrdersWeekly": "متوسط الطلبات المرفوضه اسبوعيا",
    "avgRejectedOrdersMonthly": "متوسط الطلبات المرفوضه شهريا",
    "avgRejectedOrdersYearly": "متوسط الطلبات المرفوضه سنويا",
    "avgDistance": "متوسط المسافة المقطوعة",
    "avgIncentiveDaily": "متوسط الحافز اليومي",
    "avgIncentiveWeekly": "متوسط الحافز الاسبوعي",
    "avgIncentiveMonthly": "متوسط الحافز الشهري",
    "avgDiscountDaily": "متوسط الخصم اليومي",
    "avgDiscountWeekly": "متوسط الخصم الاسبوعي",
    "avgDiscountMonthly": "متوسط الخصم الشهري",
    "ratingDaily": "التقييم اليومي",
    "ratingWeekly": "التقييم الاسبوعي",
    "ratingMonthly": "التقييم الشهري",
    "avgComplaints": "متوسط عدد الشكاوى"
  },
  "prediction": {
    "title": "توقع",
    "from": "من",
    "to": "إلى",
    "search": "بحث",
    "perOrder": "لكل طلب",
    "perAgent": "لكل مندوب",
    "perCollector": "لكل محصل",
    "perDriver": "لكل سائق",
    "predictNextMonth": "توقع الشهر القادم",
    "totalOrders": "إجمالي الطلبات",
    "lastYear": "العام الماضي",
    "totalAgent": "إجمالي المندوبين",
    "drivers": "السائقون",
    "order": "طلب",
    "agents": "المندوبون",
    "collector": "المحصل",
    "store": "المتجر",
    "allStores": "جميع المتاجر",
    "noData": "لا توجد بيانات. اختر نطاقاً زمنياً ثم اضغط بحث.",
    "growthRate": "معدل النمو",
    "growthRateTrend": "اتجاه معدل النمو",
    "avgOrdersPerMonth": "متوسط الطلبات / الشهر",
    "cancellationRate": "معدل الإلغاء",
    "cancellationRateTrend": "اتجاه معدل الإلغاء",
    "avgDeliveryTime": "متوسط وقت التوصيل",
    "avgDeliveryTimeTrend": "اتجاه متوسط وقت التوصيل",
    "totalRevenue": "إجمالي الإيرادات",
    "min": "دقيقة",
    "minUnit": "د"
  },
  "purchasing": {
    "predict": {
      "title": "توقع شراء المنتجات",
      "subtitle": "في الصفحة أدناه ستظهر المنتجات التي ستنفد قريبًا",
      "selectCustomer": "اختر العميل",
      "selectCustomerPlaceholder": "اختر العميل",
      "noCustomerSelected": "اختر عميلًا لعرض المنتجات المتوقعة.",
      "submitRequest": "إنشاء طلب شراء",
      "submitSuccess": "تم إنشاء طلب الشراء بنجاح",
      "submitError": "فشل في إنشاء طلب الشراء",
      "noProductsSelected": "قم بتفعيل ‘عمل طلب’ لمنتج واحد على الأقل.",
      "updateNeededStockError": "فشل تحديث الكمية المطلوبة",
      "columns": {
        "index": "#",
        "productName": "اسم المنتج",
        "sku": "SKU",
        "currentStock": "المخزون الحالي",
        "price": "السعر",
        "count": "الكمية",
        "makeRequest": "عمل طلب"
      }
    },
    "requests": {
      "title": "طلبات الشراء",
      "columns": {
        "index": "#",
        "createdAt": "تاريخ الإنشاء",
        "company": "الشركة",
        "status": "الحالة",
        "view": "عرض"
      },
      "viewBtn": "عرض",
      "noData": "لا توجد طلبات شراء بعد.",
      "detail": {
        "title": "تفاصيل الطلب",
        "summary": "ملخص الطلب",
        "products": "المنتجات",
        "productName": "اسم المنتج",
        "neededStock": "الكمية المطلوبة",
        "complete": "إكمال",
        "cancel": "إلغاء",
        "completeConfirm": "هل تريد تعليم هذا الطلب كمكتمل؟",
        "cancelConfirm": "هل تريد إلغاء هذا الطلب؟",
        "completeSuccess": "تم إكمال الطلب",
        "cancelSuccess": "تم إلغاء الطلب",
        "actionError": "فشل تنفيذ العملية. حاول مرة أخرى."
      }
    },
    "status": {
      "pending": "قيد الانتظار",
      "approved": "موافق عليه",
      "rejected": "مرفوض",
      "completed": "مكتمل",
      "cancelled": "ملغي",
      "unknown": "غير معروف"
    }
  },
  "agentKpi": {
    "title": "مؤشرات أداء المندوب",
    "from": "من",
    "to": "إلى",
    "search": "بحث",
    "fetchError": "فشل في جلب بيانات مؤشرات أداء المندوب",
    "noData": "لا توجد بيانات متاحة. يرجى تطبيق الفلاتر.",
    "noDataFound": "لم يتم العثور على مندوبين للمعايير المحددة",
    "agentName": "اسم المندوب",
    "averageOrders": "متوسط عدد الطلبات",
    "avgDeliveryTimeDaily": "متوسط زمن التوصيل اليومي",
    "avgDeliveryTimeWeekly": "متوسط زمن التوصيل الأسبوعي",
    "avgDeliveryTimeMonthly": "متوسط زمن التوصيل الشهري",
    "avgDeliveryTimeYearly": "متوسط زمن التوصيل السنوي",
    "avgDeliveryTimePerOrder": "متوسط زمن التوصيل لكل طلب",
    "avgRejectedOrdersDaily": "متوسط الطلبات المرفوضة يومياً",
    "avgRejectedOrdersWeekly": "متوسط الطلبات المرفوضة أسبوعياً",
    "avgRejectedOrdersMonthly": "متوسط الطلبات المرفوضة شهرياً",
    "avgRejectedOrdersYearly": "متوسط الطلبات المرفوضة سنوياً",
    "avgDistance": "متوسط المسافة المقطوعة",
    "avgIncentiveDaily": "متوسط الحافز اليومي",
    "avgIncentiveWeekly": "متوسط الحافز الأسبوعي",
    "avgIncentiveMonthly": "متوسط الحافز الشهري",
    "avgDiscountDaily": "متوسط الخصم اليومي",
    "avgDiscountWeekly": "متوسط الخصم الأسبوعي",
    "avgDiscountMonthly": "متوسط الخصم الشهري",
    "ratingDaily": "التقييم اليومي",
    "ratingWeekly": "التقييم الأسبوعي",
    "ratingMonthly": "التقييم الشهري",
    "avgComplaints": "متوسط عدد الشكاوى"
  },
  "dmsTop10Shoppers": {
    "title": "أفضل 10 متسوقين",
    "dateRange": "نطاق التاريخ",
    "store": "المتجر",
    "allStores": "جميع المتاجر",
    "applyFilters": "تطبيق الفلاتر",
    "selectDateRange": "يرجى اختيار نطاق تاريخ",
    "fetchError": "فشل في جلب بيانات أفضل 10 متسوقين",
    "noData": "لا توجد بيانات متاحة. يرجى تطبيق الفلاتر.",
    "noDataFound": "لم يتم العثور على متسوقين للمعايير المحددة",
    "shopperId": "رقم المتسوق",
    "shopperName": "اسم المتسوق",
    "username": "اسم المستخدم",
    "status": "الحالة",
    "active": "نشط",
    "online": "متصل",
    "ordersCount": "عدد الطلبات",
    "from": "من",
    "to": "إلى",
    "viewShopper": "عرض تفاصيل المتسوق"
  },
  "sallaOrders": {
    "title": "طلبات سلة",
    "orders": "الطلبات",
    "purchasedOrders": "الطلبات المشتراة",
    "orderNumber": "رقم الطلب",
    "printTitle": "أمر شراء",
    "purchaseOrder": "أمر شراء",
    "supplierName": "الاسم",
    "supplierPhone": "الهاتف",
    "supplierAddress": "العنوان",
    "supplierWhatsapp": "واتساب",
    "paymentMethod": "طريقة الدفع",
    "selectMethod": "اختر الطريقة",
    "selectStatus": "اختر الحالة",
    "createdFrom": "تم الإنشاء من",
    "createdTo": "تم الإنشاء إلى",
    "selectDate": "شهر / يوم / سنة",
    "pending": "قيد الانتظار",
    "processing": "قيد المعالجة",
    "shipped": "تم الشحن",
    "delivered": "تم التسليم",
    "canceled": "ملغي",
    "status": "الحالة",
    "total": "الإجمالي",
    "createdAt": "تاريخ الإنشاء",
    "orderId": "رقم الطلب",
    "supplier": "المورد",
    "quantity": "الكمية",
    "subTotal": "المجموع الفرعي",
    "totalDiscount": "إجمالي الخصم",
    "purchase": "شراء",
    "purchased": "تم الشراء",
    "purchaseSuccess": "تم شراء الطلب بنجاح",
    "purchaseError": "فشل في شراء الطلب",
    "bulkPurchase": "شراء المحدد",
    "bulkPurchaseSuccess": "تم شراء الطلبات بنجاح",
    "bulkPurchaseError": "فشل في شراء الطلبات",
    "selectOrders": "يرجى اختيار الطلبات للشراء",
    "confirmPurchase": "هل أنت متأكد من شراء هذا الطلب؟",
    "confirmBulkPurchase": "هل أنت متأكد من شراء الطلبات المحددة؟",
    "orderDetails": "تفاصيل الطلب",
    "fetchError": "فشل في جلب تفاصيل الطلب"
  },
  "suppliers": {
    "tableTitle": "جميع الموردين",
    "modalTitle": "إضافة مورد",
    "editModalTitle": "تعديل مورد",
    "name": "الاسم",
    "nameAr": "الاسم (عربي)",
    "nameEn": "الاسم (إنجليزي)",
    "nameArPlaceholder": "أدخل الاسم بالعربية",
    "nameEnPlaceholder": "أدخل الاسم بالإنجليزية",
    "addressAr": "العنوان (عربي)",
    "addressEn": "العنوان (إنجليزي)",
    "addressArPlaceholder": "أدخل العنوان بالعربية",
    "addressEnPlaceholder": "أدخل العنوان بالإنجليزية",
    "phone": "الهاتف",
    "phonePlaceholder": "أدخل رقم الهاتف",
    "whatsapp": "واتساب",
    "whatsappPlaceholder": "أدخل رقم الواتساب",
    "email": "البريد الإلكتروني",
    "emailPlaceholder": "أدخل البريد الإلكتروني",
    "logo": "الشعار",
    "uploadLogo": "رفع الشعار",
    "status": "الحالة",
    "required": "هذا الحقل مطلوب",
    "invalidEmail": "يرجى إدخال بريد إلكتروني صحيح",
    "uploadImageOnly": "يمكنك رفع ملفات الصور فقط!",
    "imageSizeLimit": "يجب أن تكون الصورة أصغر من 2 ميجابايت!",
    "createSuccess": "تم إنشاء المورد بنجاح",
    "updateSuccess": "تم تحديث المورد بنجاح",
    "saveError": "فشل في حفظ المورد. يرجى المحاولة مرة أخرى.",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء موردين"
  },
  "custody": {
    "title": "حراسة المتسوق",
    "subtitle": "إدارة ومراقبة تدفقات الأموال الائتمانية عبر المنظمة.",
    "giveMoney": "إعطاء مال",
    "columns": {
      "date": "التاريخ",
      "total": "الإجمالي",
      "byWho": "بواسطة",
      "notes": "ملاحظات"
    },
    "tabs": {
      "all": "الكل",
      "given": "ممنوح",
      "received": "مستلم"
    },
    "stats": {
      "totalReceived": "إجمالي المستلم",
      "totalGiven": "إجمالي الممنوح",
      "remainingBalance": "الرصيد المتبقي",
      "liquidity": "السيولة: عالية"
    },
    "orders": {
      "title": "ملخص الطلبات",
      "totalOrders": "إجمالي الطلبات",
      "cashOrders": "طلبات نقدية",
      "codOrders": "طلبات الدفع عند الاستلام",
      "returnedOrders": "الطلبات المرتجعة",
      "totalOrdersAmount": "إجمالي مبلغ الطلبات",
      "cashOrdersAmount": "مبلغ الطلبات النقدية"
    },
    "modal": {
      "title": "إعطاء مال",
      "amount": "المبلغ",
      "amountPlaceholder": "أدخل المبلغ...",
      "amountMin": "يجب أن يكون المبلغ أكبر من 0",
      "type": "النوع",
      "notes": "ملاحظات",
      "notesPlaceholder": "ملاحظات اختيارية...",
      "successMessage": "تم تسجيل المعاملة بنجاح",
      "errorMessage": "فشل في معالجة المعاملة"
    }
  },
  "notifications": {
    "slaBreach": {
      "title": "تجاوزت التذكرة مدة الإغلاق",
      "body": "{{type}} #{{id}}{{priority}} لا تزال مفتوحة بعد انتهاء مدة الإغلاق"
    },
    "slaWarning": {
      "title": "اقتراب موعد الإغلاق",
      "body": "{{type}} #{{id}}{{priority}} يجب إغلاقها قريبًا"
    },
    "slaAutoClosed": {
      "title": "تم إغلاق التذكرة تلقائيًا",
      "body": "{{type}} #{{id}}{{priority}} وصلت إلى موعد الإغلاق وتم إغلاقها تلقائيًا"
    },
    "unknown": "غير معروف",
    "customer": "العميل",
    "openTicket": "فتح التذكرة",
    "copyId": "نسخ الرقم",
    "activityType": {
      "activity": "نشاط",
      "inquiry": "استفسار",
      "complaint": "شكوى"
    },
    "newOrder": {
      "title": "طلب جديد",
      "body": "يوجد طلب جديد للفرع: #{{id}}"
    },
    "orderMissing": {
      "title": "طلب مفقود",
      "body": "الطلب #{{id}} مفقود"
    },
    "changeOrderPay": {
      "title": "تغيير دفع الطلب",
      "body": "تم تغيير الدفع للطلب: #{{id}}"
    },
    "cancelOrder": {
      "title": "إلغاء الطلب",
      "body": "تم إلغاء الطلب #{{id}}"
    },
    "returnOrder": {
      "title": "إرجاع الطلب",
      "body": "تم إرجاع الطلب #{{id}}"
    },
    "newActivity": {
      "title": "{{type}} جديد",
      "body": "تم إنشاء {{type}} #{{id}} بواسطة {{by}}",
      "bodyBeforeId": "تم إنشاء {{type}} ",
      "bodyAfterId": " بواسطة {{by}}"
    },
    "activityReply": {
      "title": "رد جديد",
      "body": "رد جديد على {{type}} #{{id}} بواسطة {{by}}",
      "bodyBeforeId": "رد جديد على {{type}} ",
      "bodyAfterId": " بواسطة {{by}}"
    },
    "statusChanged": {
      "title": "تغيير الحالة",
      "body": "تم تغيير حالة {{type}} #{{id}} بواسطة {{by}}",
      "bodyBeforeId": "{{type}} ",
      "bodyAfterId": " تم تغيير الحالة بواسطة {{by}}"
    },
    "center": {
      "title": "الإشعارات",
      "empty": "لا توجد إشعارات بعد",
      "markAllRead": "تحديد الكل كمقروء",
      "clearAll": "مسح الكل",
      "copyId": "نسخ الرقم {{id}}",
      "idCopied": "تم نسخ الرقم: {{id}}",
      "idCopyFailed": "فشل نسخ الرقم"
    },
    "import": {
      "file": "ملف",
      "entity": {
        "product": "المنتجات",
        "category": "الأقسام",
        "offer": "العروض",
        "attribute": "الخصائص",
        "extra": "الإضافات",
        "productUnit": "وحدات المنتجات",
        "productAttribute": "خصائص المنتجات",
        "productExtra": "إضافات المنتجات"
      },
      "completedTitle": "اكتمل استيراد {{entity}}",
      "completedBody": "{{file}}: تم استيراد {{rows}} صف في {{jobs}} دفعة",
      "partialTitle": "اكتمل استيراد {{entity}} مع أخطاء",
      "partialBody": "{{file}}: فشلت {{failed}} من {{jobs}} دفعة ({{rows}} صف)"
    }
  },
  "driverTracker": {
    "ready": "جاهز",
    "outForDelivery": "في الطريق",
    "blocked": "محظور",
    "break": "استراحة",
    "drivers": "السائقين",
    "noDrivers": "لم يتم العثور على سائقين",
    "orders": "الطلبات",
    "stores": "المتاجر",
    "noStores": "لم يتم العثور على متاجر",
    "lastUpdate": "آخر تحديث",
    "phone": "الهاتف",
    "status": "الحالة",
    "fetchError": "فشل في جلب بيانات التتبع",
    "showAll": "عرض كل المتاجر مع السائقين",
    "location": "الموقع"
  },
  "shippingDetails": {
    "success": "تم تحديث بيانات الشحن بنجاح",
    "error": "فشل في تحديث بيانات الشحن",
    "noMapLocation": "لا يوجد موقع متاح لهذا العنوان.",
    "viewOnMap": "عرض على الخريطة",
    "address": "العنوان",
    "selectAddress": "اختر عنوان التوصيل",
    "deliveryDateDetails": "تفاصيل موعد التوصيل",
    "deliveryDate": "تاريخ التوصيل",
    "deliveryTime": "وقت التوصيل",
    "timeSlot": "من {{from}} إلى {{to}} - السعر {{fees}} {{currency}}",
    "selectDeliveryTime": "اختر وقت التوصيل",
    "customerServiceComment": "تعليق خدمة العملاء",
    "branchComment": "تعليق الفرع",
    "enterComment": "أدخل التعليق",
    "enterBranchComment": "أدخل تعليق الفرع",
    "updateChanges": "تحديث التغييرات",
    "apartment": "شقة {{value}}",
    "street": "شارع {{value}}",
    "building": "عمارة {{value}}",
    "floor": "الدور {{value}}",
    "am": "ص",
    "pm": "م"
  },
  "home": {
    "welcome": "مرحباً",
    "orders": "الطلبات",
    "customers": "العملاء",
    "reports": "التقارير",
    "stores": "المتاجر"
  },
  "customerSegmentation": {
    "title": "قواعد الشرائح",
    "subtitle": "حدد الشروط المنطقية لكل شريحة.",
    "addNew": "إضافة شريحة جديدة",
    "generalSettings": "الإعدادات العامة",
    "segmentThreshold": "حد الشريحة (بالأيام)",
    "segmentThresholdHelp": "عدد الأيام المستخدم لحساب الشريحة",
    "saveGeneralSettings": "حفظ الإعدادات العامة",
    "segments": "الشرائح",
    "noSegments": "لا توجد شرائح. اضغط على 'إضافة شريحة جديدة' لإنشاء شريحة.",
    "segmentName": "اسم الشريحة",
    "segmentNamePlaceholder": "أدخل اسم الشريحة",
    "priority": "الأولوية",
    "priorityPlaceholder": "الأولوية",
    "colorTheme": "لون الشريحة",
    "active": "نشط",
    "conditionsLogic": "الشروط (المنطق: و)",
    "selectField": "اختر الحقل",
    "selectOperator": "اختر المعامل",
    "enterValue": "أدخل القيمة",
    "addCondition": "إضافة شرط",
    "maxConditions": "الحد الأقصى شرطان",
    "save": "حفظ",
    "delete": "حذف",
    "nameRequired": "الاسم مطلوب",
    "conditionRequired": "مطلوب شرط واحد على الأقل",
    "saveSuccess": "تم الحفظ بنجاح",
    "saveFailed": "فشل الحفظ",
    "deleteSuccess": "تم الحذف بنجاح",
    "deleteFailed": "فشل الحذف",
    "generalSettingsSaved": "تم حفظ الإعدادات العامة بنجاح",
    "generalSettingsFailed": "فشل حفظ الإعدادات العامة",
    "noViewPermission": "ليس لديك صلاحية لعرض شرائح العملاء",
    "noCreatePermission": "ليس لديك صلاحية لإنشاء شرائح",
    "noEditPermission": "ليس لديك صلاحية لتعديل الشرائح",
    "noDeletePermission": "ليس لديك صلاحية لحذف الشرائح",
    "fields": {
      "orders": "الطلبات",
      "AOV": "متوسط قيمة الطلب"
    },
    "operators": {
      "gt": "أكبر من",
      "lt": "أقل من",
      "eq": "يساوي",
      "gte": "أكبر من أو يساوي",
      "lte": "أقل من أو يساوي",
      "between": "بين"
    }
  },
  "pharmacistWorkspace": {
    "title": "مساحة الصيدلي",
    "queueTitle": "قائمة مراجعة الروشتات",
    "reviewTitle": "مراجعة الروشتة",
    "open": "فتح",
    "claim": "استلام",
    "claimed": "تم استلام الروشتة",
    "claimFailed": "فشل الاستلام",
    "decisionSaved": "تم حفظ القرار",
    "decisionFailed": "فشل حفظ القرار",
    "decision": "القرار",
    "approve": "موافقة",
    "reject": "رفض",
    "requestClarification": "طلب توضيح",
    "proposeAlternative": "اقتراح بديل",
    "rejectReason": "سبب الرفض",
    "note": "ملاحظة",
    "saveDecision": "حفظ القرار",
    "images": "صور الروشتة",
    "approvalImages": "صور موافقة التأمين",
    "lines": "أسطر OCR / الأدوية",
    "resolveLines": "تحديد منتجات الأسطر",
    "resolveHint": "نص OCR للمساعدة فقط. اختر منتج الكتالوج لكل سطر.",
    "resolveAllRequired": "يجب تحديد منتج لكل سطر قبل الموافقة",
    "ocrSupport": "OCR",
    "resolved": "تم التحديد",
    "unresolved": "غير محدد",
    "noLines": "لا توجد أسطر OCR بعد",
    "lineName": "الاسم",
    "lineQty": "الكمية",
    "lineNotes": "ملاحظات",
    "product": "المنتج",
    "selectProduct": "اختر منتجًا",
    "price": "السعر",
    "ocrLine": "سطر OCR",
    "selectOcrLine": "سطر OCR اختياري",
    "proposeAltsTitle": "المنتجات البديلة",
    "addAlt": "إضافة بديل",
    "altsRequired": "أضف بديلاً واحدًا على الأقل",
    "proposedAlternatives": "البدائل المقترحة",
    "originalName": "الأصلي",
    "altProduct": "المنتج",
    "customerDecision": "العميل",
    "pending": "قيد الانتظار",
    "type": "النوع",
    "insurance": "تأمين",
    "prescription": "روشتة",
    "insuranceCompany": "شركة التأمين",
    "events": "سجل المراجعة",
    "actor": "المستخدم",
    "comment": "تعليق",
    "filters": {
      "status": "الحالة",
      "store": "الفرع",
      "unclaimed": "غير مستلمة",
      "unclaimedOnly": "غير مستلمة فقط"
    },
    "columns": {
      "customer": "العميل",
      "phone": "الهاتف",
      "store": "الفرع",
      "status": "الحالة",
      "type": "النوع",
      "age": "العمر (دقيقة)",
      "claimedBy": "مستلمة بواسطة",
      "actions": "إجراءات"
    }
  },
  "refunds": {
    "title": "المرتجعات المالية",
    "tableTitle": "المرتجعات المالية",
    "requestRefund": "طلب استرداد",
    "refundableAmount": "المبلغ القابل للاسترداد",
    "refundedTotal": "تم استرداده",
    "pendingTotal": "قيد الانتظار",
    "fullRefund": "استرداد كامل",
    "partialRefund": "استرداد جزئي",
    "amountRange": "يجب أن يكون المبلغ بين 0.01 و {{max}}",
    "requestedAwaitingApproval": "تم طلب الاسترداد وفي انتظار الموافقة",
    "requestedApproved": "تم طلب الاسترداد والموافقة عليه",
    "requestFailed": "فشل طلب الاسترداد",
    "empty": "لا توجد عمليات استرداد",
    "searchPlaceholder": "رقم الطلب",
    "autoApproved": "تلقائي",
    "awaitingApproval": "في انتظار الموافقة",
    "toSettle": "قيد التسوية",
    "closedUnpaid": "فشل / مرفوض",
    "countLabel": "{{count}} عملية",
    "approve": "موافقة",
    "approveConfirm": "الموافقة على هذا الاسترداد؟",
    "approved": "تمت الموافقة على الاسترداد",
    "reject": "رفض",
    "rejectTitle": "رفض الاسترداد",
    "rejected": "تم رفض الاسترداد",
    "markProcessing": "قيد التنفيذ",
    "processingConfirm": "تحويل الاسترداد إلى قيد التنفيذ؟",
    "markedProcessing": "تم تحويل الاسترداد إلى قيد التنفيذ",
    "markSucceeded": "تم الاسترداد",
    "markedSucceeded": "تم تسجيل الاسترداد كناجح",
    "markFailed": "فشل الاسترداد",
    "markedFailed": "تم تسجيل الاسترداد كفاشل",
    "actionFailed": "فشل الإجراء",
    "fields": {
      "amount": "المبلغ",
      "mode": "طريقة الاسترداد",
      "status": "الحالة",
      "reason": "السبب",
      "order": "الطلب",
      "requestedBy": "طلب بواسطة",
      "approvedBy": "وافق / رفض بواسطة",
      "gatewayReference": "مرجع البوابة / الإيصال",
      "rejectionReason": "سبب الرفض",
      "failureReason": "سبب الفشل",
      "actions": "الإجراءات",
      "processedBy": "تمت المعالجة بواسطة",
      "paymentReference": "مرجع الدفع",
      "approvalRule": "قاعدة الموافقة"
    },
    "filters": {
      "from": "من تاريخ",
      "to": "إلى تاريخ"
    },
    "modes": {
      "gateway": "بوابة الدفع",
      "wallet": "المحفظة",
      "cash": "نقدي"
    },
    "statuses": {
      "requested": "مطلوب",
      "approved": "موافق عليه",
      "rejected": "مرفوض",
      "processing": "قيد التنفيذ",
      "succeeded": "ناجح",
      "failed": "فشل"
    },
    "details": "تفاصيل الاسترداد",
    "viewDetails": "عرض التفاصيل"
  },
  "refundApprovalRules": {
    "tableTitle": "قواعد موافقة الاسترداد",
    "create": "إضافة قاعدة موافقة",
    "edit": "تعديل قاعدة الموافقة",
    "saved": "تم حفظ قاعدة الموافقة",
    "saveFailed": "فشل حفظ قاعدة الموافقة",
    "noCreatePermission": "ليس لديك صلاحية إضافة قواعد الموافقة",
    "allModes": "كل الطرق",
    "modeHint": "عمليات الاسترداد بهذه الطريقة وضمن نطاق المبلغ تحتاج موافقة مستخدم آخر.",
    "maxBelowMin": "يجب أن يكون أكبر من أو يساوي مبلغ البداية",
    "fields": {
      "title": "العنوان",
      "minAmount": "من مبلغ",
      "maxAmount": "إلى مبلغ (فارغ = بلا حد)",
      "range": "نطاق المبلغ"
    }
  }
}
